export const dedicated_house_mom = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 400 400"
    width="35px"
    height="35px"
  >
    <path
      d="M227.2,235.5h-121c-3.4,0-6.3,2.9-6.3,6.3v64.6c0,14.6,11.9,26.5,26.5,26.5H207c14.6,0,26.5-11.9,26.5-26.5v-64.6
          C233.5,238.3,230.7,235.5,227.2,235.5z M207,320.2h-80.6c-7.7,0-13.9-6.2-13.9-13.9v-28.1h80.4c3.4,0,6.3-2.9,6.3-6.3
          s-2.9-6.3-6.3-6.3h-80.4V248h108.4v17.6h-6.7c-3.4,0-6.3,2.9-6.3,6.3s2.9,6.3,6.3,6.3h6.7v28.1C220.9,314,214.6,320.2,207,320.2z
           M245,80.2V12.7c0-1.7-0.7-3.3-1.8-4.5s-2.8-1.8-4.5-1.8h-33.3c-3.4,0-6.3,2.9-6.3,6.3v68.5h-64.7V12.7c0-3.4-2.9-6.3-6.3-6.3H94.7
          c-3.4,0-6.3,2.9-6.3,6.3v155.8c-3.1,12.8-14.7,21.9-27.9,21.9c-3.3,0-6.1,2.5-6.3,5.9L41,383.4c-0.3,3,1.8,5.8,4.7,6.6l6.8,1.8
          c37.3,9.8,75.7,14.6,114.2,14.6s76.9-5,114.2-14.6l6.8-1.8c2.9-0.8,5-3.5,4.7-6.6l-10.9-153.9l-12,7.5l10,142.3l-1.8,0.4
          c-36.2,9.5-73.6,14.3-111,14.3s-74.8-4.8-111-14.3l-1.8-0.5l12.5-176.5c16.7-2.4,30.8-15.1,34.5-32c0.1-0.4,0.2-0.9,0.2-1.3V19h20.7
          v68.5c0,3.4,2.9,6.3,6.3,6.3h77.4c3.4,0,6.3-2.9,6.3-6.3V19h20.6v71L245,80.2z"
    />
    <g>
      <g>
        <path
          d="M289.4,60.4c-40,0-72.6,32.6-72.6,72.6c0,25,12.7,47,31.9,60.1v46.2c0,1.8,0.9,3.5,2.4,4.5c1.5,1,3.4,1.1,5.1,0.4l33.2-15
          l33.2,15c0.7,0.3,1.4,0.5,2.2,0.5c1,0,2-0.3,2.9-0.9c1.5-1,2.4-2.7,2.4-4.5v-46.2C349.4,180,362,158,362,133
          C362,93,329.5,60.4,289.4,60.4z M319.5,231.1l-27.9-12.6c-0.7-0.3-1.4-0.5-2.2-0.5s-1.5,0.2-2.2,0.5l-27.9,12.6v-32
          c2.7,1.2,5.4,2.3,8.2,3.1c0.2,0.1,0.3,0.1,0.5,0.2c0.4,0.1,0.7,0.2,1.1,0.3c0.3,0.1,0.5,0.2,0.8,0.2c0.3,0.1,0.6,0.2,0.9,0.2
          c0.3,0.1,0.7,0.2,1,0.3c0.2,0.1,0.5,0.1,0.7,0.2c0.4,0.1,0.8,0.2,1.2,0.3c0.2,0,0.4,0.1,0.6,0.1c0.4,0.1,0.9,0.2,1.3,0.3
          c0.2,0,0.4,0.1,0.5,0.1c0.5,0.1,0.9,0.2,1.4,0.2c0.2,0,0.3,0.1,0.5,0.1c0.5,0.1,1,0.1,1.4,0.2c0.1,0,0.3,0,0.4,0.1
          c0.5,0.1,1,0.1,1.5,0.2c0.1,0,0.3,0,0.4,0.1c0.5,0.1,1,0.1,1.5,0.1c0.1,0,0.3,0,0.4,0c0.5,0,1,0.1,1.5,0.1c0.2,0,0.3,0,0.5,0
          c0.5,0,1,0,1.5,0.1c0.1,0,0.3,0,0.4,0c0.6,0,1.3,0,1.9,0c0.6,0,1.3,0,1.9,0c0.1,0,0.3,0,0.4,0c0.5,0,1,0,1.5-0.1
          c0.2,0,0.3,0,0.5,0c0.5,0,1-0.1,1.5-0.1c0.1,0,0.3,0,0.4,0c0.5,0,1-0.1,1.5-0.1c0.1,0,0.3,0,0.4-0.1c0.5-0.1,1-0.1,1.5-0.2
          c0.1,0,0.3,0,0.4-0.1c0.5-0.1,1-0.1,1.4-0.2c0.2,0,0.3-0.1,0.5-0.1c0.5-0.1,0.9-0.2,1.4-0.2c0.2,0,0.4-0.1,0.5-0.1
          c0.4-0.1,0.9-0.2,1.3-0.3c0.2,0,0.4-0.1,0.6-0.1c0.4-0.1,0.8-0.2,1.2-0.3c0.2-0.1,0.5-0.1,0.7-0.2c0.3-0.1,0.7-0.2,1-0.3
          c0.3-0.1,0.6-0.2,0.9-0.2c0.3-0.1,0.5-0.2,0.8-0.2c0.4-0.1,0.7-0.2,1.1-0.3c0.2,0,0.3-0.1,0.5-0.2c2.8-0.9,5.5-1.9,8.2-3.1
          L319.5,231.1L319.5,231.1z M309.7,191.6c-0.2,0.1-0.4,0.1-0.6,0.2c-0.3,0.1-0.6,0.2-1,0.3c-0.4,0.1-0.8,0.2-1.1,0.3
          c-0.3,0.1-0.5,0.2-0.8,0.2c-0.5,0.1-1,0.3-1.5,0.4c-0.2,0-0.4,0.1-0.6,0.1c-0.5,0.1-1,0.2-1.5,0.3c-0.1,0-0.3,0.1-0.4,0.1
          c-0.6,0.1-1.3,0.3-1.9,0.4c-0.1,0-0.1,0-0.2,0c-0.6,0.1-1.2,0.2-1.8,0.3c-0.1,0-0.3,0-0.4,0.1c-0.6,0.1-1.3,0.2-1.9,0.2
          c0,0,0,0-0.1,0c-0.7,0.1-1.3,0.1-2,0.2c-0.1,0-0.3,0-0.4,0c-0.5,0-1,0.1-1.6,0.1c-0.2,0-0.4,0-0.5,0c-0.7,0-1.3,0-2,0
          c-0.7,0-1.3,0-2,0c-0.2,0-0.4,0-0.5,0c-0.5,0-1,0-1.6-0.1c-0.1,0-0.3,0-0.4,0c-0.7,0-1.3-0.1-2-0.2c0,0,0,0-0.1,0
          c-0.6-0.1-1.3-0.1-1.9-0.2c-0.1,0-0.3,0-0.4-0.1c-0.6-0.1-1.2-0.2-1.8-0.3c-0.1,0-0.1,0-0.2,0c-0.7-0.1-1.3-0.2-1.9-0.4
          c-0.1,0-0.3-0.1-0.4-0.1c-0.5-0.1-1-0.2-1.5-0.3c-0.2,0-0.4-0.1-0.6-0.1c-0.5-0.1-1-0.3-1.5-0.4c-0.3-0.1-0.5-0.2-0.8-0.2
          c-0.4-0.1-0.8-0.2-1.1-0.3c-0.3-0.1-0.6-0.2-1-0.3c-0.2-0.1-0.4-0.1-0.6-0.2c-24.3-8.4-41.8-31.5-41.8-58.6c0-34.2,27.8-62,62-62
          s62,27.8,62,62C351.4,160.1,333.9,183.2,309.7,191.6z"
        />
      </g>
    </g>
    <path
      d="M321.4,118.7l-19.3-0.9l-6.8-18.1c-2-5.4-9.7-5.4-11.7,0l-6.8,18.1l-19.3,0.9c-5.8,0.3-8.2,7.6-3.6,11.2l15.1,12l-5.1,18.6
          c-1.5,5.6,4.7,10.1,9.5,6.9l16.1-10.6l16.1,10.6c4.8,3.2,11-1.3,9.5-6.9l-5.1-18.6l15.1-12C329.5,126.3,327.1,119,321.4,118.7
          L321.4,118.7z M303.2,136.1c-2,1.6-2.8,4.1-2.1,6.6l3.9,13.9l-12.1-8c0,0,0,0,0,0c-1-0.7-2.3-1-3.5-1c-1.2,0-2.4,0.3-3.5,1l-12.1,8
          l3.9-13.9c0.7-2.4-0.2-5-2.1-6.6l-11.3-9l14.5-0.6c2.5-0.1,4.7-1.7,5.6-4.1l5.1-13.6l5.1,13.6c0.9,2.4,3.1,3.9,5.6,4.1l14.5,0.6
          L303.2,136.1z"
    />
  </svg>
);

export const partial_ocean_view = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 400 400"
    width="35px"
    height="35px"
  >
    <g>
      <g>
        <path
          className="st2"
          d="M327.1,223.1c-15,0-29.6-5.3-40-14.6l-2.4-2.1l-2.4,2.1c-10.4,9.3-25,14.6-40,14.6
          c-18.3,0-35.4-7.7-45.7-20.6c-1.5-1.8-1.2-4.5,0.7-6c0.8-0.6,1.7-0.9,2.7-0.9c1.3,0,2.5,0.6,3.3,1.6c8.7,10.9,23.3,17.4,39,17.4
          c15.7,0,30.3-6.5,39-17.4c0,0,0,0,0,0l0,0c0.3-0.4,0.5-0.6,0.7-0.7c0.7-0.5,1.5-0.8,2.3-0.9c0.2,0,0.3,0,0.3,0c0.1,0,0.2,0,0.3,0
          c1.3,0.1,2.4,0.7,3.1,1.6c8.7,10.9,23.3,17.4,39,17.4L327.1,223.1z"
        />
      </g>
      <g>
        <path
          className="st2"
          d="M327.1,268.6c-15,0-29.6-5.3-40-14.6l-2.4-2.1l-2.4,2.1c-10.4,9.3-25,14.6-40,14.6
          c-18.3,0-35.4-7.7-45.7-20.6c-1.5-1.8-1.2-4.5,0.7-6c0.8-0.6,1.7-0.9,2.7-0.9c1.3,0,2.5,0.6,3.3,1.6c8.7,10.9,23.3,17.4,39,17.4
          c15.7,0,30.3-6.5,39-17.4c0,0,0,0,0,0l0,0c0.3-0.4,0.5-0.6,0.7-0.7c0.7-0.5,1.5-0.8,2.3-0.9c0.2,0,0.3,0,0.3,0c0.1,0,0.2,0,0.3,0
          c1.3,0.1,2.4,0.7,3.1,1.6c8.7,10.9,23.3,17.4,39,17.4L327.1,268.6z"
        />
      </g>
      <g>
        <path
          d="M371,331.1h-5.7V29c0-3.1-2.6-5.7-5.7-5.7H40.4c-3.1,0-5.7,2.6-5.7,5.7v302.2H29c-3.1,0-5.7,2.6-5.7,5.7V371
          c0,3.1,2.6,5.7,5.7,5.7H371c3.1,0,5.7-2.6,5.7-5.7v-34.2C376.7,333.7,374.2,331.1,371,331.1z M46.1,34.7h307.9v296.5H46.1V34.7z
           M365.3,365.3H34.7v-22.8h330.7V365.3z"
        />
        <path
          d="M210.8,312.6h118.9c3,0,5.4-2.4,5.4-5.4V58.6c0-3-2.4-5.4-5.4-5.4H210.8h-21.6H70.3c-3,0-5.4,2.4-5.4,5.4v248.7
          c0,3,2.4,5.4,5.4,5.4h118.9H210.8z M183.8,301.8H75.7V64h108.1h32.4h108.1v237.9H216.2H183.8z"
        />
      </g>
      <path
        className="st2"
        d="M333.6,158.8h-45.1c-4,0-7.8-1.5-10.5-4.4c-2.9-2.8-4.4-6.6-4.4-10.6c0-8.2,6.7-15,15-15h2.2l0.4-1.5
          c2.3-9.1,10.5-15.4,19.9-15.4c9.4,0,17.6,6.4,19.9,15.4l0.4,1.5h2.2l-5.6,7.4c-2,0-3.7-1.7-3.7-3.7c0-7.3-5.9-13.2-13.2-13.2
          c-7.3,0-13.2,5.9-13.2,13.2c0,2-1.7,3.7-3.7,3.7h-5.6c-4.2,0-7.6,3.4-7.6,7.6c0,2.1,0.8,3.9,2.3,5.4c1.4,1.4,3.3,2.2,5.3,2.2h45.1
          V158.8z"
      />
      <path
        className="st2"
        d="M66.4,194.3h45.1c2,0,3.9-0.8,5.3-2.2c1.5-1.4,2.3-3.3,2.3-5.4c0-4.2-3.4-7.6-7.6-7.6h-5.6
          c-2,0-3.7-1.7-3.7-3.7c0-7.3-5.9-13.2-13.2-13.2c-7.3,0-13.2,5.9-13.2,13.2c0,2-1.7,3.7-3.7,3.7l-5.6-7.4h2.2l0.4-1.5
          c2.3-9.1,10.5-15.4,19.9-15.4c9.4,0,17.6,6.3,19.9,15.4l0.4,1.5h2.2c8.2,0,15,6.7,15,15c0,4-1.6,7.8-4.4,10.6
          c-2.8,2.8-6.5,4.4-10.5,4.4H66.4V194.3z"
      />
      <path
        d="M138.3,143.5c-10.1,0-18.2-8.2-18.2-18.2c0-4.9,1.9-9.5,5.4-12.9c3.4-3.5,7.9-5.3,12.8-5.3h2.7l0.5-1.8
          c2.9-11.1,12.9-18.8,24.3-18.8c11.4,0,21.4,7.7,24.3,18.8l0.5,1.8h2.7c10.1,0,18.2,8.2,18.2,18.2c0,4.9-1.9,9.5-5.4,12.9
          c-3.4,3.4-7.9,5.3-12.8,5.3H138.3z M138.3,116c-2.5,0-4.8,1-6.4,2.7c-1.8,1.8-2.8,4-2.8,6.5c0,5.1,4.1,9.2,9.2,9.2h54.9
          c2.5,0,4.8-1,6.4-2.7c1.8-1.8,2.8-4,2.8-6.5c0-5.1-4.1-9.2-9.2-9.2h-6.9c-2.5,0-4.5-2-4.5-4.5c0-8.9-7.2-16.1-16.1-16.1
          c-8.9,0-16.1,7.2-16.1,16.1c0,2.5-2,4.5-4.5,4.5H138.3z"
      />
    </g>
  </svg>
);

export const home_sound_system = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 400 400"
    height="35px"
    width="35px"
  >
    <g id="XMLID_1405_">
      <g id="XMLID_1326_">
        <g id="XMLID_2132_">
          <path
            d="M114.1,375.3c-19.6,0-35.5-15.9-35.5-35.5V60.2c0-19.6,15.9-35.5,35.5-35.5H235c3.5,0,6.4,2.8,6.4,6.4s-2.8,6.4-6.4,6.4
          H114.1c-12.6,0-22.8,10.2-22.8,22.8v279.7c0,12.6,10.2,22.8,22.8,22.8h171.9c12.6,0,22.8-10.2,22.8-22.8V60.2
          c0-12.6-10.2-22.8-22.8-22.8h-53.2c-3.5,0-6.4-2.8-6.4-6.4s2.8-6.4,6.4-6.4h53.2c19.6,0,35.5,15.9,35.5,35.5v279.7
          c0,19.6-15.9,35.5-35.5,35.5H114.1z"
          />
        </g>
        <g id="XMLID_1332_">
          <path
            d="M200,340.4c-42.1,0-76.3-34.2-76.3-76.3s34.2-76.3,76.3-76.3s76.3,34.2,76.3,76.3S242.1,340.4,200,340.4z M200,200.5
          c-35,0-63.6,28.5-63.6,63.6s28.5,63.6,63.6,63.6s63.6-28.5,63.6-63.6S235,200.5,200,200.5z"
          />
        </g>
        <g id="XMLID_1330_">
          <path
            d="M200,305.4c-22.8,0-41.3-18.5-41.3-41.3s18.5-41.3,41.3-41.3s41.3,18.5,41.3,41.3S222.8,305.4,200,305.4z M200,235.5
          c-15.8,0-28.6,12.8-28.6,28.6c0,15.8,12.8,28.6,28.6,28.6s28.6-12.8,28.6-28.6C228.6,248.3,215.8,235.5,200,235.5z"
          />
        </g>
        <g id="XMLID_1327_">
          <g id="XMLID_1329_">
            <path
              d="M200,165.6c-29.2,0-53-23.8-53-53s23.8-53,53-53s53,23.8,53,53S229.2,165.6,200,165.6z M200,72.3
          c-22.2,0-40.3,18.1-40.3,40.3s18.1,40.3,40.3,40.3s40.3-18.1,40.3-40.3S222.2,72.3,200,72.3z"
            />
          </g>
          <g id="XMLID_1328_">
            <path
              d="M200,135c-12.3,0-22.4-10-22.4-22.4s10-22.4,22.4-22.4s22.4,10,22.4,22.4S212.3,135,200,135z M200,102.9
          c-5.3,0-9.7,4.3-9.7,9.7s4.3,9.7,9.7,9.7s9.7-4.3,9.7-9.7S205.3,102.9,200,102.9z"
            />
          </g>
        </g>
      </g>
      <g id="XMLID_1325_">
        <path d="M347.1,259c-3.5,0-6.4-2.8-6.4-6.4V147.4c0-3.5,2.8-6.4,6.4-6.4s6.4,2.8,6.4,6.4v105.2C353.5,256.1,350.6,259,347.1,259z" />
      </g>
      <g id="XMLID_1324_">
        <path
          d="M379.2,308.9c-3.5,0-6.4-2.8-6.4-6.4v-205c0-3.5,2.8-6.4,6.4-6.4s6.4,2.8,6.4,6.4v205C385.5,306,382.7,308.9,379.2,308.9z
          "
        />
      </g>
      <g id="XMLID_1323_">
        <path
          d="M52.9,259c-3.5,0-6.4-2.8-6.4-6.4V147.4c0-3.5,2.8-6.4,6.4-6.4c3.5,0,6.4,2.8,6.4,6.4v105.2C59.2,256.1,56.4,259,52.9,259
          z"
        />
      </g>
      <g id="XMLID_1318_">
        <path d="M20.8,308.9c-3.5,0-6.4-2.8-6.4-6.4v-205c0-3.5,2.8-6.4,6.4-6.4s6.4,2.8,6.4,6.4v205C27.2,306,24.3,308.9,20.8,308.9z" />
      </g>
    </g>
  </svg>
);

export const beach_club_access = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="35px"
    width="35px"
    viewBox="0 0 400 400"
  >
    <path
      d="M142.48 82.71v121.85M61.59 82.71v121.85M338.41 82.71v121.85M257.52 82.71v121.85M36.39 204.56h327.22v18.49H36.39zM6.12 72.17v10.72h387.76V72.17L200 22.53 6.12 72.17zM36.39 358.98h327.22v18.49H36.39zM61.59 223.05v135.93M338.41 223.05v135.93M239.81 358.98v-69.45c0-21.98-17.82-39.81-39.81-39.81-21.98 0-39.81 17.82-39.81 39.81v69.45M290.17 249.72c9.84 0 17.82 7.99 17.82 17.82v36.81h-35.64v-36.81c0-9.84 7.99-17.82 17.82-17.82ZM111.96 249.72c9.84 0 17.82 7.99 17.82 17.82v36.81H94.14v-36.81c0-9.84 7.99-17.82 17.82-17.82Z"
      className="cls-1"
      stroke="#000"
      fill="none"
      strokeMiterlimit={10}
      strokeWidth="10px"
    />
  </svg>
);

export const checkin_checkout = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 400 400"
    height="35px"
    width="35px"
  >
    <g>
      <path
        d="M84.6,280.1l110.5,117.7c1.3,1.4,3.1,2.2,5,2.2s3.7-0.8,5-2.2l110.3-117.7c16.9-18,29.4-37.8,37-58.7
          c7.8-21.1,11.1-43.5,9.7-65.9c-2.7-40.9-20.1-79.5-49-108.6c-30-30.1-70.7-47-113.1-47S116.9,16.8,86.9,46.8
          c-28.9,29.1-46.4,67.7-49,108.6c-1.4,22.4,1.9,44.9,9.7,65.9C55.2,242.3,67.7,262.1,84.6,280.1z M51.5,156.4
          C54,118.7,70,83.2,96.6,56.5C124,29,161.2,13.6,200,13.6S276,29,303.4,56.5c26.6,26.8,42.6,62.3,45.1,99.9
          c1.3,20.5-1.7,41.1-8.9,60.3c-7,19.2-18.5,37.4-34.1,54.1L200,383.1L94.5,270.8c-15.6-16.7-27.1-34.9-34.1-54.1
          C53.2,197.4,50.2,176.9,51.5,156.4z"
      />
      <path
        d="M200,269.6c62.2,0,112.8-51.9,112.8-115.6S262.2,38.4,200,38.4S87.2,90.3,87.2,154C87.2,217.8,137.8,269.6,200,269.6z
           M200,52.1c54.7,0,99.1,45.8,99.1,102s-44.5,102-99.1,102c-54.7,0-99.1-45.8-99.1-102S145.3,52.1,200,52.1z"
      />
      <path
        d="M181.8,188.5c2.6,2.6,6.8,2.7,9.5,0.1l62.1-59.3c2.7-2.6,2.8-6.9,0.2-9.6c-2.6-2.7-6.9-2.8-9.6-0.2l-57.3,54.7l-30.5-30.5
          c-2.7-2.7-7-2.7-9.6,0c-2.7,2.7-2.7,7,0,9.6L181.8,188.5z"
      />
    </g>
  </svg>
);

export const family_friendly = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 400 400"
    height="35px"
    width="35px"
  >
    <g id="XMLID_2837_">
      <g id="XMLID_2769_">
        <g id="XMLID_2770_">
          <path
            className="st5"
            d="M5.9,362.1c-2.7,0-4.9-2.2-4.9-4.9v-103c0-36.8,29.9-66.7,66.7-66.7h14.6v-10.9l-1.2-0.9
          c-10.6-7.8-16.9-20.2-16.9-33.2v-25.2l-1.6-0.9c-10.9-5.9-17.7-17.3-17.7-29.7c0-18.6,15.1-33.7,33.7-33.7
          c3.4,0,6.9,0.5,10.2,1.6l2,0.6l1.3-1.6c7.9-10,19.7-15.7,32.4-15.7c22.8,0,41.3,18.5,41.3,41.3c0,13.6-6.7,26.3-18,34l-1.3,0.9
          v28.4c0,13.1-6.3,25.5-16.9,33.2l-1.2,0.9v10.9h14.6c11.5,0,22.8,3,32.7,8.6l1.9,1.1l1.6-1.5c5.7-5.3,13.1-8.1,20.9-8.1
          c10.3,0,19.9,5.2,25.7,13.8l1.6,2.4l2.5-1.6c2.2-1.4,4.5-2.6,6.7-3.7l4-1.9l-3.1-3.1c-5.9-5.8-9.1-13.4-9.1-21.6v-35.8
          c0-39.4,31.7-71.7,70.6-72l0.5,0c18.9,0,36.7,7.3,50.1,20.7c13.6,13.5,21,31.4,21,50.5V172c0,8.2-3.2,15.9-9.2,21.6l-3.1,3.1
          l4,1.9c22.3,10.5,36.7,33.1,36.7,57.7v100.9c0,2.7-2.2,4.9-4.9,4.9H5.9z M263.6,202.2c-11.4,0-22.4,3.5-31.6,10.2l-1.4,1l0.2,1.7
          c0.1,1.1,0.2,2.2,0.2,3.2c0,6.6-2.1,12.9-6,18.2l-2.5,3.4l4,1.3c14.6,4.8,24.4,18.3,24.4,33.6v77.4h138.4v-96.1
          c0-29.8-24.2-54-54-54h-13.4l-0.3,2.8c-1,11.3-10.8,20.2-22.1,20.2c-11.4,0-21.1-8.9-22.1-20.2l-0.3-2.8H263.6z M184.5,249.4
          c-14.1,0-25.6,11.5-25.6,25.6v77.4h82.2V275c0-14.1-11.5-25.6-25.6-25.6H184.5z M67.7,197.3c-31.4,0-57,25.6-57,57v98.1h138.4
          V275c0-15.3,9.8-28.8,24.4-33.6l4-1.3l-2.5-3.4c-3.9-5.3-6-11.6-6-18.2c0-3.7,0.7-7.3,2-10.8l0.9-2.5l-2.3-1.2
          c-8.2-4.3-17.4-6.6-26.7-6.6h-14.6v3.8c0,12.7-10.3,23-23,23s-23-10.3-23-23v-3.8H67.7z M200,197.3c-11.7,0-21.2,9.5-21.2,21.2
          s9.5,21.2,21.2,21.2s21.2-9.5,21.2-21.2S211.7,197.3,200,197.3z M286.9,202.9c0,6.9,5.6,12.5,12.5,12.5s12.5-5.6,12.5-12.5v-15.5
          l-3.7,0.8c-2.9,0.7-5.9,1-8.8,1c-2.9,0-5.9-0.3-8.8-1l-3.7-0.8V202.9z M92,201c0,7.3,6,13.3,13.3,13.3c7.3,0,13.3-6,13.3-13.3
          v-19.3l-3.7,0.9c-3.1,0.8-6.4,1.1-9.6,1.1s-6.4-0.4-9.6-1.1l-3.7-0.9V201z M324,119.2c8.3,0,15,6.7,15,15v15.5
          c0,12.5-6,24.4-16.1,31.9l-1.2,0.9v10h18.7c11.3,0,20.5-9.2,20.5-20.5v-36.6c0-16.5-6.5-32-18.2-43.6
          c-11.6-11.5-26.9-17.8-43.2-17.8l-0.6,0c-33.6,0.2-61,28.2-61,62.3V172c0,11.3,9.2,20.5,20.5,20.5h18.7v-10l-1.2-0.9
          c-10.1-7.5-16.1-19.4-16.1-31.9v-15.5c0-8.3,6.7-15,15-15H324z M274.9,128.9c-2.9,0-5.3,2.4-5.3,5.3v15.5
          c0,16.5,13.4,29.9,29.9,29.9s29.9-13.4,29.9-29.9v-15.5c0-2.9-2.4-5.3-5.3-5.3H274.9z M73.9,142.5c0,17.3,14.1,31.4,31.4,31.4
          s31.4-14.1,31.4-31.4v-23.7l-3.7,0.8c-2.8,0.6-5.8,0.9-8.6,0.9c-8,0-15.8-2.3-22.5-6.6l-1.8-1.1l-1.7,1.2
          c-5.8,4.2-12.8,6.5-19.9,6.5c-0.5,0-1.1,0-1.6,0l-3.2-0.1V142.5z M100,101.4c1.2,0,2.4,0.4,3.3,1.3c5.8,5.3,13.3,8.2,21.2,8.2
          c17.4,0,31.6-14.2,31.6-31.6s-14.2-31.6-31.6-31.6c-11.4,0-22,6.2-27.6,16.2c-0.9,1.5-2.5,2.5-4.3,2.5c-0.8,0-1.6-0.2-2.4-0.6
          c-3.5-2-7.6-3-11.6-3c-13.2,0-24,10.8-24,24s10.8,24,24,24c6.7,0,13.2-2.9,17.8-7.9C97.3,101.9,98.6,101.4,100,101.4z"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const rooftop_terrace = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 400 400"
    height="35px"
    width="35px"
  >
    <g>
      <g>
        <g>
          <path
            d="M347.4,313.6c2.5-5.2,2.7-11.2,0.5-16.7l-0.1-0.2c-1.2-3.2-3.3-5.8-5.9-7.7c0.7-1.6,1-3.3,1-5.2V257
          c0-7.5-6.1-13.6-13.6-13.6h-14.5c-0.6,0-1.2,0-1.8,0.1V210c0-9.2-7.4-16.6-16.6-16.6h-84c-4.1,0-7.8,1.5-10.7,3.9
          c-2.9-2.4-6.6-3.9-10.7-3.9h-82.3c-9.2,0-16.6,7.4-16.6,16.6v33.5c-0.6-0.1-1.2-0.1-1.8-0.1H76c-7.5,0-13.6,6.1-13.6,13.6v26.9
          c0,1.5,0.2,2.9,0.7,4.3c-3.2,1.9-5.8,4.9-7.2,8.6l-0.1,0.2c-2.2,5.4-1.9,11.5,0.5,16.7c-3.2,0-5.9,2.7-5.9,5.9v40.1
          c0,3.3,2.6,5.9,5.9,5.9h16.3v28.5c0,3.3,2.6,5.9,5.9,5.9h16.5c2.2,0,4.2-1.2,5.2-3.1l17-31.3h169.2l17,31.3c1,1.9,3,3.1,5.2,3.1
          h16.5c3.3,0,5.9-2.6,5.9-5.9v-28.5h16.3c3.3,0,5.9-2.6,5.9-5.9v-40.1C353.2,316.3,350.6,313.7,347.4,313.6L347.4,313.6z
           M207.8,302.9c0-3,2.4-5.4,5.4-5.4h118.6c2.3,0,4.2,1.4,5.1,3.5l0.1,0.3c1.1,2.8,0.8,5.9-0.9,8.4c-1.7,2.5-4.4,3.9-7.4,3.9H207.8
          V302.9z M314.9,255.2h14.5c1,0,1.8,0.8,1.8,1.8v26.9c0,1-0.8,1.8-1.8,1.8h-14.5c-2.4,0-1.8-3.3-1.8-4.8v-24.2
          C313.2,255.9,314,255.2,314.9,255.2z M212.6,205.2h84c2.6,0,4.8,2.1,4.8,4.8l0,71.4c-0.2,2.4-2.3,4.3-4.8,4.3h-84
          c-2.6,0-4.8-2.1-4.8-4.8V210C207.8,207.4,209.9,205.2,212.6,205.2z M104.1,210c0-2.6,2.1-4.8,4.8-4.8h82.3c2.6,0,4.8,2.1,4.8,4.8
          v70.9v0c0,2.6-2.1,4.8-4.8,4.8h-0.6h-75.7c-4,0-9.9-3.2-10.7-4.9L104.1,210z M74.2,257c0-1,0.8-1.8,1.8-1.8h14.5
          c1,0,1.8,0.8,1.8,1.8v24c0,1.5,0.6,4.8-1.8,4.8H76c-1,0-1.8-0.8-1.8-1.8V257z M91.5,388.2h-7v-22.6h19.3L91.5,388.2z
           M319.2,388.2h-7l-12.3-22.6h19.3L319.2,388.2z M341.4,353.7H62.3v-28.3h36.8c3.3,0,5.9-2.6,5.9-5.9c0-3.3-2.6-5.9-5.9-5.9h-24
          c-3,0-5.7-1.4-7.4-3.9c-1.7-2.5-2-5.6-0.9-8.4l0.1-0.3c0.8-2.1,2.8-3.5,5.1-3.5h4h114.5c3,0,5.4,2.4,5.4,5.4v10.7H87.1
          c-3.3,0-5.9,2.6-5.9,5.9s2.6,5.9,5.9,5.9h254.3V353.7z"
          />
        </g>
      </g>
      <path
        d="M45,107.1c-11.4,0-20.6-9.3-20.6-20.6c0-5.6,2.2-10.8,6.1-14.6c3.8-3.9,8.9-6,14.5-6h3l0.5-2C51.8,51.3,63.1,42.6,76,42.6
          c12.9,0,24.3,8.8,27.5,21.3l0.5,2h3.1c11.4,0,20.6,9.3,20.6,20.6c0,5.6-2.2,10.8-6.1,14.6c-3.8,3.9-8.9,6-14.5,6H45z M45,76.1
          c-2.8,0-5.4,1.1-7.3,3c-2,2-3.1,4.6-3.1,7.4c0,5.8,4.7,10.4,10.4,10.4h62.1c2.8,0,5.4-1.1,7.3-3c2-2,3.1-4.6,3.1-7.4
          c0-5.8-4.7-10.4-10.4-10.4h-7.8c-2.8,0-5.1-2.3-5.1-5.1c0-10-8.2-18.2-18.2-18.2c-10,0-18.2,8.2-18.2,18.2c0,2.8-2.3,5.1-5.1,5.1
          H45z"
      />
      <path
        d="M292.9,153.1c-11.4,0-20.6-9.3-20.6-20.6c0-5.6,2.2-10.8,6.1-14.6c3.8-3.9,8.9-6,14.5-6h3l0.5-2
          c3.2-12.5,14.5-21.3,27.5-21.3c12.9,0,24.3,8.8,27.5,21.3l0.5,2h3.1c11.4,0,20.6,9.3,20.6,20.6c0,5.6-2.2,10.8-6.1,14.6
          c-3.8,3.9-8.9,6-14.5,6H292.9z M292.9,122c-2.8,0-5.4,1.1-7.3,3c-2,2-3.1,4.6-3.1,7.4c0,5.8,4.7,10.4,10.4,10.4H355
          c2.8,0,5.4-1.1,7.3-3c2-2,3.1-4.6,3.1-7.4c0-5.8-4.7-10.4-10.4-10.4h-7.8c-2.8,0-5.1-2.3-5.1-5.1c0-10-8.2-18.2-18.2-18.2
          c-10,0-18.2,8.2-18.2,18.2c0,2.8-2.3,5.1-5.1,5.1H292.9z"
      />
    </g>
  </svg>
);

export const outdoor_dining = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 400 400"
    height="35px"
    width="35px"
  >
    <g>
      <g>
        <path
          className="st5"
          d="M144.3,376.1c-2.4,0-4.4-2-4.4-4.4s2-4.4,4.4-4.4h19.8l0.3-1.6c2.8-13.8,15.1-23.9,29.3-23.9l2,0v-74.3h-52.8
          c-2.4,0-4.4-2-4.4-4.4v-19.1c0-2.4,2-4.4,4.4-4.4h52.8V128.1h-161c-2.4,0-4.4-2-4.4-4.4c0-22.2,18.1-42.8,51-58
          C108.5,53.1,143,45.4,181,43.4l1.9-0.1V28.3c0-2.4,2-4.4,4.4-4.4h25.4c2.4,0,4.4,2,4.4,4.4v15.1l1.9,0.1c38,2,72.5,9.7,99.8,22.3
          c32.9,15.2,51,35.8,51,58c0,2.4-2,4.4-4.4,4.4h-161v111.6h52.8c2.4,0,4.4,2,4.4,4.4v19.1c0,2.4-2,4.4-4.4,4.4h-52.8v74.3l2,0
          c14.1,0,26.4,10.1,29.3,23.9l0.3,1.6h23.6c2.4,0,4.4,2,4.4,4.4s-2,4.4-4.4,4.4H144.3z M193.6,350.7c-8.9,0-16.9,5.6-19.8,14
          l-0.9,2.6h54.2l-0.9-2.6c-3-8.4-10.9-14-19.8-14H193.6z M147.2,258.8h105.7v-10.3H147.2V258.8z M263.6,61.5
          c20.8,13.9,33.9,34.4,36,56l0.2,1.8h61.1l-0.5-2.4c-3.6-16.1-19.6-31.4-45.1-43.2c-14.6-6.7-31.4-12-50.1-15.8L263.6,61.5z
           M204.4,119.3h86.5l-0.3-2.2c-2-17-11.6-32.9-27.1-44.9c-15.4-11.9-35.7-19.1-57.1-20.3l-2.1-0.1V119.3z M193.5,51.9
          c-21.4,1.2-41.7,8.4-57.1,20.3c-15.5,12-25.1,27.9-27.1,44.9l-0.3,2.2h86.5V51.8L193.5,51.9z M135,57.9
          c-18.7,3.7-35.5,9-50.1,15.8c-25.5,11.8-41.5,27.1-45.1,43.2l-0.5,2.4h61.1l0.2-1.8c2-21.7,15.1-42.1,36-56L135,57.9z M191.7,42.9
          h16.6V32.7h-16.6V42.9z"
        />
      </g>
      <g>
        <g>
          <path
            className="st2"
            d="M362.3,376.1c-2.9,0-5.2-2.3-5.2-5.2v-52.2h-65.7v52.2c0,2.9-2.3,5.2-5.2,5.2s-5.2-2.3-5.2-5.2v-52.2h-9.1
          c-2.9,0-5.2-2.3-5.2-5.2v-14.4c0-10.8,8.8-19.6,19.6-19.6h56.5v-85.2c0-10.8,8.8-19.6,19.6-19.6c10.8,0,19.6,8.8,19.6,19.6v104.8
          c0,8.3-5.2,15.7-13.1,18.5l-1.3,0.5v52.9C367.5,373.8,365.2,376.1,362.3,376.1z M286.2,290c-5,0-9.1,4.1-9.1,9.1v9.1h85.2
          c5,0,9.1-4.1,9.1-9.1V194.3c0-5-4.1-9.1-9.1-9.1c-5,0-9.1,4.1-9.1,9.1v90.5c0,2.9-2.3,5.2-5.2,5.2H286.2z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            className="st2"
            d="M113.8,376.1c-2.9,0-5.2-2.3-5.2-5.2v-52.2H42.9v52.2c0,2.9-2.3,5.2-5.2,5.2c-2.9,0-5.2-2.3-5.2-5.2V318
          l-1.3-0.5c-7.8-2.8-13.1-10.2-13.1-18.5V194.3c0-10.8,8.8-19.6,19.6-19.6s19.6,8.8,19.6,19.6v85.2h56.5
          c10.8,0,19.6,8.8,19.6,19.6v14.4c0,2.9-2.3,5.2-5.2,5.2h-9.1v52.2C119.1,373.8,116.7,376.1,113.8,376.1z M37.7,185.1
          c-5,0-9.1,4.1-9.1,9.1v104.8c0,5,4.1,9.1,9.1,9.1H123v-9.1c0-5-4.1-9.1-9.1-9.1H52.1c-2.9,0-5.2-2.3-5.2-5.2v-90.5
          C46.9,189.2,42.8,185.1,37.7,185.1z"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const lockoff_studio = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 400 400"
    height="35px"
    width="35px"
  >
    <g>
      <g>
        <g>
          <path
            d="M173.3,217.6H300c18.4,0,33.3,14.9,33.3,33.3v20h-160V217.6z M80,217.6h40c7.4,0,13.3,6,13.3,13.3s-6,13.3-13.3,13.3H80
          c-7.4,0-13.3-6-13.3-13.3S72.6,217.6,80,217.6z M13.3,177.6h13.3v66.7H13.3V177.6z M373.3,311H400V164.3h-40v80h-13.9
          c-3.3-22.9-23-40-46.1-40H160v40h-17c2.4-4,3.7-8.6,3.7-13.3c0-14.7-11.9-26.7-26.7-26.7H80c-14.7,0-26.7,11.9-26.7,26.7
          c0,4.7,1.3,9.3,3.7,13.3H40v-80H0V311h26.7H373.3z M386.7,297.6H13.3v-40H160v26.7h186.7v-26.7h40V297.6z M386.7,244.3h-13.3
          v-66.7h13.3V244.3z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M311.7,69.1h-6.4v-6.4c0-32-25.9-57.9-57.9-57.9c-32,0-57.9,25.9-57.9,57.9v6.4H183c-3.6,0-6.4,2.9-6.4,6.4v103
          c0,3.6,2.9,6.4,6.4,6.4h128.7c3.6,0,6.4-2.9,6.4-6.4v-103C318.2,72,315.3,69.1,311.7,69.1z M202.3,62.7
          c0-24.9,20.2-45.1,45.1-45.1s45.1,20.2,45.1,45.1v6.4h-90.1V62.7z M305.3,172.1H189.5V82h115.8V172.1z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M265.6,114.2c-2.7-7.7-10-12.9-18.2-12.9c-10.6,0-19.3,8.6-19.3,19.2c0,8.2,5.1,15.5,12.9,18.2v14.1
          c0,3.6,2.9,6.4,6.4,6.4c3.6,0,6.4-2.9,6.4-6.4v-14.1C263.9,135.2,269.1,124.2,265.6,114.2z M247.4,127.1c-3.6,0-6.4-2.9-6.4-6.4
          s2.9-6.4,6.4-6.4s6.4,2.9,6.4,6.4C253.8,124.2,250.9,127.1,247.4,127.1z"
          />
        </g>
      </g>
      <g>
        <path d="M26,311.6v69.6H14v-69.6H26 M40,297.6H0v97.6h40V297.6L40,297.6z" />
      </g>
      <g>
        <path d="M386,311.6v69.6h-12v-69.6H386 M400,297.6h-40v97.6h40V297.6L400,297.6z" />
      </g>
    </g>
  </svg>
);

export const covered_terrace = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 400 400"
    height="35px"
    widht="35px"
  >
    <g>
      <g>
        <path
          d="M365.5,142.7c-10.6,0-20.3-4.9-26.7-13.6l-0.9-1.2l-0.9,1.2c-6.4,8.6-16.2,13.6-26.7,13.6c-10.6,0-20.3-4.9-26.7-13.6
          l-0.9-1.2l-0.9,1.2c-6.4,8.6-16.2,13.6-26.7,13.6s-20.3-4.9-26.7-13.6l-0.9-1.2l-0.9,1.2c-6.4,8.6-16.2,13.6-26.7,13.6
          s-20.3-4.9-26.7-13.6l-0.9-1.2l-0.9,1.2c-6.4,8.6-16.2,13.6-26.7,13.6s-20.3-4.9-26.7-13.6l-0.9-1.2l-0.9,1.2
          c-6.4,8.6-16.2,13.6-26.7,13.6c-10.6,0-20.3-4.9-26.7-13.6l-0.9-1.2l-0.9,1.2c-6.4,8.6-16.2,13.6-26.7,13.6
          c-18.4,0-33.4-15-33.4-33.4V74.8c0-0.8,0.2-1.5,0.5-2.2c0.3-0.7,0.7-1.4,1.3-1.9L71.8,1.7C72.9,0.6,74.3,0,75.9,0h248.2
          c1.6,0,3,0.6,4.1,1.7l68.9,68.9c0.5,0.5,1,1.2,1.3,1.9c0.3,0.7,0.4,1.5,0.4,2.2v34.5C398.9,127.7,383.9,142.7,365.5,142.7z
           M343.7,109.2c0,12,9.8,21.8,21.8,21.8c12,0,21.8-9.8,21.8-21.8V80.6h-43.5V109.2z M288.6,109.2c0,12,9.8,21.8,21.8,21.8
          s21.8-9.8,21.8-21.8V80.6h-43.5V109.2z M233.4,109.2c0,12,9.8,21.8,21.8,21.8c12,0,21.8-9.8,21.8-21.8V80.6h-43.5V109.2z
           M178.2,109.2c0,12,9.8,21.8,21.8,21.8s21.8-9.8,21.8-21.8V80.6h-43.5V109.2z M123.1,109.2c0,12,9.8,21.8,21.8,21.8
          s21.8-9.8,21.8-21.8V80.6h-43.5V109.2z M67.9,109.2c0,12,9.8,21.8,21.8,21.8s21.8-9.8,21.8-21.8V80.6H67.9V109.2z M12.8,109.2
          c0,12,9.8,21.8,21.8,21.8s21.8-9.8,21.8-21.8V80.6H12.8V109.2z M21,68.9h358l-57.3-57.3H78.3L21,68.9z"
        />
      </g>
      <g>
        <g>
          <path
            d="M345.5,313.6c2.5-5.2,2.7-11.2,0.5-16.7l-0.1-0.2c-1.2-3.2-3.3-5.8-5.9-7.7c0.7-1.6,1-3.3,1-5.2V257
          c0-7.5-6.1-13.6-13.6-13.6H313c-0.6,0-1.2,0-1.8,0.1V210c0-9.2-7.4-16.6-16.6-16.6h-84c-4.1,0-7.8,1.5-10.7,3.9
          c-2.9-2.4-6.6-3.9-10.7-3.9H107c-9.2,0-16.6,7.4-16.6,16.6v33.5c-0.6-0.1-1.2-0.1-1.8-0.1H74.1c-7.5,0-13.6,6.1-13.6,13.6v26.9
          c0,1.5,0.2,2.9,0.7,4.3c-3.2,1.9-5.8,4.9-7.2,8.6l-0.1,0.2c-2.2,5.4-1.9,11.5,0.5,16.7c-3.2,0-5.9,2.7-5.9,5.9v40.1
          c0,3.3,2.6,5.9,5.9,5.9h16.3v28.5c0,3.3,2.6,5.9,5.9,5.9h16.5c2.2,0,4.2-1.2,5.2-3.1l17-31.3h169.2l17,31.3c1,1.9,3,3.1,5.2,3.1
          h16.5c3.3,0,5.9-2.6,5.9-5.9v-28.5h16.3c3.3,0,5.9-2.6,5.9-5.9v-40.1C351.4,316.3,348.8,313.7,345.5,313.6L345.5,313.6z
           M205.9,302.9c0-3,2.4-5.4,5.4-5.4h118.6c2.3,0,4.2,1.4,5.1,3.5l0.1,0.3c1.1,2.8,0.8,5.9-0.9,8.4c-1.7,2.5-4.4,3.9-7.4,3.9H205.9
          V302.9z M313,255.2h14.5c1,0,1.8,0.8,1.8,1.8v26.9c0,1-0.8,1.8-1.8,1.8H313c-2.4,0-1.8-3.3-1.8-4.8v-24.2
          C311.4,255.9,312.1,255.2,313,255.2z M210.7,205.2h84c2.6,0,4.8,2.1,4.8,4.8l0,71.4c-0.2,2.4-2.3,4.3-4.8,4.3h-84
          c-2.6,0-4.8-2.1-4.8-4.8V210C205.9,207.4,208.1,205.2,210.7,205.2z M102.2,210c0-2.6,2.1-4.8,4.8-4.8h82.3c2.6,0,4.8,2.1,4.8,4.8
          v70.9v0c0,2.6-2.1,4.8-4.8,4.8h-0.6h-75.7c-4,0-9.9-3.2-10.7-4.9L102.2,210z M72.3,257c0-1,0.8-1.8,1.8-1.8h14.5
          c1,0,1.8,0.8,1.8,1.8v24c0,1.5,0.6,4.8-1.8,4.8H74.1c-1,0-1.8-0.8-1.8-1.8V257z M89.7,388.2h-7v-22.6H102L89.7,388.2z
           M317.4,388.2h-7L298,365.6h19.3L317.4,388.2z M339.6,353.7H60.4v-28.3h36.8c3.3,0,5.9-2.6,5.9-5.9c0-3.3-2.6-5.9-5.9-5.9h-24
          c-3,0-5.7-1.4-7.4-3.9c-1.7-2.5-2-5.6-0.9-8.4L65,301c0.8-2.1,2.8-3.5,5.1-3.5h4h114.5c3,0,5.4,2.4,5.4,5.4v10.7H85.2
          c-3.3,0-5.9,2.6-5.9,5.9s2.6,5.9,5.9,5.9h254.3V353.7z"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const housekeeping = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 400 400"
    height="35px"
    width="35px"
  >
    <g>
      <g id="outline">
        <path
          d="M223.7,361.5c-2.4,0-4.5-1.7-5-4.2l-19.9-106.9c-0.5-2.6,1.1-5.2,3.7-5.8l90-24c0.4-0.1,0.9-0.2,1.3-0.2
          c2.2,0,4.2,1.5,4.9,3.6L329.9,328c0.7,2.7-0.9,5.5-3.6,6.2l-101.3,27c-0.1,0-0.3,0.1-0.4,0.1C224.3,361.4,224,361.5,223.7,361.5
          L223.7,361.5z M209.7,253.1l18,96.9l90.9-24.3l-28.2-94.2L209.7,253.1z"
        />
        <path
          d="M201.9,395.3c-2.5,0-4.6-1.8-5-4.2l-25.4-147.5c-0.2-1.3,0.1-2.7,0.9-3.8l8.4-11.8l-1.5-1c-2.6-1.6-4.8-3.9-6.3-6.6
          c-5-8.9-1.9-20.2,6.9-25.2l1.7-1l-1.2-1.5c-4.3-5.6-4.9-13.3-1.6-19.6l0.7-1.4l-1.3-0.8c-3.9-2.5-6.7-6.4-7.9-10.9
          c-1.3-4.8-0.6-9.8,1.9-14.1c2.5-4.3,6.5-7.3,11.3-8.6l21.3-5.7l-4.4-16.4l-8.2,2.2c-0.4,0.1-0.9,0.2-1.3,0.2
          c-2.3,0-4.3-1.6-4.9-3.8l-5.2-19.4l-9.9,6.5l-0.1,0.7c-2.7,16-8.1,31.2-16.1,45.2c-0.7,1.2-1.8,2-3.1,2.4
          c-0.4,0.1-0.9,0.2-1.3,0.2c-2.3,0-4.3-1.6-4.9-3.8l-16.2-60.6l-8.1,2.2c-0.4,0.1-0.9,0.2-1.3,0.2l-27.9,0.4c-2.4,0-4.4-1.6-5-3.8
          l-7-26.2c-0.6-2.3,0.4-4.6,2.4-5.8l24.4-13.5c0.4-0.2,0.8-0.4,1.2-0.5L219.3,8.6c5.6-1.5,11.6-2.3,17.8-2.3
          c11.8,0,23.2,2.8,32.3,8c9.9,5.6,16.5,13.6,19,23.2c0.7,2.7-0.9,5.5-3.6,6.2l-21.3,5.7l10.9,40.9c0.7,2.7-0.9,5.5-3.6,6.2
          l-8.2,2.2l4.4,16.4l47.5-12.7c0.4-0.1,0.9-0.2,1.3-0.2c0.9,0,1.8,0.2,2.5,0.7l14.8,8.5l37.2-9.9c0.4-0.1,0.9-0.2,1.3-0.2
          c2.3,0,4.3,1.6,4.9,3.8l21,78.6c0.4,1.3,0.2,2.7-0.5,3.9c-0.7,1.2-1.8,2-3.1,2.4l-37.2,9.9l-8.5,14.8c-0.7,1.2-1.8,2-3.1,2.4
          l-21.8,5.8l40.6,123.9c0,0.1,0.1,0.2,0.1,0.3c0.7,2.7-0.9,5.5-3.6,6.2l-157.1,41.9c-0.2,0-0.3,0.1-0.5,0.1
          C202.5,395.3,202.2,395.3,201.9,395.3C201.9,395.3,201.9,395.3,201.9,395.3z M228.5,135.9l1.4,2c4,5.6,4.4,12.8,1.2,18.9l-0.7,1.4
          l1.3,0.8c2.5,1.6,4.6,3.8,6.1,6.4c2.4,4.3,3.1,9.3,1.8,14c-1.3,4.8-4.4,8.7-8.6,11.2l-1.7,1l1.2,1.5c1.5,1.9,2.5,4.1,3.1,6.5
          c1.3,4.8,0.6,9.8-1.9,14.1c-2.5,4.3-6.5,7.3-11.3,8.6l-26.2,7c-0.2,0-0.4,0.1-0.6,0.1c-0.2,0-0.5,0.1-0.7,0.1l-0.7,0.1L182,243.9
          l24.1,140l146.5-39.1l-64.5-196.7l-22.9,6.1c-1.6,0.4-3.2,0.6-4.8,0.6c-0.5,0-1,0-1.5-0.1c-5-0.4-9.5-2.7-12.7-6.5
          c-3.2-3.8-4.8-8.6-4.4-13.6l0.2-2.4L228.5,135.9z M215.4,195.8c-0.7,0-1.5,0.1-2.2,0.3l-26.2,7c-2.2,0.6-4,2-5.1,3.9
          c-1.1,2-1.4,4.2-0.9,6.4c1,3.7,4.4,6.3,8.2,6.3c0.7,0,1.5-0.1,2.2-0.3l26.2-7c4.5-1.2,7.2-5.9,6-10.4
          C222.6,198.4,219.3,195.8,215.4,195.8z M297.9,145.5l22.2,67.7l20.3-5.4L349,193c0.7-1.2,1.8-2,3.1-2.4l34.4-9.2l-18.4-68.7
          l-34.4,9.2c-0.4,0.1-0.9,0.2-1.3,0.2c-0.9,0-1.8-0.2-2.5-0.7l-14.8-8.5L258.2,128c-2.2,0.6-4,2-5.1,3.9c-1.1,2-1.4,4.2-0.9,6.4
          c1,3.7,4.4,6.3,8.2,6.3c0.7,0,1.5-0.1,2.2-0.3l50.7-13.5l2.6,9.8L297.9,145.5z M221.5,166.1c-0.7,0-1.5,0.1-2.2,0.3l-26.2,7
          c-4.5,1.2-7.2,5.9-6,10.4c1,3.7,4.4,6.3,8.2,6.3c0.7,0,1.5-0.1,2.2-0.3l26.2-7c4.5-1.2,7.2-5.9,6-10.4
          C228.7,168.7,225.4,166.1,221.5,166.1z M214.5,139.9c-0.7,0-1.5,0.1-2.2,0.3l-26.2,7c-4.5,1.2-7.2,5.9-6,10.4
          c1,3.7,4.4,6.3,8.2,6.3c0.7,0,1.5-0.1,2.2-0.3l26.2-7c4.5-1.2,7.2-5.9,6-10.4C221.7,142.5,218.4,139.9,214.5,139.9z M139.1,82.6
          l12.7,47.6l1.9-4.4c3.8-8.8,6.3-18.2,7.2-27.8c0.1-1.7,1-3.1,2.3-4l8.7-5.7l-26-7.5L139.1,82.6z M210.3,112.7l4.4,16.4l42.6-11.4
          l-4.4-16.4L210.3,112.7z M190.2,90l4.4,16.4l68.7-18.4l-4.4-16.4L190.2,90z M146,70.5c0.5,0,0.9,0.1,1.4,0.2L184,81.2l72.3-19.3
          l-3.9-14.7c-0.7-2.7,0.9-5.5,3.6-6.2l20.8-5.6l-1.3-2c-6.8-10.3-21.9-16.9-38.4-16.9c-5.2,0-10.3,0.7-15.1,2L115.5,46.9l7.9,29.5
          l21.3-5.7C145.1,70.5,145.5,70.5,146,70.5z M90.8,59.3l4.9,18.5l17.5-0.3l-7.1-26.7L90.8,59.3z"
        />
        <path
          d="M261.3,322.7c-11.5,0-21.6-7.8-24.5-18.9c-2.5-9.4,4.5-28.3,11.3-41.6c0,0,0-0.1,0.1-0.1c1-1.6,2.7-2.5,4.5-2.5
          c1,0,1.9,0.3,2.7,0.8c12.5,8.1,28,21,30.5,30.4c1.8,6.6,0.8,13.4-2.6,19.3c-3.4,5.9-8.9,10.1-15.4,11.8
          C265.7,322.4,263.5,322.7,261.3,322.7C261.3,322.7,261.3,322.7,261.3,322.7z M253.7,274c-4.3,9.9-8.5,22.2-7.1,27.2
          c1.8,6.7,7.8,11.3,14.7,11.3c1.3,0,2.7-0.2,3.9-0.5c8.1-2.2,13-10.5,10.8-18.7c-1.3-5-11.5-13.9-19.8-20l-1.7-1.3L253.7,274z"
        />
      </g>
      <path d="M33.9,129l-12,21.9L0,162.9l21.9,12l12,21.9l12-21.9l21.9-12l-21.9-12L33.9,129z" />
      <path d="M376.3,4.7L367.9,20l-15.3,8.4l15.3,8.4l8.4,15.3l8.4-15.3l15.3-8.4L384.7,20L376.3,4.7z" />
      <path d="M117.5,238.3l-8.4,15.3l-15.3,8.4l15.3,8.4l8.4,15.3l8.4-15.3l15.3-8.4l-15.3-8.4L117.5,238.3z" />
    </g>
  </svg>
);

export const small_events = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 400 400"
    height="35px"
    width="35px"
  >
    <g>
      <path d="M210.9,153.1c0.1-3.1-2.4-5.6-5.4-5.6c-3.1-0.1-5.6,2.4-5.6,5.4s2.4,5.6,5.4,5.6S210.9,156.1,210.9,153.1z" />
      <path
        d="M216,403.7c-24.2,0-46.9-1.2-64-3.4c-22.9-2.9-31.4-6.8-31.4-14.1c0-7.4,8.6-11.3,32-14.4c17.5-2.3,40.6-3.6,65.3-3.6
          l1.9,0c24.2,0,46.9,1.2,64,3.4c22.9,2.9,31.4,6.8,31.4,14.1c0,7.4-8.6,11.3-32,14.4c-17.5,2.3-40.6,3.6-65.3,3.6L216,403.7z
           M140.3,386.1c13.2,2.8,39.9,5.4,75.7,5.4l1.9,0c36.7-0.1,64.1-2.9,77.6-5.8c-13.2-2.8-39.9-5.4-75.7-5.4l-1.9,0
          C181.2,380.4,153.8,383.2,140.3,386.1z"
      />

      <rect
        x="158.2"
        y="9.4"
        transform="matrix(0.8957 -0.4447 0.4447 0.8957 -42.5182 85.0079)"
        className="st4"
        width="3.4"
        height="247.5"
      />
      <path
        d="M345.3,124.4c-30.7,0-55.6-24.9-55.6-55.4s25-55.4,55.6-55.4S401,38.4,401,68.9S376,124.4,345.3,124.4z M345.3,25.7
          c-24,0-43.5,19.4-43.5,43.3s19.5,43.3,43.5,43.3s43.5-19.4,43.5-43.3S369.3,25.7,345.3,25.7z"
      />
      <rect x="112.7" y="124.2" className="st4" width="196.4" height="4" />
      <path d="M216.5,194.8c0.1-3.1-2.4-5.6-5.4-5.6c-3.1-0.1-5.6,2.4-5.6,5.4c-0.1,3.1,2.4,5.6,5.4,5.6S216.4,197.9,216.5,194.8z" />
      <path
        d="M251.5,153.1c0.1-3.1-2.4-5.6-5.4-5.6c-3.1-0.1-5.6,2.4-5.6,5.4c-0.1,3.1,2.4,5.6,5.4,5.6
          C248.9,158.6,251.4,156.1,251.5,153.1z"
      />
      <path d="M221.8,372.7h-12.1V252.4L53.3,64.1h310.3L221.8,252.3V372.7z M79.1,76.2l136.3,164.3L339.2,76.2H79.1z" />
      <path
        className="st4"
        d="M100.1,25.3c-5.9,0.4-11-4.1-11.4-10c-0.4-5.9,4.1-11,10-11.4c5.9-0.4,11,4.1,11.4,10
          C110.5,19.8,106,24.9,100.1,25.3z M98.9,7.3c-4,0.3-7.1,3.7-6.8,7.8c0.3,4,3.7,7.1,7.8,6.8c4-0.3,7.1-3.7,6.8-7.8
          C106.4,10.1,102.9,7.1,98.9,7.3z"
      />
    </g>
  </svg>
);

export const pet_friendly = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 400 400"
    height="35px"
    width="35px"
  >
    <g id="XMLID_14_">
      <g id="XMLID_139_">
        <path
          d="M130.5,377.7c-40.4,0-75.5-28.7-83.6-68.2l-0.2-0.9l-0.8-0.4C17.4,293-0.6,262.4,0,230.2c0.9-46.6,39.1-84.5,85.1-84.6
          l0.2,0c5.4,0,10.1,3.7,11.5,9c1.3,4.9-0.8,9.9-5.2,12.4c-19.9,11.2-32.2,32.3-32.2,55.1c0,4.4,0.5,8.8,1.4,13.1l0.9,4.3l2.7-3.5
          c8.3-10.8,18.7-19.5,30.9-25.7l134.8-69.5c15.9-8.2,25.8-24.5,25.8-42.4V73.6c0-28.3,23-51.3,51.3-51.3c3.2,0,5.9,2.6,5.9,5.9
          v29.5h5.8c15.6,0,30.1,8.4,37.8,22l0.6,1h19.3c6.9,0,13.5,3,18,8.4c4.5,5.3,6.4,12.3,5.2,19.1l-2.9,16.9c-3,17.4-18,30-35.6,30
          h-29.8v32.7c0,28.8-5.4,57-16.1,83.7l-0.2,0.6l18.5,70.9l5.9,6.2c4.8,5,6,12,3.3,18.3c-2.7,6.3-8.7,10.3-15.6,10.3H130.5z
           M259.2,233.7c3.2,0,5.9,2.6,5.9,5.9v36.9l34.5,89.5h27.7c2.1,0,3.9-1.2,4.8-3.1c0.8-2,0.5-4.1-1-5.6l-6.9-7.3
          c-0.7-0.7-1.2-1.6-1.4-2.6l-19.4-74.2c-0.3-1.2-0.2-2.6,0.3-3.7c10.7-26,16.2-53.5,16.2-81.7v-38.6c0-3.2,2.6-5.9,5.9-5.9
          c0.1,0,0.1,0,0.2,0l0.2,0l0.1,0l35.1,0c11.9,0,22-8.5,24-20.2l2.9-16.9c0.6-3.4-0.4-6.9-2.6-9.6c-2.2-2.7-5.5-4.2-9-4.2h-23
          c-2.4,0-4.5-1.4-5.4-3.6c-5-11.8-16.5-19.4-29.3-19.4h-11.6c-3.2,0-5.9-2.6-5.9-5.9V34.4l-2.4,0.5c-18.1,3.9-31.3,20.2-31.3,38.7
          v24.7c0,22.3-12.3,42.6-32.2,52.8l-134.8,69.5c-27,13.9-43.7,41.4-43.7,71.8c0,40.6,33,73.6,73.6,73.6h112.2l-0.6-2.5
          c-3.9-17.1-19.4-29.4-36.9-29.4h-73.5c-3.2,0-5.9-2.6-5.9-5.9s2.6-5.9,5.9-5.9h51l-3.5-20.6c-2.8-16.7-15.4-29.8-32-33.3
          l-14.9-3.2c-3.2-0.7-5.2-3.8-4.5-7c0.6-2.7,3-4.7,5.7-4.7c0.4,0,0.8,0,1.2,0.1l14.9,3.2c21.3,4.5,37.5,21.4,41.1,42.9l3.8,22.6
          h10.6c24.2,0,45.3,18,48.9,41.9l0.3,1.7H287l-33.3-86.3c-0.3-0.7-0.4-1.4-0.4-2.1v-38C253.3,236.4,255.9,233.7,259.2,233.7z
           M77,157.8c-36.5,4.2-64.6,35.4-65.3,72.6c-0.5,24.1,10.8,47.1,30.2,61.5l3.1,2.3l0.1-3.9c0.3-12.9,3.2-25.3,8.6-37l0.4-0.8
          l-0.4-0.8c-4.1-9.4-6.1-19.4-6.1-29.7c0-23.8,11.5-46.5,30.8-60.5l6.2-4.5L77,157.8z"
        />
        <path
          d="M321.2,106.2c-2.1,0-4.1-0.8-5.6-2.3c-1.5-1.5-2.3-3.5-2.3-5.6c0-2.1,0.8-4.1,2.3-5.6c1.5-1.5,3.5-2.3,5.6-2.3
          c2.1,0,4.1,0.8,5.6,2.3c1.5,1.5,2.3,3.5,2.3,5.6c0,2.1-0.8,4.1-2.3,5.6C325.4,105.3,323.3,106.2,321.2,106.2z"
        />
      </g>
    </g>
  </svg>
);

export const washer_dryer = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 400 400"
    height="35px"
    width="35px"
  >
    <g>
      <g>
        <g>
          <g>
            <path
              d="M72.7,400c-14.9,0-27-12.1-27-27l0-346.1c0-14.9,12.1-27,27-27h254.6c14.9,0,27,12.1,27,27V373c0,14.9-12.1,27-27,27
          H72.7z M57.5,373c0,8.4,6.8,15.2,15.2,15.2h254.6c8.4,0,15.2-6.8,15.2-15.2V92.9H57.5L57.5,373z M72.7,11.8
          c-8.4,0-15.2,6.8-15.2,15.2v54.2h284.9V27c0-8.4-6.8-15.2-15.2-15.2H72.7z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M200,320.9c-44.3,0-80.3-36-80.3-80.3s36-80.3,80.3-80.3c22.1,0,42.8,8.8,58.1,24.9c2.2,2.3,2.2,5.9,0,8.1
          c-12.2,12.8-18.9,29.6-18.9,47.3c0,17.7,6.7,34.5,18.9,47.3c2.2,2.3,2.2,5.9,0,8.1C242.8,312.1,222.1,320.9,200,320.9z
           M200,172.1c-37.8,0-68.5,30.7-68.5,68.5s30.7,68.5,68.5,68.5c16.6,0,32.5-6,44.9-16.8l0.7-0.6l-0.6-0.8
          c-11.4-14.2-17.7-32-17.7-50.3s6.3-36.1,17.7-50.3l0.6-0.8l-0.7-0.6C232.5,178.1,216.6,172.1,200,172.1z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M296.1,69.4c-13.1,0-23.8-10.7-23.8-23.8s10.7-23.8,23.8-23.8c13.1,0,23.8,10.7,23.8,23.8S309.2,69.4,296.1,69.4z
           M296.1,33.6c-6.6,0-12,5.4-12,12s5.4,12,12,12s12-5.4,12-12S302.7,33.6,296.1,33.6z"
            />
          </g>
        </g>
        <g>
          <g>
            <path d="M95.4,51.4c-3.3,0-5.9-2.6-5.9-5.9c0-3.3,2.6-5.9,5.9-5.9H123c3.3,0,5.9,2.6,5.9,5.9c0,3.3-2.6,5.9-5.9,5.9H95.4z" />
          </g>
        </g>
        <g>
          <g>
            <path d="M156,51.4c-3.3,0-5.9-2.6-5.9-5.9c0-3.3,2.6-5.9,5.9-5.9h27.6c3.3,0,5.9,2.6,5.9,5.9c0,3.3-2.6,5.9-5.9,5.9H156z" />
          </g>
        </g>
      </g>
      <circle
        className="st6"
        cx="200"
        cy="240.4"
        r="105.7"
        fill="none"
        stroke="black"
        strokeWidth="10px"
      />
    </g>
  </svg>
);

export const guest_house = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 400 400"
    width="35px"
    height="35px"
  >
    <g>
      <g>
        <g>
          <path
            className="st5"
            d="M200,237.1c-6.2,0-11.9-2.3-16.3-6.5c-1.9-1.8-1.9-4.8-0.1-6.7c0.9-0.9,2.1-1.4,3.4-1.4
          c1.2,0,2.4,0.5,3.3,1.3c2.6,2.5,6,3.9,9.7,3.9s7.1-1.4,9.7-3.9c0.9-0.9,2.1-1.3,3.3-1.3c1.3,0,2.5,0.5,3.4,1.4
          c1.8,1.9,1.8,4.9-0.1,6.7C211.9,234.8,206.2,237.1,200,237.1z"
          />
          <g>
            <path
              className="st5"
              d="M234.7,400c-2.6,0-4.7-2.1-4.7-4.7s2.1-4.7,4.7-4.7h12.4v-34.3c0-2.6,2.1-4.7,4.7-4.7
          c2.6,0,4.7,2.1,4.7,4.7v34.3h31.9v-62.9c-0.5-28.5-20.2-35.9-50.3-44c-2.5-0.7-5-1.4-7.5-2.1l-2.8-0.8l-0.9,2.7
          c-3.9,11.7-14.8,19.6-27.1,19.6c-12.3,0-23.3-7.9-27.2-19.6l-0.9-2.7l-2.8,0.8c-2.5,0.7-5,1.4-7.5,2.1
          c-30.1,8.1-49.8,15.5-50.3,44l0,63h31.9v-34.3c0-2.6,2.1-4.7,4.7-4.7s4.7,2.1,4.7,4.7v34.3h12.4c2.6,0,4.7,2.1,4.7,4.7
          s-2.1,4.7-4.7,4.7h-58.6c-2.6,0-4.7-2.1-4.7-4.7l0-67.8c0.6-37.8,30.7-45.9,57.3-53c3.3-0.9,6.7-1.8,10-2.8l2.2-0.6v-9.2
          l-1.6-0.9c-20.5-11.1-33.2-32.5-33.2-55.7v-30.7c0-35,28.4-63.4,63.4-63.4c34.9,0,63.4,28.4,63.4,63.4v30.7
          c0,23.2-12.7,44.6-33.2,55.7l-1.6,0.9v9.2l2.2,0.6c3.2,0.9,6.5,1.8,10,2.8c18.4,5,39.2,10.6,50,26.8c4.4,8.5,7.3,16.2,7.3,26.4
          V400H234.7z M180.9,274.5c0,10.6,8.6,19.1,19.1,19.1c10.5,0,19.1-8.6,19.1-19.1v-8.6l-3.7,0.9c-5,1.3-10.2,1.9-15.4,1.9
          c-5.2,0-10.4-0.6-15.4-1.9l-3.7-0.9V274.5z M181,182.1c-9.4,9-21,10.9-32.2,12.2l-2.7,0.3v10.7c0,29.7,24.2,53.9,53.9,53.9
          c29.7,0,53.9-24.2,53.9-53.9v-10.3l-3.1,0.1c-2,0.1-4,0.1-5.9,0.1c-24.3,0-44.6-4.5-60.4-13.5l-1.9-1.1L181,182.1z M181.6,169.5
          c1,0,1.9,0.3,2.7,0.8c14.8,10.1,35.2,15.3,60.5,15.3c2.1,0,4.2,0,6.2-0.1l2.9-0.1v-10.9c0-29.7-24.2-53.9-53.9-53.9
          c-29.7,0-53.9,24.2-53.9,53.9V185l3.4-0.4c10.6-1.3,20.7-3.2,28.4-13.3C178.7,170.2,180.1,169.5,181.6,169.5z"
            />
          </g>
        </g>
      </g>
      <g>
        <g>
          <path
            className="st5"
            d="M367.8,181.2c0,2.1,0,3.7,0,5.3c0,68.3,0,136.6,0,204.9c0,7.5-1.1,8.6-8.6,8.6c-106.1,0-212.2,0-318.3,0
          c-0.5,0-1,0-1.5,0c-5.5,0-7.1-1.6-7.1-7.1c0-45.9,0-91.8,0-137.7c0-23.1,0-46.3,0-69.4c0-1.3,0-2.6,0-4.5c-3.8,0-7.4,0-10.9,0
          c-4.8,0-9.7-0.1-14.5,0c-2.7,0.1-5.2-0.2-6.3-3.1c-1.1-2.8,0.4-4.8,2.4-6.6c12.9-11.3,25.8-22.7,38.8-34c23-20.2,46-40.4,69-60.6
          C139,51.9,167.4,27,195.8,2.1c3.2-2.8,5.2-2.8,8.9,0.4c14.8,12.9,29.5,25.9,44.2,38.8c29.1,25.6,58.2,51.1,87.3,76.7
          c20.4,17.9,40.7,35.8,61.1,53.7c1.9,1.7,3.3,3.6,2.2,6.3c-1.1,2.6-3.2,3.2-5.9,3.2C385.2,181.2,376.7,181.2,367.8,181.2z
           M200,11.6c-60.5,53.2-120.7,106-180.8,158.9c5.1,0.8,9.8,0.8,14.5,0.8c7.5,0,8.7,1.1,8.7,8.5c0,68.4,0,136.8,0,205.3
          c0,1.5,0,3.1,0,4.7c105.4,0,210.3,0,315.4,0c0-1.8,0-3.4,0-5c0-68.1,0-136.1,0-204.2c0-1.1,0-2.2,0-3.3c0.1-4.3,1.5-5.9,5.9-6
          c4.8-0.1,9.7,0,14.5-0.1c0.8,0,1.7-0.2,3.1-0.4C320.6,117.6,260.4,64.7,200,11.6z"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const small_group = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 400 400"
    height="35px"
    width="35px"
  >
    <g>
      <g>
        <path
          d="M262.3,363.2h131.8c3.2,0,5.9-2.6,5.9-5.9V248.9c0-3.2-2.6-5.9-5.9-5.9s-5.9,2.6-5.9,5.9v102.6h-85.4V280
          c0-22.7-12.7-43.2-32-53.7c4.5-7.8,12.9-12.8,22.2-12.8h69.4c14.2,0,25.7,11.5,25.7,25.7v14.3c0,3.2,2.6,5.9,5.9,5.9h0
          c3.2,0,5.9-2.6,5.9-5.9v-14.3c0-20.6-16.8-37.4-37.4-37.4h-4.3c9.2-8.3,14.9-20.3,14.9-33.6c0-25-20.3-45.3-45.3-45.3
          c-25,0-45.3,20.3-45.3,45.3c0,13.3,5.8,25.3,14.9,33.6h-4.3c-14,0-26.7,7.8-33.1,19.9c-0.8-0.2-1.6-0.5-2.4-0.7l-31.3-8.4V196
          c14.8-8.8,24.8-24.9,25.2-43.2h6.8c10.2,0,18.5-8.3,18.5-18.5c0-8.7-6.1-16-14.2-18v-16c0-35-28.5-63.5-63.5-63.5
          s-63.5,28.5-63.5,63.5v16.4c-7.3,2.5-12.6,9.4-12.6,17.5c0,10.2,8.3,18.5,18.5,18.5h6.8c0.4,18.4,10.4,34.4,25.2,43.2v16.6
          l-31.3,8.4c-0.8,0.2-1.6,0.4-2.4,0.7c-6.4-12.1-19.1-19.9-33.1-19.9h-4.3c9.2-8.3,14.9-20.3,14.9-33.6c0-25-20.3-45.3-45.3-45.3
          s-45.3,20.3-45.3,45.3c0,13.3,5.8,25.3,14.9,33.6h-4.3C16.8,201.8,0,218.5,0,239.2v14.3c0,3.2,2.6,5.9,5.9,5.9s5.9-2.6,5.9-5.9
          v-14.3c0-14.2,11.5-25.7,25.7-25.7h69.4c9.3,0,17.7,5,22.2,12.8c-19.4,10.5-32,31-32,53.7v71.5H11.7V248.9c0-3.2-2.6-5.9-5.9-5.9
          S0,245.6,0,248.9v108.4c0,3.2,2.6,5.9,5.9,5.9h131.8H262.3z M38.6,168.2c0-18.5,15.1-33.6,33.6-33.6s33.6,15.1,33.6,33.6
          c0,18.5-15,33.5-33.5,33.6H72C53.6,201.7,38.6,186.6,38.6,168.2L38.6,168.2z M187.6,240.3l-5.7,4.7c-2.6,2.2-6,2.9-9.3,1.8
          c-3.3-1-5.7-3.5-6.6-6.8l-3.4-12.4l12.1-3.2C176.7,231.3,181.4,237,187.6,240.3L187.6,240.3z M225.3,224.4l12.1,3.2l-3.4,12.4
          c-0.9,3.3-3.3,5.8-6.6,6.8c-3.3,1-6.7,0.4-9.3-1.8l-5.7-4.7C218.6,237,223.3,231.3,225.3,224.4L225.3,224.4z M265.2,134.2
          c0,3.7-3,6.8-6.8,6.8h-6.8v-13.5h5.2h1.6C262.1,127.5,265.2,130.5,265.2,134.2z M147.5,100.3c0-28.5,23.2-51.8,51.8-51.8
          c28.5,0,51.8,23.2,51.8,51.8v15.4h-19.4c-5.5,0-9.9-4.5-9.9-9.9c0-3.2-2.6-5.9-5.9-5.9s-5.9,2.6-5.9,5.9c0,5.5-4.5,9.9-9.9,9.9
          h-52.5L147.5,100.3z M134.8,134.2c0-3.7,3-6.8,6.8-6.8h6.8V141h-6.8C137.9,141,134.8,138,134.8,134.2z M160.1,151.6v-24.1H200
          c6.2,0,11.8-2.6,15.8-6.8c4,4.2,9.6,6.8,15.8,6.8h8.3v24.1c0,22-17.9,39.9-39.9,39.9S160.1,173.6,160.1,151.6z M200,203.2
          c5.1,0,10-0.8,14.7-2.1v16c0,8.1-6.6,14.7-14.7,14.7s-14.7-6.6-14.7-14.7v-16C190,202.5,194.9,203.2,200,203.2z M147,351.5h-38.2
          V280c0-22.3,15-41.9,36.6-47.7l5.8-1.6l3.5,12.5c2,7.1,7.4,12.7,14.4,14.9c2.1,0.7,4.3,1,6.5,1c5,0,9.9-1.7,13.8-5l10.6-8.8
          l10.6,8.8c4,3.3,8.8,5,13.8,5c2.2,0,4.4-0.3,6.5-1c7-2.2,12.4-7.8,14.4-14.9l3.5-12.5l5.8,1.6c21.5,5.8,36.6,25.4,36.6,47.7v71.5
          H253H147z M294.2,168.2c0-18.5,15.1-33.6,33.6-33.6c18.5,0,33.6,15.1,33.6,33.6c0,18.5-15,33.5-33.5,33.6h-0.2
          C309.3,201.7,294.2,186.6,294.2,168.2L294.2,168.2z"
        />
      </g>
    </g>
  </svg>
);

export const workspace = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 400 400"
    height="35px"
    width="35px"
  >
    <g>
      <g>
        <g>
          <path
            d="M393.3,241.7H372l-5.4-21.5c-0.7-3-3.4-5-6.4-5h-22.1l29-53.9c14.2,3.5,28.6-5.2,32.1-19.4c3.5-14.2-5.2-28.6-19.4-32.1
          c-2.1-0.5-4.2-0.8-6.4-0.8c-1.9,0-3.7,0.2-5.5,0.6l-48.7-98.3c-1.6-3.3-5.6-4.6-8.9-3c0,0,0,0,0,0l-36,18.2
          c-21.1-17.9-52.4-16.7-72,2.9c-2.6,2.6-2.6,6.8,0,9.4c0,0,0,0,0,0l65.7,65.7c2.6,2.6,6.8,2.6,9.4,0c0,0,0,0,0,0
          c18.1-18.1,20.7-46.7,6.1-67.7l26.8-13.5l45.8,92.4c-11.1,9.6-12.3,26.3-2.7,37.4c0.7,0.8,1.3,1.5,2.1,2.2L323,215.2h-29.2
          c-3,0-5.7,2.1-6.4,5l-5.4,21.5H170l-3.3-13.3h47.9c12.8,0,23.2-10.4,23.2-23.2v-95.4c0-12.8-10.4-23.2-23.2-23.2H48.6
          c-12.8,0-23.2,10.4-23.2,23.2v95.4c0,12.8,10.4,23.2,23.2,23.2h47.9l-3.3,13.3H6.6c-3.7,0-6.6,3-6.6,6.6v26.5
          c0,3.7,3,6.6,6.6,6.6h15.1h345.1h26.5c3.7,0,6.6-3,6.6-6.6v-26.5C400,244.7,397,241.7,393.3,241.7z M272.3,89.9l-55.5-55.5
          c15.7-11.1,37.1-9.5,50.9,3.9c0.4,0.6,0.9,1.1,1.4,1.5C281.9,53.6,283.2,74.5,272.3,89.9z M373.4,122.2c7.3,0,13.3,5.9,13.3,13.3
          s-5.9,13.3-13.3,13.3s-13.3-5.9-13.3-13.3C360.2,128.2,366.1,122.2,373.4,122.2z M299,228.4h56l3.3,13.3h-62.6L299,228.4z
           M38.7,109.8c0-5.5,4.5-10,10-10h165.9c5.5,0,10,4.5,10,10v85.4H38.7V109.8z M48.6,215.2c-4.2,0-8-2.7-9.4-6.6h184.7
          c-1.4,4-5.2,6.6-9.4,6.6H48.6z M156.3,241.7h-49.4l3.3-13.3h42.7L156.3,241.7z M386.7,268.2H13.3V255h373.4V268.2z"
          />
        </g>
      </g>
      <g>
        <path
          d="M63.7,392.5c-3.8,0-6.9-3.1-6.9-6.9V280.5c0-3.8,3.1-6.9,6.9-6.9c3.8,0,6.9,3.1,6.9,6.9v105.1
          C70.6,389.4,67.5,392.5,63.7,392.5z"
        />
      </g>
      <g>
        <path
          d="M337.3,392.5c-3.8,0-6.9-3.1-6.9-6.9V280.5c0-3.8,3.1-6.9,6.9-6.9s6.9,3.1,6.9,6.9v105.1
          C344.2,389.4,341.1,392.5,337.3,392.5z"
        />
      </g>
    </g>
  </svg>
);

export const ocean_view = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 400 400"
    height="35px"
    width="35px"
  >
    <g>
      <g>
        <path
          className="st2"
          d="M284.4,223.1c-15,0-29.6-5.3-40-14.6l-2.4-2.1l-2.4,2.1c-10.4,9.3-25,14.6-40,14.6c-15,0-29.6-5.3-40-14.6
          l-2.4-2.1l-2.4,2.1c-10.4,9.3-25,14.6-40,14.6c-18.3,0-35.4-7.7-45.7-20.6c-1.5-1.8-1.2-4.5,0.7-6c0.8-0.6,1.7-0.9,2.7-0.9
          c1.3,0,2.5,0.6,3.3,1.6c8.7,10.9,23.3,17.4,39,17.4c15.7,0,30.3-6.5,39-17.4c0,0,0,0,0,0l0,0c0.3-0.4,0.5-0.6,0.7-0.7
          c0.7-0.5,1.5-0.8,2.3-0.9c0.2,0,0.3,0,0.3,0c0.1,0,0.2,0,0.3,0c1.3,0.1,2.4,0.7,3.1,1.6c8.7,10.9,23.3,17.4,39,17.4
          s30.3-6.5,39-17.4c0.7-0.9,1.8-1.5,3-1.6l0.1,0c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.2,0c1.3,0.1,2.4,0.7,3.1,1.6
          c8.7,10.9,23.3,17.4,39,17.4c15.7,0,30.3-6.5,39-17.4c0.8-1,2-1.6,3.3-1.6c1,0,1.9,0.3,2.7,0.9c0.9,0.7,1.5,1.7,1.6,2.9
          s-0.2,2.3-0.9,3.1C319.8,215.4,302.7,223.1,284.4,223.1z"
        />
      </g>
      <g>
        <path
          className="st2"
          d="M284.4,270.3c-15,0-29.6-5.3-40-14.6l-2.4-2.1l-2.4,2.1c-10.4,9.3-25,14.6-40,14.6c-15,0-29.6-5.3-40-14.6
          l-2.4-2.1l-2.4,2.1c-10.4,9.3-25,14.6-40,14.6c-18.3,0-35.4-7.7-45.7-20.6c-1.5-1.8-1.2-4.5,0.7-6c0.8-0.6,1.7-0.9,2.7-0.9
          c1.3,0,2.5,0.6,3.3,1.6c8.7,10.9,23.3,17.4,39,17.4c15.7,0,30.3-6.5,39-17.4c0,0,0,0,0,0l0,0c0.3-0.4,0.5-0.6,0.7-0.7
          c0.7-0.5,1.5-0.8,2.3-0.9c0.2,0,0.3,0,0.3,0c0.1,0,0.2,0,0.3,0c1.3,0.1,2.4,0.7,3.1,1.6c8.7,10.9,23.3,17.4,39,17.4
          s30.3-6.5,39-17.4c0.7-0.9,1.8-1.5,3-1.6l0.1,0c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.2,0c1.3,0.1,2.4,0.7,3.1,1.6
          c8.7,10.9,23.3,17.4,39,17.4c15.7,0,30.3-6.5,39-17.4c0.8-1,2-1.6,3.3-1.6c1,0,1.9,0.3,2.7,0.9c0.9,0.7,1.5,1.7,1.6,2.9
          c0.1,1.1-0.2,2.3-0.9,3.1C319.8,262.6,302.7,270.3,284.4,270.3z"
        />
      </g>
      <g>
        <path
          d="M371,331.1h-5.7V29c0-3.1-2.6-5.7-5.7-5.7H40.4c-3.1,0-5.7,2.6-5.7,5.7v302.2H29c-3.1,0-5.7,2.6-5.7,5.7V371
          c0,3.1,2.6,5.7,5.7,5.7H371c3.1,0,5.7-2.6,5.7-5.7v-34.2C376.7,333.7,374.2,331.1,371,331.1z M46.1,34.7h307.9v296.5H46.1V34.7z
           M365.3,365.3H34.7v-22.8h330.7V365.3z"
        />
        <path
          d="M210.8,312.6h118.9c3,0,5.4-2.4,5.4-5.4V58.6c0-3-2.4-5.4-5.4-5.4H210.8h-21.6H70.3c-3,0-5.4,2.4-5.4,5.4v248.7
          c0,3,2.4,5.4,5.4,5.4h118.9H210.8z M183.8,301.8H75.7V64h108.1h32.4h108.1v237.9H216.2H183.8z"
        />
      </g>
      <path
        className="st2"
        d="M65.8,160.8h45.1c2,0,3.9-0.8,5.3-2.2c1.5-1.4,2.3-3.3,2.3-5.4c0-4.2-3.4-7.6-7.6-7.6h-5.6
          c-2,0-3.7-1.7-3.7-3.7c0-7.3-5.9-13.2-13.2-13.2c-7.3,0-13.2,5.9-13.2,13.2c0,2-1.7,3.7-3.7,3.7l-5.6-7.4H68l0.4-1.5
          c2.3-9.1,10.5-15.4,19.9-15.4c9.4,0,17.6,6.3,19.9,15.4l0.4,1.5h2.2c8.2,0,15,6.7,15,15c0,4-1.6,7.8-4.4,10.6
          c-2.8,2.8-6.5,4.4-10.5,4.4H65.8V160.8z"
      />
      <path
        d="M223.5,138.7c-10.1,0-18.2-8.2-18.2-18.2c0-4.9,1.9-9.5,5.4-12.9c3.4-3.5,7.9-5.3,12.8-5.3h2.7l0.5-1.8
          c2.9-11.1,12.9-18.8,24.3-18.8c11.4,0,21.4,7.7,24.3,18.8l0.5,1.8h2.7c10.1,0,18.2,8.2,18.2,18.2c0,4.9-1.9,9.5-5.4,12.9
          c-3.4,3.4-7.9,5.3-12.8,5.3H223.5z M223.5,111.3c-2.5,0-4.8,1-6.4,2.7c-1.8,1.8-2.8,4-2.8,6.5c0,5.1,4.1,9.2,9.2,9.2h54.9
          c2.5,0,4.8-1,6.4-2.7c1.8-1.8,2.8-4,2.8-6.5c0-5.1-4.1-9.2-9.2-9.2h-6.9c-2.5,0-4.5-2-4.5-4.5c0-8.9-7.2-16.1-16.1-16.1
          c-8.9,0-16.1,7.2-16.1,16.1c0,2.5-2,4.5-4.5,4.5H223.5z"
      />
    </g>
  </svg>
);

export const toiletries = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 400 400"
    height="35px"
    width="35px"
  >
    <g>
      <path
        d="M334,175l-13.9-11.9c-7.3-6.3-11.5-15.4-11.5-25v-1.6c3.6,0,6.6-3,6.6-6.6v-26.4c0-11-8.8-19.8-19.8-19.8H269
      c-11,0-19.8,8.8-19.8,19.8v26.4c0,3.6,3,6.6,6.6,6.6v1.6c0,9.6-4.2,18.8-11.5,25L230.4,175c-13.2,11.3-20.8,27.7-20.8,45v133.9
      c0,25.4,20.7,46.1,46.1,46.1h52.7c25.4,0,46.1-20.7,46.1-46.1V220C354.7,202.7,347.2,186.2,334,175z M262.5,103.5
      c0-3.6,3-6.6,6.6-6.6h26.4c3.6,0,6.6,3,6.6,6.6v19.8h-39.5v-19.8H262.5z M341.6,353.9c0,18.2-14.7,32.9-32.9,32.9H256
      c-18.2,0-32.9-14.7-32.9-32.9V220c0-13.5,5.8-26.3,16.1-35l13.8-12c10.2-8.7,16.1-21.6,16.1-35v-1.6h26.4v1.6
      c0,13.4,5.8,26.3,16.1,35l13.9,11.9c10.2,8.7,16.1,21.6,16.1,35v133.9l0,0V353.9z"
      />
      <path
        d="M97,340.7c-25.4,0-46.1-20.7-46.1-46.1v-36.4c0-25.4,20.7-46.1,46.1-46.1s46.1,20.7,46.1,46.1v36.4
      C143,320,122.4,340.7,97,340.7z M97,225.2c-18.2,0-33,14.8-33,33v36.4c0,18.2,14.7,32.9,32.9,32.9s32.9-14.7,32.9-32.9v-36.4
      C129.8,240,115.1,225.2,97,225.2z"
      />
      <path
        d="M282.3,320.9c-21.8,0-39.5-17.7-39.5-39.5v-13.2c0-21.8,17.7-39.5,39.5-39.5s39.5,17.7,39.5,39.5v13.2
      C321.7,303.2,304.1,320.9,282.3,320.9z M282.3,241.9c-14.6,0-26.4,11.8-26.4,26.4v13.2c0,14.6,11.8,26.4,26.4,26.4
      s26.4-11.8,26.4-26.4v-13.2C308.6,253.7,296.8,241.9,282.3,241.9z"
      />
      <path
        d="M314.9,46.9c-11,0-19.8-8.8-19.8-19.8s8.8-19.8,19.8-19.8s19.8,8.8,19.8,19.8S325.8,46.9,314.9,46.9z M314.9,20.5
      c-3.6,0-6.6,3-6.6,6.6s3,6.6,6.6,6.6s6.6-3,6.6-6.6S318.5,20.5,314.9,20.5z"
      />
      <path
        d="M362.3,97.6c-14.6,0-26.4-11.8-26.4-26.4s11.8-26.4,26.4-26.4s26.4,11.8,26.4,26.4S376.9,97.6,362.3,97.6z M362.3,58.1
      c-7.2,0-13.2,5.9-13.2,13.2s5.9,13.2,13.2,13.2c7.2,0,13.2-5.9,13.2-13.2S369.6,58.1,362.3,58.1z"
      />
      <path
        d="M169.4,0H64C53,0,44.2,11.1,44.2,22.1S53.1,44.2,64,44.2h6.6v29.5H64c-3.6,0-6.6,3-6.6,6.6v39.5c0,3.6,3,6.6,6.6,6.6v3.5
      c0,7.5-4.2,14.3-11,17.7l-1.7,0.8c-24.6,12.2-40.2,37.3-40,64.8v140.7c0,25.4,20.7,46.1,46.1,46.1h79.1c25.4,0,46.1-20.7,46.1-46.1
      V213.2c0.1-27.5-15.5-52.6-40-64.8l-1.7-0.8c-6.7-3.3-11-10.2-11-17.7v-3.5c3.6,0,6.6-3,6.6-6.6V80.3c0-3.6-3-6.6-6.6-6.6h-6.6
      V44.2h43.8c3.6,0,6.6,3,6.6,6.6V64c0,3.6,3,6.6,6.6,6.6H209c3.6,0,6.6-3,6.6-6.6V46.1C215.5,20.7,194.9,0,169.4,0z M70.6,86.9h52.7
      v26.4H70.6V86.9z M134.9,159.4l1.7,0.8c20.2,10,32.9,30.6,32.8,53v140.7c0,18.2-14.7,32.9-32.9,32.9H57.4
      c-18.2,0-32.9-14.7-32.9-32.9V213.2c-0.1-22.5,12.6-43,32.8-53l1.7-0.8c11.2-5.5,18.3-17,18.2-29.5v-3.5h39.5v3.5
      C116.7,142.4,123.7,153.8,134.9,159.4z M110.2,73.7H83.8V44.2h26.4C110.2,44.2,110.2,73.7,110.2,73.7z M202.4,57.4h-15.5v-6.6
      c0-11-8.8-19.8-19.8-19.8H64c-3.6,0-6.6-5.3-6.6-8.9s3-8.9,6.6-8.9h105.4c18.2,0,32.9,14.7,32.9,32.9v11.3H202.4z"
      />
    </g>
  </svg>
);

export const media_room = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 400 400"
    height="35px"
    width="35px"
  >
    <g>
      <g>
        <path
          d="M319.2,366h-57.9v-44.5H365c12.7,0,23.2-10.4,23.2-23.2V100.8c0-12.7-10.4-23.2-23.2-23.2H221.6l36.1-45.9
          c1.9-2.4,1.5-5.8-0.9-7.8c-2.4-1.9-5.8-1.5-7.8,0.9l-41.5,52.6h-14.9l-41.5-52.6c-1.9-2.4-5.4-2.8-7.8-0.9
          c-2.4,1.9-2.8,5.4-0.9,7.8l36.1,45.9L35.1,77.5C22.3,77.6,11.9,88,11.9,100.7v57c4.8,5.5,11,2.2,11-2.7V101c0-3,1-6.1,3-8.3
          c2.3-2.7,5.6-4.1,9.1-4.1c7.1,0,321.2,0,329.9,0c6.7,0,12.1,5.4,12.1,12.1v197.7c0,3.2-1.2,6.3-3.6,8.5c-2.3,2.3-5.3,3.6-8.5,3.6
          H35c-6.7,0-12.1-5.4-12.1-12.1V140.1c0-3-2.5-5.5-5.5-5.5s-5.5,2.5-5.5,5.5v158.4c0,12.7,10.4,23.2,23.2,23.2h103.6v44.5H77.7
          l-0.4,11H319L319.2,366z M149.7,366v-44.5h100.7V366H149.7z"
        />
        <path
          d="M320.9,379H75.4l0.5-14.8h60.9v-40.7H35c-13.8,0-25-11.2-25-25V100.7c0-13.8,11.2-25,25-25l139.6,0.1L140.9,33
          c-1.2-1.5-1.8-3.4-1.6-5.4c0.2-2,1.2-3.8,2.8-4.9c1.5-1.2,3.4-1.8,5.4-1.5c2,0.2,3.8,1.2,4.9,2.8l40.9,51.9h13.1l41-51.9
          c2.6-3.2,7.1-3.7,10.4-1.2c3.2,2.6,3.7,7.1,1.2,10.4l-33.7,42.8H365c13.8,0,25,11.2,25,25v197.7c0,13.8-11.2,25-25,25H263.3v40.7
          h57.9L320.9,379z M79.2,375.2h238.1l0.1-7.3h-57.9v-48.2h105.4c11.7,0,21.3-9.5,21.3-21.3V100.8c0-11.7-9.5-21.3-21.3-21.3H217.7
          l38.5-48.8c1.2-1.6,0.9-3.9-0.6-5.1c-1.6-1.2-3.8-0.9-5.1,0.7l-42.1,53.3h-16.7l-42.1-53.4c-0.6-0.8-1.5-1.2-2.5-1.3
          c-0.9-0.1-1.9,0.2-2.7,0.8c-0.8,0.7-1.3,1.5-1.4,2.5s0.2,1.9,0.8,2.7l38.6,48.9L35,79.4c-11.7,0-21.3,9.5-21.3,21.3v33
          c1-0.6,2.4-0.9,3.7-0.9s2.6,0.4,3.7,0.9V101c0-3.6,1.2-7,3.5-9.5c2.7-3,6.5-4.7,10.4-4.7H365c7.7,0,14,6.3,14,14v197.7
          c0,3.7-1.4,7.2-4.1,9.9c-2.7,2.7-6.1,4.1-9.9,4.1H35c-7.7,0-14-6.3-14-14V161.5c-0.3,0.2-0.7,0.4-1,0.5c-2.1,0.8-4.3,0.6-6.3-0.4
          v137c0,11.7,9.5,21.3,21.3,21.3h105.4V368h-61L79.2,375.2z M24.8,155.1v143.4c0,5.6,4.6,10.3,10.3,10.3H365c2.8,0,5.3-1,7.2-3
          c2-2,3-4.6,3-7.2V100.7c0-5.6-4.6-10.3-10.3-10.3H35.1c-2.9,0-5.8,1.2-7.7,3.5c-1.7,1.9-2.6,4.4-2.6,7V155.1z M13.7,157
          c1.6,1.5,3.3,2.1,4.9,1.5c1.4-0.6,2.4-1.9,2.4-3.4v-14.9c0-2-1.6-3.7-3.7-3.7s-3.7,1.6-3.7,3.7L13.7,157L13.7,157z M252.2,367.9
          H147.8v-48.2h104.4V367.9z M151.6,364.2h97v-40.8h-97V364.2z"
        />
      </g>
      <g>
        <path
          d="M175.8,157.5c-4.2-2.7-9.6-2.9-14-0.6c-4.4,2.4-7.1,7-7.1,12.1v81.8c0,5,2.8,9.6,7.1,12.1c4.4,2.4,9.8,2.2,14-0.6
          l63.2-40.9c3.9-2.6,6.3-6.8,6.3-11.5c0-4.7-2.3-8.9-6.3-11.5L175.8,157.5z M170.3,247.3v-74.7L228,210L170.3,247.3z"
        />
      </g>
    </g>
  </svg>
);

export const beachfront = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 400 400"
    height="35px"
    width="35px"
  >
    <g>
      <g>
        <path
          className="st1"
          d="M174.5,240.6c0.1,0,0.1,0,0.2,0C174.6,240.6,174.6,240.6,174.5,240.6"
        />
        <path
          className="st1"
          d="M173.6,240.6c0.1,0,0.3,0,0.4,0C173.9,240.6,173.8,240.6,173.6,240.6"
        />
        <path
          className="st1"
          d="M251.2,240.6c0.2,0,0.3,0,0.5,0C251.5,240.6,251.4,240.6,251.2,240.6"
        />
        <path
          className="st1"
          d="M252.1,240.6c0,0,0.1,0,0.1,0C252.2,240.6,252.2,240.6,252.1,240.6"
        />
        <path
          className="st1"
          d="M173.6,353.5c0.1,0,0.3,0,0.4,0C173.9,353.5,173.8,353.5,173.6,353.5"
        />
        <path
          className="st1"
          d="M174.5,353.5c0.1,0,0.1,0,0.2,0C174.6,353.5,174.6,353.5,174.5,353.5"
        />
        <path
          className="st1"
          d="M252.1,353.5c0,0,0.1,0,0.1,0C252.2,353.5,252.2,353.5,252.1,353.5"
        />
        <path
          className="st1"
          d="M251.2,353.5c0.1,0,0.3,0,0.4,0C251.5,353.5,251.4,353.5,251.2,353.5"
        />
      </g>
      <g>
        <path
          className="st2"
          d="M329,302.3c-22.9,0-45.1-8.1-60.9-22.3l-3.6-3.2l-3.6,3.2c-15.8,14.1-38,22.3-60.9,22.3
          c-22.9,0-45.1-8.1-60.9-22.3l-3.6-3.2l-3.6,3.2c-15.8,14.1-38,22.3-60.9,22.3c-27.8,0-53.8-11.7-69.5-31.4c-2.2-2.8-1.8-6.9,1-9.2
          c1.2-0.9,2.6-1.4,4.1-1.4c2,0,3.9,0.9,5.1,2.4c13.3,16.6,35.5,26.5,59.4,26.5c23.9,0,46.1-9.9,59.4-26.5c0,0,0,0,0,0l0.1,0.1
          c0.5-0.5,0.8-0.9,1-1c1-0.8,2.2-1.3,3.5-1.4c0.3,0,0.5,0,0.5,0c0.2,0,0.3,0,0.4,0c2,0.2,3.6,1,4.7,2.4
          c13.3,16.6,35.5,26.5,59.4,26.5s46.1-9.9,59.4-26.5c1.1-1.4,2.7-2.3,4.6-2.4l0.2,0c0.2,0,0.3,0,0.4,0c0.1,0,0.2,0,0.4,0
          c2,0.1,3.6,1,4.7,2.4c13.3,16.6,35.5,26.5,59.4,26.5s46.1-9.9,59.4-26.5c1.2-1.6,3.1-2.4,5.1-2.4c1.5,0,2.9,0.5,4.1,1.4
          c1.4,1.1,2.2,2.6,2.4,4.4c0.2,1.7-0.3,3.4-1.4,4.8C382.8,290.6,356.9,302.3,329,302.3z"
        />
      </g>
      <g>
        <path
          className="st2"
          d="M329,374.2c-22.9,0-45.1-8.1-60.9-22.3l-3.6-3.2l-3.6,3.2c-15.8,14.1-38,22.3-60.9,22.3
          c-22.9,0-45.1-8.1-60.9-22.3l-3.6-3.2l-3.6,3.2c-15.8,14.1-38,22.3-60.9,22.3c-27.8,0-53.8-11.7-69.5-31.4c-2.2-2.8-1.8-6.9,1-9.2
          c1.2-0.9,2.6-1.4,4.1-1.4c2,0,3.9,0.9,5.1,2.4c13.3,16.6,35.5,26.5,59.4,26.5c23.9,0,46.1-9.9,59.4-26.5c0,0,0,0,0,0l0.1,0.1
          c0.5-0.5,0.8-0.9,1-1c1-0.8,2.2-1.3,3.5-1.4c0.3,0,0.5,0,0.5,0c0.2,0,0.3,0,0.4,0c2,0.2,3.6,1,4.7,2.4
          c13.3,16.6,35.5,26.5,59.4,26.5s46.1-9.9,59.4-26.5c1.1-1.4,2.7-2.3,4.6-2.4l0.2,0c0.2,0,0.3,0,0.4,0c0.1,0,0.2,0,0.4,0
          c2,0.1,3.6,1,4.7,2.4c13.3,16.6,35.5,26.5,59.4,26.5s46.1-9.9,59.4-26.5c1.2-1.6,3.1-2.4,5.1-2.4c1.5,0,2.9,0.5,4.1,1.4
          c1.4,1.1,2.2,2.6,2.4,4.4c0.2,1.7-0.3,3.4-1.4,4.8C382.8,362.5,356.9,374.2,329,374.2z"
        />
      </g>
      <g>
        <path
          fill="none"
          stroke="black"
          strokeWidth="10px"
          className="st3"
          d="M137,268.5c-20.7-18.7-33-46.3-31-76.3c3.4-51.9,48.3-91.3,100.2-87.8s91.3,48.3,87.8,100.2
          c-1.7,25.3-13.2,47.7-30.6,63.5"
        />
        <line
          className="st3"
          x1="200"
          y1="25.8"
          x2="200"
          y2="69.5"
          fill="none"
          stroke="black"
          strokeWidth="10px"
        />
        <line
          className="st3"
          x1="376"
          y1="201.8"
          x2="332.3"
          y2="201.8"
          fill="none"
          stroke="black"
          strokeWidth="10px"
        />
        <line
          className="st3"
          x1="67.7"
          y1="201.8"
          x2="24"
          y2="201.8"
          fill="none"
          stroke="black"
          strokeWidth="10px"
        />
        <line
          className="st3"
          x1="324.5"
          y1="77.4"
          x2="293.6"
          y2="108.3"
          fill="none"
          stroke="black"
          strokeWidth="10px"
        />
        <line
          className="st3"
          x1="106.4"
          y1="108.3"
          x2="75.5"
          y2="77.4"
          fill="none"
          stroke="black"
          strokeWidth="10px"
        />
        <line
          className="st3"
          x1="117.6"
          y1="159.6"
          x2="180.8"
          y2="159.6"
          fill="none"
          stroke="black"
          strokeWidth="10px"
        />
        <line
          className="st3"
          x1="105.8"
          y1="194.7"
          x2="149.6"
          y2="194.7"
          fill="none"
          stroke="black"
          strokeWidth="10px"
        />
      </g>
    </g>
  </svg>
);

export const concierge = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 400 400"
    height="35px"
    width="35px"
  >
    <g>
      <path
        className="st0"
        d="M0,390.3V379h22.7l0.9-5.6c5.6-34.8,26.6-41,27.6-41.2l94.1-25.7v-50.9l-2.3-2c-9.5-8.3-16.5-19-20.2-31
          l-1.5-4.7H82.7v37.9h19c3.1,0,5.6,2.5,5.6,5.6s-2.5,5.6-5.6,5.6H89.3c-9.9,0-17.9-8.1-17.9-17.9V113.8c0-25.6,14.1-51.9,38.7-72
          c25-20.5,57.8-32.1,90.1-32.1s65.1,11.8,90.1,32.1c24.5,20.1,38.6,46.3,38.6,72v73.9c0,16.7-13.6,30.2-30.2,30.2H279l-1.4,4.7
          c-3.7,12-10.7,22.6-20.1,31l-2.3,2v50.9l94,25.7c0.9,0.2,22.3,6.6,27.9,41.2l0.9,5.6h22v11.3L0,390.3L0,390.3z M53.4,343.3
          c-2.2,0.9-13.5,6.3-18,27.7l-1.7,8.1h333.1L365,371c-3.8-16.9-12.5-25.5-18.9-27.8l-0.2-0.1l-93.1-25.5l-2.7,3.7
          c-6.7,9-20.7,19.7-49.9,19.7c-29.3,0-43.4-10.7-50.1-19.8l-2.7-3.7l-93.5,25.7L53.4,343.3z M156.6,310.2l0.7,1.4
          c4.5,8.9,18.2,18.3,43.1,18.3c16.2,0,36-4.9,42.7-18.3l0.7-1.4V272l-11.4,11.6c-5.2,5.2-12.3,8.2-19.6,8.2c-0.3,0-0.6,0-0.9,0h-0.2
          c-3.6,0-6.8,0.1-10,0.1c-2.7,0.1-5.1,0.1-7.4,0.1c-12.5,0-19-1.2-26.3-8.5l-11.4-11.1V310.2z M200.2,70.2
          c-37.6,0-68.2,30.6-68.2,68.2v74.5l0.2,0.6c2.4,12.1,8.7,23.1,18,31.2c8.8,7.7,13.8,14.9,17.9,20.8c5.4,7.8,10.5,15,20.8,15h22.9
          c10.3,0,15.4-7.3,20.8-15c4.1-5.8,9.1-13,17.9-20.7c9.5-8.2,15.9-19.7,18-32.1l0.1-0.5v-73.7C268.4,100.8,237.8,70.2,200.2,70.2z
           M279.8,206.7h19c10.5,0,19-8.5,19-19v-43.6h-37.9L279.8,206.7L279.8,206.7z M82.7,206.7h37.9v-62.6H82.7V206.7z M200.2,58.9
          c19.1,0,37.6,6.9,52,19.4s23.9,29.9,26.6,48.7l0.8,5.7h38v-19c0-21.6-12.9-45.2-34.4-63.2c-23-19.1-52.5-29.7-83.1-29.7
          s-60.1,10.7-83,29.9c-21.5,17.9-34.4,41.5-34.4,63.2v19h38.1l0.8-5.7c2.7-18.9,12.1-36.2,26.6-48.7
          C162.6,65.8,181.1,58.9,200.2,58.9z"
      />
    </g>
  </svg>
);

export const wet_sauna = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 400 400"
    height="35px"
    width="35px"
  >
    <g>
      <g>
        <g>
          <path
            d="M375.7,183.7H52c-3,0-5.4,2.4-5.4,5.4c0,0.2,0,0.5,0,0.7l21.5,161.5v21.2c0,3,2.4,5.4,5.4,5.4h280.5c3,0,5.4-2.4,5.4-5.4
          v-21.2L381,189.8c0.2-1.5-0.3-3.1-1.3-4.3C378.7,184.4,377.2,183.7,375.7,183.7z M289.3,194.5h21.6V270h-21.6V194.5z
           M235.4,194.5h43.2V270h-43.2V194.5z M203,194.5h21.6V270H203V194.5z M149.1,194.5h43.2V270h-43.2V194.5z M116.7,194.5h21.6V270
          h-21.6V194.5z M58.2,194.5h47.8V270H68.2L58.2,194.5z M72.5,302.4h33.4v43.2H78.3L72.5,302.4z M348.7,367.1H79v-10.8h269.7V367.1
          z M116.7,345.6v-43.2h21.6v43.2H116.7z M149.1,345.6v-43.2h43.2v43.2H149.1z M203,345.6v-43.2h21.6v43.2H203z M235.4,345.6v-43.2
          h43.2v43.2H235.4z M289.3,345.6v-43.2h21.6v43.2H289.3z M349.3,345.6h-27.6v-43.2h33.4L349.3,345.6z M356.5,291.6H71.1l-1.4-10.8
          H358L356.5,291.6z M359.4,270h-37.7v-75.5h47.8L359.4,270z"
          />
          <path
            d="M193.8,171.4l7.6-7.6l-15.3-15.3c-3-3-4.7-7.2-4.7-11.4v-3.7c0-4.3,1.7-8.4,4.7-11.4l8.9-8.9c5.1-5,7.9-11.9,7.9-19.1
          v-3.7c0-7.2-2.8-14-7.9-19.1l-15.3-15.3l-7.6,7.6l15.3,15.3c3,3,4.7,7.2,4.7,11.4v3.7c0,4.3-1.7,8.4-4.7,11.4l-8.9,8.9
          c-5.1,5-7.9,11.9-7.9,19.1v3.7c0,7.2,2.8,14,7.9,19.1L193.8,171.4z"
          />
          <path
            d="M247.8,171.4l7.6-7.6l-15.3-15.3c-3-3-4.7-7.2-4.7-11.4v-3.7c0-4.3,1.7-8.4,4.7-11.4l8.9-8.9c5.1-5,7.9-11.9,7.9-19.1
          v-3.7c0-7.2-2.8-14-7.9-19.1l-15.3-15.3l-7.6,7.6l15.3,15.3c3,3,4.7,7.2,4.7,11.4v3.7c0,4.3-1.7,8.4-4.7,11.4l-8.9,8.9
          c-5.1,5-7.9,11.9-7.9,19.1v3.7c0,7.2,2.8,14,7.9,19.1L247.8,171.4z"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const bunk_room = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 400 400"
    height="35px"
    width="35px"
  >
    <g>
      <g>
        <path
          d="M361.8,373.2V333H38.2v40.2H0V26.8h38.2v80.4h19.9l-0.9-1.5c-2.3-3.9-3.6-8.4-3.6-12.9C53.6,78.6,65.2,67,79.4,67h40.2
          c14.2,0,25.8,11.6,25.8,25.8c0,4.5-1.3,9-3.6,12.9l-0.9,1.5h19.9V67h139.7c22.6,0,42.1,17,45.4,39.3l0.1,0.9h15.8V26.8H400v346.4
          H361.8z M373.2,361.8h15.4V333h-15.4V361.8z M11.4,361.8h15.4V333H11.4V361.8z M11.4,321.6h377.2v-42.2h-42.2v26.8H160.8v-26.8
          H11.4V321.6z M172.2,294.8H335v-21.1c0-19-15.5-34.5-34.5-34.5H172.2V294.8z M373.2,268h15.4v-95.8h-15.4V268z M300.5,227.8
          c22.6,0,42.1,17,45.4,39.3l0.1,0.9h15.8v-95.8H38.2V268h19.9l-0.9-1.5c-2.3-3.9-3.6-8.4-3.6-12.9c0-14.2,11.6-25.8,25.8-25.8h40.2
          c14.2,0,25.8,11.6,25.8,25.8c0,4.5-1.3,9-3.6,12.9l-0.9,1.5h19.9v-40.2H300.5z M79.4,239.2c-7.9,0-14.4,6.5-14.4,14.4
          c0,7.9,6.5,14.4,14.4,14.4h40.2c7.9,0,14.4-6.5,14.4-14.4c0-7.9-6.5-14.4-14.4-14.4H79.4z M11.4,268h15.4v-95.8H11.4V268z
           M11.4,160.8h377.2v-42.2h-42.2v26.8H160.8v-26.8H11.4V160.8z M172.2,134H335v-21.1c0-19-15.5-34.5-34.5-34.5H172.2V134z
           M373.2,107.2h15.4v-69h-15.4V107.2z M79.4,78.4c-7.9,0-14.4,6.5-14.4,14.4s6.5,14.4,14.4,14.4h40.2c7.9,0,14.4-6.5,14.4-14.4
          s-6.5-14.4-14.4-14.4H79.4z M11.4,107.2h15.4v-69H11.4V107.2z"
        />
      </g>
    </g>
  </svg>
);

export const house_mom = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 400 400"
    height="35px"
    width="35px"
  >
    <path
      d="M260.5,229.1h-121c-3.4,0-6.3,2.9-6.3,6.3V300c0,14.6,11.9,26.5,26.5,26.5h80.6c14.6,0,26.5-11.9,26.5-26.5v-64.6
          C266.8,231.9,264,229.1,260.5,229.1z M240.3,313.8h-80.6c-7.7,0-13.9-6.2-13.9-13.9v-28.1h80.4c3.4,0,6.3-2.9,6.3-6.3
          s-2.9-6.3-6.3-6.3h-80.4v-17.6h108.4v17.6h-6.7c-3.4,0-6.3,2.9-6.3,6.3s2.9,6.3,6.3,6.3h6.7v28.1
          C254.2,307.6,247.9,313.8,240.3,313.8z M325.7,377l-13.3-187.2c-0.3-3.3-3-5.9-6.3-5.9c-13.1,0-24.7-9.2-27.8-21.9V6.3
          c0-1.7-0.7-3.3-1.8-4.5S273.7,0,272,0h-33.3c-3.4,0-6.3,2.9-6.3,6.3v68.5h-64.7V6.3c0-3.4-2.9-6.3-6.3-6.3H128
          c-3.4,0-6.3,2.9-6.3,6.3v155.8C118.6,174.9,107,184,93.8,184c-3.3,0-6.1,2.5-6.3,5.9L74.3,377c-0.3,3,1.8,5.8,4.7,6.6l6.8,1.8
          c37.3,9.8,75.7,14.6,114.2,14.6s76.9-5,114.2-14.6l6.8-1.8C323.9,382.8,326,380.1,325.7,377z M311,373.2
          c-36.2,9.5-73.6,14.3-111,14.3s-74.8-4.8-111-14.3l-1.8-0.5l12.5-176.5c16.7-2.4,30.8-15.1,34.5-32c0.1-0.4,0.2-0.9,0.2-1.3V12.6
          h20.7v68.5c0,3.4,2.9,6.3,6.3,6.3h77.4c3.4,0,6.3-2.9,6.3-6.3V12.6h20.6v150.3c0,0.4,0.1,0.9,0.2,1.3c3.7,16.8,17.7,29.5,34.5,32
          l12.4,176.6L311,373.2z"
    />
  </svg>
);

export const couples = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 400 400"
    height="35px"
    width="35px"
  >
    <g>
      <g>
        <path
          className="st2"
          d="M100.5,171.5c-6.3,0-12.2-2.4-16.7-6.7c-1.9-1.9-2-5-0.1-6.9c0.9-1,2.2-1.5,3.5-1.5c0,0,0,0,0,0
          c1.3,0,2.5,0.5,3.4,1.4c2.6,2.6,6.2,4,9.9,4s7.3-1.4,9.9-4c0.9-0.9,2.1-1.4,3.4-1.4c1.3,0,2.6,0.5,3.5,1.5c1.9,1.9,1.8,5-0.1,6.9
          C112.8,169.1,106.8,171.5,100.5,171.5z"
        />
        <g>
          <path
            className="st2"
            d="M4.9,358.4c-2.7,0-4.9-2.2-4.9-4.9l0-89.5c0.6-38.7,31.5-47,58.7-54.4c3.4-0.9,6.9-1.9,10.3-2.8l2.2-0.6
          v-9.4l-1.6-0.9c-21-11.4-34-33.3-34-57.1v-31.5c0-35.8,29.1-65,65-65c35.8,0,64.9,29.1,64.9,65v31.5c0,23.8-13,45.7-34,57.1
          l-1.6,0.9v9.3l2.2,0.6c3.3,1,6.6,1.9,10.2,2.8l0.1,0c18.9,5.1,40.3,10.9,51.3,27.6l2.5,3.9l2.5-3.9c1.7-2.6,3.7-5,6-7.2l3.2-3.1
          l-4-1.9c-10.3-4.9-16.1-13.4-20.1-29.4c-0.6-2.5,0.8-5,3.2-5.8c35.8-11.8,43.3-36.2,43.3-54.5v-16.7c0-24.5,4.1-42.5,12.6-55
          c10-14.8,26.5-22.3,49-22.3c22.5,0,39,7.5,49,22.3c8.5,12.5,12.6,30.5,12.6,55v16.7c0,18.3,7.5,42.7,43.3,54.5
          c2.4,0.8,3.8,3.3,3.2,5.8c-4,16-9.8,24.5-20.1,29.4l-4,1.9l3.2,3.1c8.8,8.5,13.2,19.6,13.4,33.9l0,89.5c0,2.7-2.2,4.9-4.9,4.9
          H4.9z M238.6,288.7c2.7,0,4.9,2.2,4.9,4.9v55.1h96.6v-55.1c0-2.7,2.2-4.9,4.9-4.9c2.7,0,4.9,2.2,4.9,4.9v55.1h32.7v-84.4
          c-0.5-29.2-20.7-36.8-51.5-45.1c-2.5-0.7-5.1-1.4-7.7-2.1l-2.8-0.8l-0.9,2.8c-4,12-15.2,20.1-27.9,20.1
          c-12.7,0-23.8-8.1-27.8-20.1l-0.9-2.8l-2.8,0.8c-2.6,0.7-5.2,1.4-7.7,2.1c-30.8,8.3-51,15.9-51.5,45l0,84.5h32.7v-55.1
          C233.7,290.9,235.9,288.7,238.6,288.7z M153.7,288.7c2.7,0,4.9,2.2,4.9,4.9v55.1h32.7v-84.4c-0.5-29.2-20.7-36.8-51.5-45.1
          c-2.5-0.7-5.1-1.4-7.7-2.1l-2.8-0.8l-0.9,2.8c-4,12-15.2,20.1-27.8,20.1c-12.7,0-23.9-8.1-27.9-20.1l-0.9-2.8L69,217
          c-2.6,0.7-5.1,1.4-7.7,2.1c-30.8,8.3-51,15.9-51.5,45l0,84.5h32.7v-55.1c0-2.7,2.2-4.9,4.9-4.9s4.9,2.2,4.9,4.9v55.1h96.6v-55.1
          C148.8,290.9,151,288.7,153.7,288.7z M272.2,209.8c0,10.8,8.8,19.6,19.6,19.6c10.8,0,19.6-8.8,19.6-19.6V194l-3.8,1
          c-5.1,1.4-10.4,2.1-15.8,2.1c-5.3,0-10.6-0.7-15.7-2l-3.8-1V209.8z M81,209.8c0,10.8,8.8,19.6,19.6,19.6
          c10.8,0,19.6-8.8,19.6-19.6V201l-3.8,0.9c-5.2,1.3-10.5,1.9-15.8,1.9c-5.3,0-10.6-0.7-15.8-2L81,201V209.8z M232.9,165.9
          c-8.8,16.7-24.4,25.9-35.9,30.7l-2.6,1.1l0.9,2.7c4.1,12,10.1,16.8,23.9,19.1l0.9,0.2l0.9-0.4c9.3-4.3,19.8-7.1,29-9.6
          c3.6-1,7-1.9,10.3-2.8l2.2-0.6l0-16.6l-1.5-0.9c-9.5-5.5-17.3-13.4-22.7-22.9l-2.7-4.8L232.9,165.9z M345.3,165.8
          c-5.4,9.5-13.2,17.4-22.7,22.9l-1.5,0.9v16.6l2.2,0.6c3.3,1,6.9,1.9,10.3,2.8c9.7,2.6,19.8,5.3,29,9.6l0.9,0.4l0.9-0.2
          c13.8-2.3,19.8-7.2,23.9-19.1l0.9-2.7l-2.6-1.1c-11.5-4.8-27.1-14-36-30.7l-2.6-4.9L345.3,165.8z M81,115.2
          c-9.6,9.2-21.6,11.2-33,12.5l-2.7,0.3v10.9c0,30.4,24.8,55.2,55.2,55.2c30.4,0,55.2-24.8,55.2-55.2v-10.6l-3.1,0.1
          c-2,0.1-4.1,0.1-6.1,0.1c-24.9,0-45.7-4.6-61.9-13.8l-2-1.1L81,115.2z M240,135.5c0,28.6,23.2,51.8,51.8,51.8
          c28.6,0,51.8-23.2,51.8-51.8V125l-3.5,0.5c-3.2,0.5-6.4,0.7-9.4,0.7c-15.1,0-27.7-5.6-36.6-16.1l-2.3-2.8l-2.3,2.8
          c-8.9,10.5-21.5,16.1-36.6,16.1c-3,0-6.2-0.2-9.4-0.7L240,125V135.5z M81.7,102.3c1,0,1.9,0.3,2.8,0.9
          c15.2,10.4,36,15.7,61.9,15.7c2.1,0,4.3,0,6.4-0.1l2.9-0.1v-11.2c0-30.4-24.7-55.2-55.2-55.2c-30.4,0-55.2,24.8-55.2,55.2v10.7
          l3.4-0.4c10.8-1.3,21.2-3.3,29-13.6C78.7,103,80.1,102.3,81.7,102.3z M291.8,92.9c1.9,0,3.5,1,4.4,2.6c6.9,13.7,18.9,21,34.5,21
          c3.3,0,6.7-0.3,10.3-0.9l2.6-0.5l-0.1-2.6c-0.6-19.2-4.2-33.2-10.8-43c-8.2-12.1-21.6-18-40.9-18c-19.3,0-32.7,5.9-40.9,18
          c-6.6,9.8-10.2,23.9-10.8,43L240,115l2.6,0.5c3.6,0.6,7,0.9,10.3,0.9c15.6,0,27.6-7.3,34.5-21C288.2,93.8,289.9,92.9,291.8,92.9z
          "
          />
        </g>
      </g>
    </g>
  </svg>
);

export const parking = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 400 400"
    height="35px"
    width="35px"
  >
    <g>
      <g>
        <g>
          <path
            d="M154,299.5V112.2h64.5c34.3,0,62.3,27.9,62.3,62.3v2.2c0,34.3-27.9,62.3-62.3,62.3h-46.5v60.6H154z M172.1,220.9h46.5
          c24.4,0,44.2-19.8,44.2-44.2v-2.2c0-24.4-19.8-44.2-44.2-44.2h-46.5V220.9z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M200,382.8c-48.8,0-94.7-19-129.2-53.5S17.2,248.8,17.2,200c0-48.8,19-94.7,53.5-129.2c34.5-34.5,80.4-53.5,129.2-53.5
          c48.8,0,94.7,19,129.2,53.5c34.5,34.5,53.5,80.4,53.5,129.2c0,48.8-19,94.7-53.5,129.2C294.7,363.8,248.8,382.8,200,382.8z
           M200,33.4c-44.5,0-86.3,17.3-117.8,48.8C50.7,113.7,33.4,155.5,33.4,200c0,44.5,17.3,86.3,48.8,117.8
          c31.5,31.5,73.3,48.8,117.8,48.8c44.5,0,86.3-17.3,117.8-48.8c31.5-31.5,48.8-73.3,48.8-117.8c0-44.5-17.3-86.3-48.8-117.8
          C286.3,50.7,244.5,33.4,200,33.4z"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const hot_tub = (
  <svg
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    viewBox="0 0 400 400"
    height="35px"
    width="35px"
  >
    <path
      d="M122.5,340.9c-42.9,0-87.2-35.2-98.7-78.5L9.1,204.8l0-0.1c-2.5-7.9-3.7-16.2-3.7-24.5c0-45.4,36.9-82.3,82.3-82.3h47.2
          c3.2,0,5.8,2.6,5.8,5.8c0,3.2-2.6,5.8-5.8,5.8H87.6c-39,0-70.7,31.7-70.7,70.7c0,6.9,1,13.8,3,20.3l0,0.1l0,0.1
          c0.1,0.2,0.1,0.4,0.2,0.6l0.1,0.2l0,0.1c9.4,29.5,36.5,49.3,67.4,49.3h229.5c30.9,0,58-19.8,67.4-49.2l0.1-0.3
          c0.1-0.2,0.1-0.4,0.2-0.6l0-0.1l0-0.1c2-6.6,3-13.4,3-20.3c0-39-31.7-70.7-70.7-70.7h-65.6c-3.2,0-5.8-2.6-5.8-5.8
          c0-3.2,2.6-5.8,5.8-5.8h65.6c45.4,0,82.3,36.9,82.3,82.3c0,8.4-1.3,16.6-3.7,24.5l0,0.2l-14.7,57.4c-11.5,43.3-55.8,78.6-98.7,78.6
          H122.5z M35,259.4c10,37.9,50.1,69.9,87.6,69.9h159.6c37.4,0,77.5-32,87.6-70l5.1-20l-7,5.5c-14.6,11.5-32.2,17.6-50.8,17.6H87.6
          c-18.6,0-36.2-6.1-50.8-17.6l-7-5.5L35,259.4z M193,225c-8,0-15.9-3.2-21.7-8.8c-3.8-3.7-9.1-5.8-14.1-5.8c-0.4,0-0.8,0-1.2,0
          c-4,0.3-7.4,2-9.7,4.9l0,0.1l-0.1,0.1c-4.3,5.5-10.8,8.9-18.2,9.4c-0.7,0-1.4,0.1-2.1,0.1c-8,0-15.9-3.2-21.6-8.8
          c-3.8-3.7-9.1-5.8-14.1-5.8c-0.4,0-0.8,0-1.2,0c-4.1,0.3-7.5,2-9.8,5c-1.1,1.4-2.8,2.2-4.6,2.2c-1.3,0-2.5-0.4-3.5-1.2
          c-1.2-0.9-2-2.3-2.2-3.8c-0.2-1.5,0.2-3,1.2-4.3c4.3-5.6,10.7-8.9,18.1-9.5c0.7,0,1.4-0.1,2-0.1c8.1,0,16.1,3.3,22.1,9.1
          c3.6,3.5,8.7,5.5,13.6,5.5c0.4,0,0.8,0,1.3,0c2.9-0.2,6.9-1.2,9.9-5l0.1-0.1c4.3-5.6,10.7-8.9,18-9.4c0.7,0,1.4-0.1,2-0.1
          c8.1,0,16.1,3.3,22.1,9.1c3.6,3.5,8.7,5.5,13.6,5.5c0.4,0,0.8,0,1.3,0c2.9-0.2,7-1.2,9.9-5l0.1-0.1c4.3-5.5,10.7-8.8,18-9.4
          c0.7,0,1.4-0.1,2-0.1c8.1,0,16.1,3.3,22.1,9.1c2.3,2.2,2.4,5.9,0.1,8.1c-1.1,1.1-2.6,1.8-4.1,1.8c-1.5,0-2.9-0.6-4-1.6
          c-3.8-3.7-9.1-5.8-14.1-5.8c-0.4,0-0.8,0-1.2,0c-4,0.3-7.4,2-9.7,5l-0.1,0.1c-4.3,5.6-10.8,8.9-18.2,9.5
          C194.3,225,193.6,225,193,225L193,225z M193.1,187.3c-8,0-15.9-3.2-21.6-8.8c-3.8-3.7-9.1-5.8-14.1-5.8c-0.4,0-0.8,0-1.2,0
          c-4.1,0.3-7.5,2-9.8,5c-1.1,1.4-2.8,2.2-4.6,2.2c-1.3,0-2.5-0.4-3.5-1.2c-1.2-0.9-2-2.3-2.2-3.8c-0.2-1.5,0.2-3,1.2-4.3
          c4.3-5.6,10.7-8.9,18.1-9.5c0.7,0,1.4-0.1,2-0.1c8.1,0,16.1,3.3,22.1,9.1c3.6,3.5,8.7,5.5,13.7,5.5c0.4,0,0.8,0,1.2,0
          c2.9-0.2,6.9-1.2,9.8-4.9l0.1-0.2c4.3-5.6,10.7-8.9,18.1-9.5c0.7,0,1.4-0.1,2-0.1c8.1,0,16.1,3.3,22.1,9.1c3.6,3.5,8.7,5.5,13.6,5.5
          c0.4,0,0.8,0,1.3,0c2.9-0.2,7-1.2,9.9-5l0.1-0.1c4.3-5.5,10.7-8.8,18-9.4c0.7,0,1.3-0.1,2-0.1c8.1,0,16.1,3.3,22.1,9.1
          c2.3,2.2,2.4,5.9,0.1,8.1c-1.1,1.1-2.6,1.8-4.1,1.8c-1.5,0-2.9-0.6-4-1.6c-3.8-3.7-9.1-5.8-14.1-5.8c-0.4,0-0.8,0-1.2,0
          c-4,0.3-7.3,2-9.7,4.9l-0.1,0.2c-4.3,5.6-10.8,8.9-18.2,9.5c-0.7,0-1.4,0.1-2.1,0.1c-8,0-15.9-3.2-21.7-8.8
          c-3.8-3.7-9.1-5.8-14.1-5.8c-0.4,0-0.8,0-1.2,0c-4.1,0.3-7.4,2-9.8,5c-4.3,5.6-10.8,8.9-18.2,9.5
          C194.5,187.2,193.8,187.3,193.1,187.3z M206.4,142.6c-1.5,0-3-0.6-4.1-1.7c-2.3-2.2-2.3-5.9,0-8.2c6.6-6.6,6.4-22.1-0.4-31.2
          c-6.6-8.9-9.3-21.5-7-32.3c0.6-2.6,2.9-4.6,5.6-4.6c0.4,0,0.8,0,1.2,0.1c1.5,0.3,2.8,1.2,3.6,2.5c0.8,1.3,1.1,2.8,0.8,4.3
          c-1.6,7.6,0.4,16.8,4.9,23l0.1,0.1l0,0c4.5,6.1,7.3,14.9,7.4,23.4c0.1,9.3-2.8,17.4-8.1,22.8C209.4,142,208,142.6,206.4,142.6z
           M170.7,142.6c-1.5,0-3-0.6-4.1-1.7c-1.1-1.1-1.7-2.5-1.7-4.1c0-1.5,0.6-3,1.7-4.1c6.6-6.6,6.4-22.1-0.4-31.2l-0.1-0.1
          c-6.5-8.8-9.2-21.5-6.9-32.2c0.6-2.6,2.9-4.6,5.6-4.6c0.4,0,0.8,0,1.2,0.1c1.5,0.3,2.8,1.2,3.6,2.5c0.8,1.3,1.1,2.8,0.8,4.3
          c-1.6,7.6,0.4,16.8,5,23l0.1,0.1c4.5,6.1,7.3,14.9,7.4,23.4c0.1,9.3-2.8,17.4-8.1,22.8C173.7,142,172.2,142.6,170.7,142.6z"
    />
  </svg>
);

export const plunge_pool = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 400 400"
    height="35px"
    width="35px"
  >
    <g>
      <path
        d="M156.7,331.6c14,0,28.1,3.1,42,9.1c14.8,6.4,29.8,9.7,44.6,9.7c14.6,0,29.4-3.2,44-9.5c13.1-5.7,25.9-8.6,39.1-9
          c1.3,0,2.6-0.1,3.9-0.1c14.7,0,27.7,2.6,39.7,7.9c1.1,0.5,2.2,0.7,3.3,0.7c2.2,0,3.9-1.1,4.7-3c1.3-3.1-0.6-7.7-4-9.7
          c-0.5-0.3-1-0.5-1.4-0.7c-14.5-6-29.2-9.1-43.5-9.1c-13.9,0-27.8,2.9-41.4,8.5c-10,4.2-21.9,8.6-34.8,9.6
          c-4.1,0.3-7.8,0.5-11.5,0.5c-14.3,0-26.4-2.5-37.2-7.6c-15.1-7.2-30.8-10.8-46.8-10.8c-7.6,0-15.5,0.8-23.3,2.5
          c-6.2,1.3-12.3,3.7-18.3,6.1c-3.3,1.3-6.7,2.6-10,3.8c-12.1,4.1-24.1,6.2-35.8,6.2c-13.2,0-26.3-2.6-39-7.8
          c-0.8-0.3-1.6-0.6-2.4-0.8c-0.2-0.1-0.5-0.1-0.7-0.2l-0.1,0c-3.2,0-4.9,1.3-5.7,4.2c-0.9,3.3-0.1,5.8,2.5,7.8
          c0.8,0.6,1.7,1,2.8,1.4l0.1,0.1c14.4,6,28.9,9,43.2,9c14.6,0,29.3-3.2,43.7-9.5C128.4,334.7,142.6,331.6,156.7,331.6z"
      />
      <path
        d="M156.7,381.2c14,0,28.1,3.1,42,9.1c14.8,6.4,29.8,9.7,44.6,9.7c14.6,0,29.4-3.2,44-9.5c13.1-5.7,25.9-8.6,39.1-9
          c1.3,0,2.6-0.1,3.9-0.1c14.7,0,27.7,2.6,39.7,7.9c1.1,0.5,2.2,0.7,3.3,0.7c2.2,0,3.9-1.1,4.7-3c1.3-3.1-0.6-7.7-4-9.7
          c-0.5-0.3-1-0.5-1.4-0.7c-14.5-6-29.2-9.1-43.5-9.1c-13.9,0-27.8,2.9-41.4,8.5c-10,4.2-21.9,8.6-34.8,9.6
          c-4.1,0.3-7.8,0.5-11.5,0.5c-14.3,0-26.4-2.5-37.2-7.6c-15.1-7.2-30.8-10.8-46.8-10.8c-7.6,0-15.5,0.8-23.3,2.5
          c-6.2,1.3-12.3,3.7-18.3,6.1c-3.3,1.3-6.7,2.6-10,3.8c-12.1,4.1-24.1,6.2-35.8,6.2c-13.2,0-26.3-2.6-39-7.8
          c-0.8-0.3-1.6-0.6-2.4-0.8c-0.2-0.1-0.5-0.1-0.7-0.2l-0.1,0c-3.2,0-4.9,1.3-5.7,4.2c-0.9,3.3-0.1,5.8,2.5,7.8
          c0.8,0.6,1.7,1,2.8,1.4l0.1,0.1c14.4,6,28.9,9,43.2,9c14.6,0,29.3-3.2,43.7-9.5C128.4,384.3,142.6,381.2,156.7,381.2z"
      />
      <g>
        <g>
          <g>
            <path
              className="st7"
              d="M181.4,13.6C174.5,0.9,158.6-3.7,146,3.2c-12.6,6.9-17.3,22.7-10.4,35.4c6.9,12.6,22.7,17.3,35.4,10.4
          C183.6,42,188.3,26.2,181.4,13.6z"
            />
            <g>
              <path
                className="st7"
                d="M79.3,52.8l24.5,12.7l-23.1,60.4l35.8,7.2l29.9,6.1l20.8-54.5c3.4-9-1.1-19.1-10.1-22.6
          c-30.6-11.6-29.3-11.4-31.8-11.9L84.6,29.1c-3.5-1.8-7.6-1.8-11.1,0.1l-41,22.7C26.9,55,24.8,62.2,28,67.8
          c3.1,5.7,10.3,7.7,15.9,4.6L79.3,52.8z"
              />
              <path
                className="st7"
                d="M115.9,188.5l-16.8,4.8l4.3,5.9l-30.1,56.1c-3.8,7.1-1.5,16.2,5.5,20.3c7.4,4.3,16.7,1.5,20.6-5.9
          l34.7-64.7c2.7-5.1,2.3-11.2-1.1-15.9l-3.3-4.5L115.9,188.5z"
              />
              <path
                className="st7"
                d="M171,181.7l-12.5,5l-16.5,6.6l4.3,5.4l-23.6,58.4c-3.1,7.6,0.6,16.3,8.3,19.4c7.6,3.1,16.3-0.6,19.4-8.3
          l26.9-66.5c2-5,1.2-10.8-2.2-15L171,181.7z"
              />
            </g>
            <g>
              <path
                className="st7"
                d="M99.1,193.3l30.6-8.7L111,159.1l4.8,1.8l26.2,32.3l29-11.6l-27.8-34.3l3.2-8.3l-65.7-13.3l-4.9,12.8
          c-3.5,9.2-2.2,19.6,3.6,27.5L99.1,193.3z"
              />
            </g>
          </g>
        </g>
        <line className="st8" x1="26.5" y1="286.3" x2="178.4" y2="286.3" />
      </g>
    </g>
  </svg>
);

export const grill = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 400 400"
    height="35px"
    width="35px"
  >
    <g>
      <g>
        <path
          d="M320.3,331.5h-4.2l-26.4-100.3c-0.2-0.8-0.6-1.5-1.1-2.2c8-12.4,12.8-26.6,13.8-41.3h11.3c7.7,0,14-6.3,14-14v-3.2
          c0-7.7-6.3-14-14-14h-190L250.6,29.7c2.4-2.4,2.4-6.4,0-8.8C218-11.8,166.1-15,129.7,13.3L118.4,2c-2.4-2.4-6.4-2.4-8.8,0
          L94.4,17.1c-2.4,2.4-2.4,6.4,0,8.8l11.3,11.3c-27.7,35.8-25.1,86.5,6.2,119.3h-7.5c-7.7,0-14,6.3-14,14v3.2c0,7.7,6.3,14,14,14
          h5.1c1.2,17.6,7.8,34.4,18.8,48.1c0,0.1-0.1,0.2-0.2,0.3l-37.5,150c-0.8,3.3,1.2,6.7,4.5,7.6c0,0,0,0,0,0c0.5,0.1,1,0.2,1.5,0.2
          c2.9,0,5.4-2,6.1-4.7l20.7-82.8h173.3h0l6.9,26c-11.4,3.1-19.4,13.4-19.4,25.2v10c0,14.5,11.8,26.3,26.3,26.3l0,0h10
          c14.5,0,26.3-11.8,26.3-26.3l0,0v-10C346.5,343.3,334.8,331.5,320.3,331.5z M114,15.3l6.3,6.3l-6.3,6.3l-6.3-6.3L114,15.3z
           M122.2,37.3l7.6-7.6c29.2-29.2,76-31.1,107.4-4.3L117.9,144.8C91.1,113.3,93,66.6,122.2,37.3z M104.3,175.3
          c-0.8,0-1.5-0.7-1.5-1.5l0,0v-3.2c0-0.8,0.7-1.5,1.5-1.5h209.5c0.8,0,1.5,0.7,1.5,1.5v3.2c0,0.8-0.7,1.5-1.5,1.5H104.3z
           M121.8,187.8H290c-3.3,38.8-35.8,68.7-74.7,68.8h-18.8C157.5,256.5,125.1,226.6,121.8,187.8z M126.4,294l11.9-47.4
          c16,14.4,36.7,22.4,58.3,22.4h18.8c24.3,0,47.5-10.2,64-28.1l14,53.1H126.4z M334,367.8c0,7.6-6.2,13.8-13.8,13.8h-10
          c-7.6,0-13.8-6.2-13.8-13.8v-10c0-7.6,6.2-13.8,13.8-13.8h10c7.6,0,13.8,6.2,13.8,13.8V367.8z"
        />
      </g>
    </g>
  </svg>
);

export const pool = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 400 400"
    height="35px"
    width="35px"
  >
    <g>
      <path
        d="M57,221c-16.1,0-32.6-3.5-49-10.5c-3.6-1.5-5.3-3.7-5.6-7.3c-0.2-2.2,0.4-4.2,1.7-5.6c1.1-1.2,2.5-1.8,4.1-1.8
          c0.9,0,1.9,0.2,2.8,0.6c14,6.3,28.9,9.4,44.3,9.4c0,0,0,0,0,0c9.3,0,18.9-1.1,28.7-3.4c8-1.8,15.8-5,23.3-8.1
          c3-1.2,6.1-2.5,9.2-3.6c1.3-0.5,2.3-1.6,3.1-2.6c0.1-0.2,0.3-0.3,0.4-0.5c14-15.8,27.9-31.6,41.9-47.4c0.4-0.5,0.8-1,1.2-1.5
          c0.2-0.3,0.4-0.5,0.6-0.8l1-1.3l-3.7-4c-2.8-3-5.6-6.1-8.9-9.8l-1.6-1.8l-1.5,1.9c-1,1.2-1.9,2.5-2.9,3.7c-2.2,2.8-4.4,5.6-6.7,8.3
          c-12,13.8-22.9,26.2-33.3,37.7c-5.1,5.7-11.6,8.8-18.4,8.8c-5.1,0-9.9-1.8-13.9-5.3c-11.3-9.9-12.4-26.8-2.5-38.4
          c7.7-9,15.7-17.8,23.5-26.4c3.3-3.7,6.7-7.4,10-11.1c3.7-4.1,7.4-8.2,11-12.3c6-6.6,11.9-13.3,17.8-19.9c5.8-6.5,11.8-9.8,17.9-9.8
          c6,0,12,3.3,17.8,9.7c16.7,18.8,33.4,37.7,50,56.5l23.8,26.9c3.6,4,7.1,8,10.7,12.1c9,10.1,18.3,20.5,27.2,30.9
          c1.8,2.1,4.2,4.4,7.8,4.4c1.6,0,3.4-0.5,5.5-1.5c15.8-7.7,32.6-11.6,49.7-11.6c14,0,28.8,2.6,43.9,7.7c2.2,0.7,4.4,1.9,6.3,2.9
          c5.6,2.9,5.3,6.1,4.4,8.6c-1.2,3.2-3.3,4.9-6.3,4.9c-0.9,0-1.9-0.2-2.9-0.5c-2-0.6-4-1.3-5.9-1.9c-6.6-2.1-13.4-4.4-20.3-5.5
          c-7.1-1.2-14.2-1.8-20.9-1.8c-15.5,0-30.1,3.2-43.5,9.5c-16.1,7.5-32.8,11.4-49.6,11.4c-15.2,0-30.8-3.1-46.3-9.2
          c-15.3-6-31.9-11.6-49.5-11.6c-0.3,0-0.6,0-0.9,0c-16.7,0.2-32.5,3.6-48.2,10.6C88.8,217.6,72.9,221,57,221z M156.9,185.5
          c2.5,0,4.6,0.1,6.6,0.2c16.7,1.4,29.1,4.6,40.4,10.4c13.6,7,28.3,10.4,45.1,10.4c0,0,0,0,0,0c5.9,0,12.1-0.4,18.5-1.3l2.3-0.3
          l-0.6-2.2c-0.1-0.4-0.2-0.8-0.3-1c-0.1-0.6-0.3-1.2-0.8-1.7l-11.8-13.5c-31.7-36.1-64.5-73.4-96.8-110.1c-2.4-2.8-5.1-4.2-7.9-4.2
          c-2.8,0-5.5,1.4-8,4.1c-2.3,2.4-4.5,5-6.7,7.5c-1,1.2-2,2.3-3.1,3.5l-12.8,14.5c-12.8,14.5-25.6,28.9-38.4,43.4
          c-4.8,5.5-5.6,10.4-2.5,15.5c2.7,4.4,5.8,5.3,8,5.3c3.1,0,6.2-1.7,9.3-5.2c7.2-8,14.3-16.1,21.5-24.2c7.2-8.1,14.4-16.3,21.6-24.4
          c3.6-4,7.2-6,10.9-6c3.6,0,7.2,1.9,10.7,5.7c4.4,4.7,8.7,9.6,12.8,14.4l2.2,2.5c4.4,5.1,4.4,8.4-0.1,13.5
          c-5.9,6.7-11.8,13.4-17.8,20.1c-4.1,4.6-8.2,9.3-12.3,13.9c-0.8,0.9-1.5,1.9-2.2,2.8c-0.3,0.4-0.7,0.9-1,1.3l-0.6,0.7l0.7,4.2h1.7
          c1.9,0,3.8,0,5.7-0.1C153.2,185.5,155.1,185.5,156.9,185.5z"
      />
      <path
        d="M150.5,261.2c15.6,0,31.3,3.4,46.9,10.2c16.5,7.2,33.3,10.8,49.7,10.8c16.3,0,32.8-3.6,49-10.6c14.6-6.3,28.9-9.6,43.6-10
          c1.4,0,2.9-0.1,4.3-0.1c16.4,0,30.9,2.9,44.3,8.8c1.2,0.6,2.5,0.8,3.6,0.8c2.4,0,4.3-1.2,5.2-3.4c1.4-3.4-0.7-8.6-4.5-10.8
          c-0.5-0.3-1.1-0.6-1.6-0.8c-16.2-6.7-32.5-10.1-48.5-10.1c-15.5,0-31,3.2-46.1,9.5c-11.1,4.6-24.5,9.6-38.8,10.7
          c-4.6,0.4-8.7,0.5-12.8,0.5c-15.9,0-29.5-2.8-41.5-8.5c-16.8-8-34.4-12-52.1-12c-8.5,0-17.3,0.9-26,2.8c-6.9,1.4-13.7,4.1-20.4,6.8
          c-3.7,1.4-7.4,2.9-11.2,4.2c-13.4,4.6-26.9,6.9-39.9,6.9c-14.7,0-29.4-2.9-43.5-8.7c-0.9-0.4-1.8-0.6-2.7-0.8
          c-0.3-0.1-0.5-0.1-0.7-0.2l-0.1,0c-3.5,0-5.4,1.4-6.3,4.7c-1,3.7-0.1,6.5,2.8,8.7c0.9,0.6,1.9,1.1,3.1,1.6l0.2,0.1
          c16.1,6.7,32.3,10.1,48.1,10.1c16.3,0,32.7-3.6,48.8-10.6C119,264.7,134.8,261.2,150.5,261.2z"
      />
      <path
        d="M152.8,327.3c15.6,0,31.3,3.4,46.9,10.2c16.5,7.2,33.3,10.8,49.7,10.8c16.3,0,32.8-3.6,49-10.6c14.6-6.3,28.9-9.6,43.6-10
          c1.4,0,2.9-0.1,4.3-0.1c16.4,0,30.9,2.9,44.3,8.8c1.2,0.6,2.5,0.8,3.6,0.8c2.4,0,4.3-1.2,5.2-3.4c1.4-3.4-0.7-8.6-4.5-10.8
          c-0.5-0.3-1.1-0.6-1.6-0.8c-16.2-6.7-32.5-10.1-48.5-10.1c-15.5,0-31,3.2-46.1,9.5c-11.1,4.6-24.5,9.6-38.8,10.7
          c-4.6,0.4-8.7,0.5-12.8,0.5c-15.9,0-29.5-2.8-41.5-8.5c-16.8-8-34.4-12-52.1-12c-8.5,0-17.3,0.9-26,2.8c-6.9,1.4-13.7,4.1-20.4,6.8
          c-3.7,1.4-7.4,2.9-11.2,4.2c-13.4,4.6-26.9,6.9-39.9,6.9c-14.7,0-29.4-2.9-43.5-8.7c-0.9-0.4-1.8-0.6-2.7-0.8
          c-0.3-0.1-0.5-0.1-0.7-0.2l-0.1,0c-3.5,0-5.4,1.4-6.3,4.7c-1,3.7-0.1,6.5,2.8,8.7c0.9,0.6,1.9,1.1,3.1,1.6l0.2,0.1
          c16.1,6.7,32.3,10.1,48.1,10.1c16.3,0,32.7-3.6,48.8-10.6C121.3,330.7,137.2,327.3,152.8,327.3z"
      />
      <path
        d="M296.2,157.4c-12.1-0.1-23.5-5.7-32.1-15.6c-8.7-10.1-13.5-23.3-13.4-37.2c0.1-29.1,21-52.7,46.6-52.7h0.2
          c25.5,0.1,46.3,23.7,46.4,52.7c0.1,15-5.6,29.3-15.6,39.4c-8.7,8.7-19.9,13.5-31.7,13.5L296.2,157.4z M297.4,66.9
          c-18.7,0-33.9,16-33.9,35.6c0,23.2,13.8,39.6,33.7,39.7h0.2c19.1,0,33.6-15.9,33.7-37.1c0.1-11.2-3.8-21.4-11-28.6
          c-6.1-6.1-14.1-9.5-22.5-9.6H297.4z"
      />
    </g>
  </svg>
);

export const wifi = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 400 400"
    height="35px"
    width="35px"
  >
    <g>
      <g>
        <path
          d="M199.4,355.4c-19.2,0-34.7-15.6-34.7-34.7s15.6-34.7,34.7-34.7s34.7,15.6,34.7,34.7S218.6,355.4,199.4,355.4z
           M199.4,297.9c-12,0-22.8,9.6-22.8,22.8s9.6,22.8,22.8,22.8s22.8-9.6,22.8-22.8S211.4,297.9,199.4,297.9z"
        />
        <path
          d="M199.4,357.8c-20.5,0-37.1-16.7-37.1-37.1s16.7-37.1,37.1-37.1c20.5,0,37.1,16.7,37.1,37.1S219.9,357.8,199.4,357.8z
           M199.4,288.3c-17.8,0-32.3,14.5-32.3,32.3s14.5,32.3,32.3,32.3s32.3-14.5,32.3-32.3S217.2,288.3,199.4,288.3z M199.4,345.8
          c-14.6,0-25.1-10.6-25.1-25.1c0-13.9,11.3-25.1,25.1-25.1c13.9,0,25.1,11.3,25.1,25.1C224.6,335.2,214,345.8,199.4,345.8z
           M199.4,300.3c-11.2,0-20.4,9.1-20.4,20.4c0,11.8,8.6,20.4,20.4,20.4c11.8,0,20.4-8.6,20.4-20.4
          C219.8,309.4,210.6,300.3,199.4,300.3z"
        />
      </g>
      <g>
        <path
          d="M278.4,247.6c-1.2,0-3.6,0-4.8-1.2c-20.4-20.4-46.7-31.1-75.4-31.1s-55.1,10.8-75.4,31.1c-2.4,2.4-6,2.4-8.4,0
          s-2.4-6,0-8.4c22.8-22.8,51.5-34.7,83.8-34.7c31.1,0,61.1,12,83.8,34.7c2.4,2.4,2.4,6,0,8.4C282,247.6,279.6,247.6,278.4,247.6z"
        />
        <path
          d="M118.6,250.6c-2.1,0-4.2-0.8-5.9-2.5c-3.4-3.4-3.4-8.4,0-11.8c23.2-23.2,52.8-35.4,85.5-35.4c32.3,0,62.7,12.6,85.5,35.4
          c3.2,3.2,3.3,7.9,0.5,11.2c-0.8,2.5-4.5,2.5-5.8,2.5c-1.5,0-4.6,0-6.5-1.9c-19.9-19.9-45.4-30.4-73.8-30.4
          c-28.3,0-53.8,10.5-73.8,30.4C122.8,249.8,120.7,250.6,118.6,250.6z M198.2,205.7c-31.5,0-59.9,11.8-82.1,34c-1.5,1.5-1.5,3.5,0,5
          s3.5,1.5,5,0c20.8-20.8,47.5-31.8,77.1-31.8s56.3,11,77.1,31.8c0.2,0.2,0.9,0.5,3.1,0.5c0.3,0,1,0,1.5-0.1l0.4-0.4
          c1.5-1.5,1.5-3.5,0-5C258.4,217.8,229.2,205.7,198.2,205.7z"
        />
      </g>
      <g>
        <path
          d="M334.7,191.3c-1.2,0-3.6,0-4.8-1.2c-71.9-71.9-190.4-71.9-262.3,0c-2.4,2.4-6,2.4-8.4,0s-2.4-6,0-8.4
          c76.6-76.6,202.4-76.6,279,0c2.4,2.4,2.4,6,0,8.4C338.3,191.3,335.9,191.3,334.7,191.3z"
        />
        <path
          d="M63.5,194.3c-2.2,0-4.3-0.9-5.9-2.5c-3.4-3.4-3.4-8.4,0-11.8c37.5-37.5,87.7-58.2,141.2-58.2S302.5,142.5,340,180
          c3.2,3.2,3.3,7.9,0.5,11.2c-0.8,2.5-4.5,2.5-5.8,2.5c-1.5,0-4.6,0-6.5-1.9c-34.3-34.3-80.3-53.2-129.4-53.2
          c-49.2,0-95.1,18.9-129.4,53.2C67.8,193.4,65.7,194.3,63.5,194.3z M198.8,126.7c-52.3,0-101.2,20.2-137.8,56.8
          c-1.5,1.5-1.5,3.5,0,5c1.4,1.4,3.6,1.4,5,0c35.2-35.2,82.4-54.6,132.8-54.6s97.6,19.4,132.8,54.6c0.2,0.2,0.9,0.5,3.1,0.5
          c0.3,0,1,0,1.5-0.1l0.4-0.4c1.5-1.5,1.5-3.5,0-5C300,146.8,251.1,126.7,198.8,126.7z"
        />
      </g>
      <g>
        <path
          d="M391,135c-1.2,0-3.6,0-4.8-1.2c-103-104.2-270.6-104.2-373.6,0c-2.4,2.4-6,2.4-8.4,0s-2.4-6,0-8.4
          C112,17.7,288,17.7,395.8,125.5c2.4,2.4,2.4,6,0,8.4C394.6,135,392.2,135,391,135z"
        />
        <path
          d="M8.4,138c-2.2,0-4.3-0.9-5.9-2.5c-3.4-3.4-3.4-8.4,0-11.8C55.1,71.2,125.2,42.2,200,42.2s144.9,29,197.5,81.5
          c1.6,1.6,2.5,3.7,2.5,5.9c0,2.2-0.9,4.3-2.5,5.9c-1.9,1.9-5,1.9-6.5,1.9s-4.6,0-6.5-1.9c-49.4-49.9-115.1-77.4-185.1-77.4
          S63.6,85.6,14.3,135.5C12.7,137.1,10.6,138,8.4,138z M200,47C126.5,47,57.6,75.5,5.9,127.1c-1.5,1.5-1.5,3.5,0,5
          c1.4,1.4,3.6,1.4,5,0c50.3-50.8,117.2-78.8,188.5-78.8s138.3,28,188.5,78.9c0.2,0.2,0.9,0.5,3.1,0.5c2.1,0,2.9-0.3,3.1-0.5
          c0.7-0.7,1.1-1.6,1.1-2.5s-0.4-1.8-1.1-2.5C342.4,75.5,273.5,47,200,47z"
        />
      </g>
    </g>
  </svg>
);

export const new_icon = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 400 400"
    height="35px"
    width="35px"
  >
    <g>
      <g>
        <g>
          <g>
            <path
              d="M396.4,223.7c-1-2-3.4-2.9-5.4-3.4c-11.3,0-108.3-3.9-108.3-116.6c0-3.4-2.9-6.4-6.4-6.4c-3.4,0-6.4,2.9-6.4,6.4
          c0,112.7-97,116.6-107.8,116.6c-1.5,0-2.9,0.5-3.9,1.5c-1,0.5-1.5,1.5-2,2c-1,2-1,4.4,0,6.4s3.4,3.4,5.9,3.4c0,0,0,0,0.5,0
          c11.3,0,107.8,3.9,107.8,116.6c0,3.4,2.9,6.4,6.4,6.4c3.4,0,6.4-2.9,6.4-6.4c0-112.2,96.5-116.6,107.8-116.6
          c2.4,0,4.4-1.5,5.9-3.4C397.8,228.1,397.8,225.6,396.4,223.7z M276.3,302.1c-14.2-46.5-49-66.6-76.4-75.5
          c27.4-8.8,62.2-28.9,76.4-75.5c14.2,46.5,49,66.6,76.4,75.5C325.3,235.4,290.5,255.5,276.3,302.1z"
            />
            <path
              d="M158.4,225c-0.5,1.2-0.5,2.7,0.1,3.9s2.2,2.1,3.7,2.1h0.5c5.3,0,32.9,0.8,59.4,16.4C255.9,267.2,273,301.9,273,350
          c0,2.1,1.8,3.9,3.9,3.9s3.9-1.8,3.9-3.9c0-47.3,17.6-82.8,50.9-102.5c27.2-16.1,56.2-16.6,59.4-16.6c1.3,0,2.6-0.8,3.8-2.3
          c0.6-1.2,0.4-2.6-0.3-3.6l-0.2-0.4c-0.4-0.8-1.7-1.6-3.5-2.1c-6,0-33.2-1.1-59.3-16.4c-33.9-19.9-51.1-54.5-51.1-102.7
          c0-2.1-1.8-3.9-3.9-3.9s-3.9,1.8-3.9,3.9c0,26.3-5.3,48.8-15.6,67c-8.5,14.9-20.4,26.9-35.4,35.7
          c-26.5,15.6-53.9,16.4-59.2,16.4c-0.9,0-1.7,0.3-2.2,0.8l-0.3,0.3l-0.4,0.2c-0.2,0.1-0.4,0.4-0.7,0.7
          C158.6,224.8,158.5,224.9,158.4,225z M276.3,310.5l-2.3-7.7c-13.9-45.6-48.4-65.3-74.8-73.8l-7.3-2.3l7.3-2.3
          c26.5-8.5,60.9-28.2,74.8-73.8l2.3-7.7l2.3,7.7c13.9,45.6,48.4,65.3,74.8,73.8l7.3,2.3l-7.3,2.3c-26.5,8.5-60.9,28.2-74.8,73.8
          L276.3,310.5z"
            />
          </g>
          <g>
            <path
              d="M195.5,96.3c3.4,0,6.4-2.9,6.4-6.9c0-3.4-2.9-6.4-6.4-6.4c-5.9,0-58.8-2-58.8-63.7c0-3.4-2.9-6.4-6.4-6.4
          c-3.4,0-6.4,2.9-6.4,6.4C123.9,81,71,83,65.1,83c-0.5,0-0.5,0-0.5,0c-3.4,0.5-5.9,2.9-5.9,6.4c0,3.4,2.9,6.4,6.4,6.4
          c6.4,0,58.8,2,58.8,63.7c0,3.4,2.9,6.4,6.4,6.4c2.9,0.5,5.9-2.4,5.9-5.9c0-61.7,52.9-63.7,58.8-63.7H195.5L195.5,96.3z
           M129.8,124.2c-7.8-18.6-22-28.9-35.3-34.8c14.2-5.9,27.4-17.1,35.3-34.8c7.8,18.6,22,28.9,35.3,34.8
          C150.9,95.3,137.7,106.6,129.8,124.2z"
            />
            <path
              d="M64.9,85.5c-1.8,0.3-3.6,1.5-3.6,3.9c0,2.1,1.8,3.9,3.9,3.9c6.3,0,61.2,1.9,61.2,66.1c0,2.1,1.8,3.9,3.9,3.9h0.4
          c0.7,0.1,1.4-0.3,1.7-0.6c0.8-0.7,1.3-1.8,1.3-2.9c0-18.4,4.9-43.3,28.4-57.1c14.6-8.6,29.9-9,32.8-9h0.5c2.2,0,3.9-2,3.9-4.4
          c0-2.1-1.8-3.9-3.9-3.9c-2.9,0-18.2-0.4-32.8-9c-23.5-13.8-28.4-38.7-28.4-57.1c0-2.1-1.8-3.9-3.9-3.9c-2.1,0-3.9,1.8-3.9,3.9
          c0,18.4-4.9,43.3-28.4,57.1c-14.6,8.6-29.9,9-32.8,9h-0.3V85.5z M129.8,130.4l-2.2-5.2c-6.3-15-17.8-26.3-34-33.5l-5.2-2.3
          l5.3-2.2c10.7-4.4,25.2-13.8,34-33.5l2.3-5.2l2.2,5.2c6.3,15,17.8,26.3,34,33.5l5.2,2.3l-5.3,2.2c-10.7,4.4-25.2,13.8-34,33.5
          L129.8,130.4z"
            />
          </g>
          <g>
            <path
              d="M139.1,304c-5.9,0-58.8-2-58.8-63.7c0-3.4-2.9-6.4-6.4-6.4c-3.4,0-6.4,2.9-6.4,6.4C67.5,302,14.6,304,8.7,304
          c-0.5,0-0.5,0-0.5,0c-3.4,0.5-5.9,2.9-5.9,6.4c0,3.4,2.9,6.4,6.4,6.4c6.4,0,58.8,2,58.8,63.7c0,3.4,2.9,6.4,6.4,6.4
          c2.9,1,5.9-2,5.9-5.9c0-61.7,52.9-63.7,58.8-63.7h0.5c3.4,0,6.4-2.9,6.4-6.9C145.5,307,142.6,304,139.1,304z M73.5,345.7
          c-8.3-18.6-22-28.9-35.3-34.8c14.2-5.9,27.4-17.1,35.3-34.8c7.8,18.6,22,28.9,35.3,34.8C94.6,316.8,81.3,328,73.5,345.7z"
            />
            <path
              d="M8.5,306.5c-1.8,0.3-3.6,1.5-3.6,3.9c0,2.1,1.8,3.9,3.9,3.9c6.3,0,61.2,1.9,61.2,66.1c0,2.1,1.8,3.9,3.9,3.9h0.4
          l0.4,0.1c0.1,0.1,0.6,0.2,1.2-0.2c0.7-0.5,1.4-1.6,1.4-3.3c0-18.4,4.9-43.3,28.4-57.1c14.6-8.6,29.9-9,32.8-9h0.5
          c2.2,0,3.9-2,3.9-4.4c0-2.1-1.8-3.9-3.9-3.9c-2.9,0-18.2-0.4-32.8-9c-23.5-13.8-28.4-38.7-28.4-57.1c0-2.1-1.8-3.9-3.9-3.9
          s-3.9,1.8-3.9,3.9c0,18.4-4.9,43.3-28.4,57.1c-14.6,8.6-29.9,9-32.8,9H8.5z M73.5,351.7l-2.2-5c-6.8-15.3-18.3-26.5-34-33.5
          l-5.2-2.3l5.3-2.2c10.7-4.4,25.2-13.8,34-33.5l2.3-5.2l2.2,5.2c6.3,15,17.8,26.3,34,33.5l5.2,2.3l-5.3,2.2
          c-10.7,4.4-25.2,13.8-34,33.5L73.5,351.7z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const cook = (
  <svg viewBox="0 0 475.8 475.8" width="35px" height="45px">
    <path d="m309.8 272.4h-143.8c-4.1 0-7.5 3.4-7.5 7.5v76.8c0 17.4 14.1 31.5 31.5 31.5h95.9c17.4 0 31.5-14.1 31.5-31.5v-76.8c-.1-4.1-3.4-7.5-7.6-7.5zm-24 100.8h-95.8c-9.1 0-16.5-7.4-16.5-16.5v-33.4h95.6c4.1 0 7.5-3.4 7.5-7.5s-3.4-7.5-7.5-7.5h-95.6v-20.9h128.9v20.9h-8c-4.1 0-7.5 3.4-7.5 7.5s3.4 7.5 7.5 7.5h8v33.4c-.1 9.1-7.5 16.5-16.6 16.5zm101.6 75.2-15.8-222.6c-.3-3.9-3.6-7-7.5-7-15.6 0-29.4-10.9-33.1-26v-185.3c0-2-.8-3.9-2.2-5.3s-3.3-2.2-5.3-2.2h-39.6c-4.1 0-7.5 3.4-7.5 7.5v81.5h-77v-81.5c0-4.1-3.4-7.5-7.5-7.5h-39.6c-4.1 0-7.5 3.4-7.5 7.5v185.3c-3.7 15.2-17.5 26.1-33.2 26.1-3.9 0-7.2 3-7.5 7l-15.7 222.5c-.3 3.6 2.1 6.9 5.6 7.8l8.1 2.1c44.3 11.6 90 17.4 135.8 17.4s91.5-5.9 135.8-17.4l8.1-2.1c3.5-.9 5.9-4.2 5.6-7.8zm-17.5-4.6c-43.1 11.3-87.5 17-132 17s-88.9-5.7-132-17l-2.1-.6 14.9-209.9c19.9-2.9 36.6-18 41-38.1.1-.5.2-1.1.2-1.6v-178.6h24.6v81.5c0 4.1 3.4 7.5 7.5 7.5h92c4.1 0 7.5-3.4 7.5-7.5v-81.5h24.5v178.7c0 .5.1 1.1.2 1.6 4.4 20 21.1 35.1 41 38l14.8 210z" />
  </svg>
);

export const time_zone = (
  <svg viewBox="0 0 512 512" width="35px" height="45px">
    <path d="m365 421.7c-41.5 0-79.7-16.9-107.4-47.7l-1.7-1.9-1.7 1.9c-27.4 30.3-66.5 47.7-107.3 47.7-79.7 0-144.6-64.9-144.6-144.7s64.9-144.7 144.7-144.7c40.7 0 79.8 17.4 107.3 47.7l1.7 1.9 1.7-1.9c27.7-30.7 65.8-47.7 107.4-47.7 79.8 0 144.7 64.9 144.7 144.7-.1 79.8-65 144.7-144.8 144.7zm-10.2-273.5c-34.3 2.7-65.5 18.6-87.9 44.8l-1.1 1.3 1 1.4c16.4 24 25 52.1 25 81.2s-8.6 57.2-25 81.2l-1 1.4 1.1 1.3c22.4 26.2 53.6 42.1 87.9 44.8l2.4.2v-19.3c0-4.3 3.5-7.8 7.8-7.8s7.8 3.5 7.8 7.8v19.3l2.4-.2c30.8-2.4 59.8-15.9 81.6-38s35-51.3 37-82.1l.2-2.4h-17.7c-4.3 0-7.8-3.5-7.8-7.8s3.5-7.8 7.8-7.8h17.5l-.2-2.5c-2.8-30.1-16.2-58.5-37.9-79.9s-50.3-34.5-80.5-36.9l-2.4-.2v16c0 4.3-3.5 7.8-7.8 7.8s-7.8-3.5-7.8-7.8v-16zm-207.8 230.6c4.3 0 7.8 3.5 7.8 7.8v19.3l2.4-.2c30.8-2.4 59.8-15.9 81.6-38s35-51.3 37-82.1l.2-2.4h-17.7c-4.3 0-7.8-3.5-7.8-7.8s3.5-7.8 7.8-7.8h17.5l-.2-2.5c-2.8-30.1-16.2-58.5-37.9-79.9s-50.3-34.5-80.5-36.9l-2.4-.2v16c0 4.3-3.5 7.8-7.8 7.8s-7.8-3.5-7.8-7.8v-16l-2.4.2c-30.2 2.4-58.8 15.5-80.5 36.9s-35.1 49.8-37.9 79.9l-.2 2.5h17.5c4.3 0 7.8 3.5 7.8 7.8s-3.5 7.8-7.8 7.8h-17.7l.2 2.4c2 30.9 15.2 60 37 82.1s50.8 35.6 81.6 38l2.4.2v-19.3c0-4.3 3.5-7.8 7.8-7.8z" />
    <path d="m210.7 100.6c-1 0-1.9-.2-2.8-.5-19.4-7.5-39.9-11.2-60.9-11.2-17.2 0-34.3 2.6-50.6 7.6-.8.2-1.5.4-2.3.4-3.4 0-6.4-2.2-7.4-5.5-.6-2-.4-4.1.5-5.9s2.6-3.2 4.6-3.8c17.8-5.5 36.4-8.3 55.2-8.3 22.9 0 45.3 4.1 66.5 12.2 4 1.5 6 6.1 4.5 10.1-1.2 2.9-4.1 4.9-7.3 4.9z" />
    <path d="m220.8 355.4c-2.1 0-4-.8-5.5-2.3l-53.3-53.2-1.5.9c-4.1 2.3-8.8 3.6-13.5 3.6-15.1 0-27.4-12.3-27.4-27.4 0-11.5 7.3-21.8 18.1-25.8l1.5-.5v-43.5c0-4.3 3.5-7.8 7.8-7.8s7.8 3.5 7.8 7.8v43.5l1.5.5c10.8 3.9 18.1 14.3 18.1 25.8 0 3.3-.6 6.6-1.7 9.6l-.5 1.4 54.2 54.2c3 3 3 8 0 11-1.6 1.4-3.5 2.2-5.6 2.2zm-73.8-90.2c-6.5 0-11.8 5.3-11.8 11.8s5.3 11.8 11.8 11.8 11.8-5.3 11.8-11.8-5.3-11.8-11.8-11.8z" />
    <path d="m365 304.3c-15.1 0-27.4-12.3-27.4-27.4 0-11.5 7.3-21.8 18.1-25.8l1.5-.5v-43.5c0-4.3 3.5-7.8 7.8-7.8s7.8 3.5 7.8 7.8v43.5l1.5.5c2.3.8 4.4 1.9 6.4 3.3l1.6 1.1 52.6-52.6c1.5-1.5 3.4-2.3 5.5-2.3 2.1 0 4 .8 5.5 2.3 3 3 3 8 0 11l-54.7 54.7.3 1.3c.6 2.2.9 4.6.9 6.9 0 15.3-12.3 27.5-27.4 27.5zm0-39.1c-6.5 0-11.8 5.3-11.8 11.8s5.3 11.8 11.8 11.8 11.8-5.3 11.8-11.8-5.3-11.8-11.8-11.8z" />
  </svg>
);

export const sun = (
  <svg viewBox="0 0 129 129" width="35px" height="45px">
    <g>
      <g>
        <path d="m64.5,92.6c15.5,0 28-12.6 28-28s-12.6-28-28-28-28,12.6-28,28 12.5,28 28,28zm0-47.9c11,0 19.9,8.9 19.9,19.9 0,11-8.9,19.9-19.9,19.9s-19.9-8.9-19.9-19.9c0-11 8.9-19.9 19.9-19.9z" />
        <path d="m68.6,23.6v-12.9c0-2.3-1.8-4.1-4.1-4.1s-4.1,1.8-4.1,4.1v12.9c0,2.3 1.8,4.1 4.1,4.1s4.1-1.8 4.1-4.1z" />
        <path d="m60.4,105.6v12.9c0,2.3 1.8,4.1 4.1,4.1s4.1-1.8 4.1-4.1v-12.9c0-2.3-1.8-4.1-4.1-4.1s-4.1,1.8-4.1,4.1z" />
        <path d="m96.4,38.5l9.1-9.1c1.6-1.6 1.6-4.2 0-5.8-1.6-1.6-4.2-1.6-5.8,0l-9.1,9.1c-1.6,1.6-1.6,4.2 0,5.8 0.8,0.8 1.8,1.2 2.9,1.2s2.1-0.4 2.9-1.2z" />
        <path d="m23.5,105.6c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l9.1-9.1c1.6-1.6 1.6-4.2 0-5.8-1.6-1.6-4.2-1.6-5.8,0l-9.1,9.1c-1.6,1.6-1.6,4.2 0,5.8z" />
        <path d="m122.5,64.6c0-2.3-1.8-4.1-4.1-4.1h-12.9c-2.3,0-4.1,1.8-4.1,4.1 0,2.3 1.8,4.1 4.1,4.1h12.9c2.2,1.42109e-14 4.1-1.8 4.1-4.1z" />
        <path d="m10.6,68.7h12.9c2.3,0 4.1-1.8 4.1-4.1 0-2.3-1.8-4.1-4.1-4.1h-12.9c-2.3,0-4.1,1.8-4.1,4.1 0,2.3 1.9,4.1 4.1,4.1z" />
        <path d="m102.6,106.8c1,0 2.1-0.4 2.9-1.2 1.6-1.6 1.6-4.2 0-5.8l-9.1-9.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l9.1,9.1c0.8,0.8 1.9,1.2 2.9,1.2z" />
        <path d="m38.4,38.5c1.6-1.6 1.6-4.2 0-5.8l-9.1-9.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l9.1,9.1c0.8,0.8 1.8,1.2 2.9,1.2s2.1-0.4 2.9-1.2z" />
      </g>
    </g>
  </svg>
);

export const translation = (
  <svg viewBox="0 0 512 512" width="35px" height="45px">
    <path d="m297.4 387.7c-1.1 0-2.1-.2-3.1-.7-3.9-1.7-5.7-6.3-4-10.2l12.9-29.4-2-.9c-2.7-1.3-4.4-4-4.4-7 0-4.3 3.5-7.7 7.7-7.7h5.6l32.8-74.9c1.2-2.8 4-4.6 7.1-4.6s5.8 1.8 7.1 4.6l32.8 74.9h5.6c4.3 0 7.7 3.5 7.7 7.7 0 3-1.7 5.7-4.4 7l-2 .9 12.9 29.4c.8 1.9.9 4 .1 5.9s-2.2 3.4-4.1 4.3c-1 .4-2 .7-3.1.7-3.1 0-5.9-1.8-7.1-4.6l-15.7-35.8h-59.6l-15.7 35.8c-1.3 2.8-4 4.6-7.1 4.6zm29.6-55.9h46l-23-52.5z" />
    <path d="m218.7 242.4c-1.3 0-2.6-.3-3.7-1-21.3-11.7-38.6-30.4-48.5-52.6l-2.1-4.6-2.1 4.6c-9.9 22.2-27.2 40.9-48.5 52.6-1.1.6-2.4 1-3.7 1-2.8 0-5.4-1.5-6.8-4-1-1.8-1.2-3.9-.6-5.9s1.9-3.6 3.7-4.6c26.3-14.4 44.7-40.8 49.2-70.5l.4-2.6h-37.7c-4.3 0-7.7-3.5-7.7-7.7s3.5-7.7 7.7-7.7h38.4v-44c0-4.3 3.5-7.7 7.7-7.7s7.7 3.5 7.7 7.7v43.9h47.7c4.3 0 7.7 3.5 7.7 7.7s-3.5 7.7-7.7 7.7h-47l.4 2.6c4.5 29.7 22.9 56 49.2 70.5 1.8 1 3.1 2.6 3.7 4.6s.3 4.1-.6 5.9c-1.3 2.5-3.9 4.1-6.8 4.1z" />
    <path d="m441 509.7c-1.8 0-3.5-.6-4.9-1.7l-63.9-52.3h-142.2c-21.9 0-39.7-17.8-39.7-39.7v-90.2l-2.6.4c-7.5 1.1-15.2 1.6-22.7 1.6-35.2 0-70-11.7-98.1-32.9l-.9-.7-43.6 11.4c-.6.2-1.3.3-2 .3-2.3 0-4.4-1-5.9-2.8-1.9-2.3-2.4-5.5-1.1-8.2l17.3-37.9-.7-1.1c-18.1-26.8-27.7-58.3-27.7-90.9 0-28.7 7.6-56.9 21.9-81.5.3-.5.7-1 1.1-1.5l.2-.2.1-.2c13.7-22.7 33-41.9 55.7-55.6l.3-.2.2-.3c.6-.6 1.2-1.2 1.9-1.6 24.6-14.1 52.7-21.6 81.3-21.6 89.7 0 162.8 73 162.8 162.8 0 4.8-.2 9.8-.7 14.8l-.2 2.5h143.1c21.9 0 39.7 17.8 39.7 39.7v194c0 21.9-17.8 39.7-39.7 39.7h-21.3v46.2c0 3-1.7 5.7-4.4 7-1 .5-2.1.7-3.3.7zm-116.9-310.2c-6.3 29.1-20.6 56-41.3 77.7-20.6 21.7-46.7 37.2-75.4 44.9l-1.7.5v93.4c0 13.4 10.9 24.3 24.3 24.3h141.2c5.4 0 6.9.1 8.9 1.9l.1.1 53.1 43.4v-37.7c0-4.3 3.5-7.7 7.7-7.7h29c13.4 0 24.3-10.9 24.3-24.3v-194c0-13.4-10.9-24.3-24.3-24.3h-145.5zm-256.3 78.5c1.8 0 3.5.6 4.8 1.7 26.5 21.3 58.4 32.6 92.4 32.6 61.9 0 117.6-39.2 138.6-97.5l1.1-3h-.6c5-15 7.6-30.6 7.6-46.6 0-81-65.9-146.9-147-146.9-81 0-147 65.9-147 146.9 0 15.9 2.5 31.6 7.6 46.6l1.1 3c4.7 13.1 11.3 25.5 19.5 36.8 1.6 2.3 1.9 5.2.8 7.8l-12.4 27.2 31.2-8.1c.8-.3 1.5-.5 2.3-.5z" />
  </svg>
);

export const gym = (
  <svg viewBox="0 0 512 512" width="35px" height="45px">
    <path d="m482 206h-18.5v-45c0-22.1-17.9-40-40-40-7.7 0-14.9 2.2-21 6-4.1-17.7-20-31-39-31-22 0-40 17.9-40 40v70h-135v-70c0-22.1-18-40-40-40-18.9 0-34.9 13.2-39 31-6.1-3.8-13.3-6-21-6-22.1 0-40 17.9-40 40v45h-18.5c-16.5 0-30 13.5-30 30v40c0 16.5 13.5 30 30 30h18.5v45c0 22.1 17.9 40 40 40 7.7 0 14.9-2.2 21-6 4.1 17.7 20 31 39 31 22 0 40-17.9 40-40v-70h135v70c0 22.1 18 40 40 40 18.9 0 34.9-13.2 39-31 6.1 3.8 13.3 6 21 6 22.1 0 40-17.9 40-40v-45h18.5c16.5 0 30-13.5 30-30v-40c0-16.5-13.5-30-30-30zm-433.5 80h-18.5c-5.5 0-10-4.5-10-10v-40c0-5.5 4.5-10 10-10h18.5zm60 65c0 5.5-2.2 10.5-5.9 14.1s-8.6 5.9-14.1 5.9c-11 0-20-9-20-20v-190c0-11 9-20 20-20s20 9 20 20zm60 25c0 11-9 20-20 20-11 0-20-9-20-20v-240c0-11 9-20 20-20s20 9 20 20zm154.9-110v20h-134.9v-60h135v20m60 130c0 11-9 20-20 20s-20-9-20-20v-119.5c0 .2 0 .4-.1.6v-2.3c0 .2.1.4.1.6v-119.4c0-11 9-20 20-20 11 0 20 9 20 20zm60-25c0 11-9 20-20 20s-20-9-20-20v-190c0-11 9-20 20-20s20 9 20 20zm48.5-75c0 5.5-4.5 10-10 10h-18.5v-60h18.5c5.5 0 10 4.5 10 10z" />
  </svg>
);

export const euro = (
  <svg viewBox="0 0 512 512" width="35px" height="45px">
    <path d="m346 330.3c-4.6 0-8.3-3.7-8.3-8.3s3.7-8.3 8.3-8.3c81.4 0 147.7-66.3 147.7-147.7s-66.3-147.7-147.7-147.7-147.7 66.3-147.7 147.7c0 4.6-3.7 8.3-8.3 8.3s-8.3-3.7-8.3-8.3c0-90.6 73.7-164.3 164.3-164.3s164.3 73.7 164.3 164.3-73.7 164.3-164.3 164.3z" />
    <path d="m166 510.3c-90.6 0-164.3-73.7-164.3-164.3s73.7-164.3 164.3-164.3c18.2 0 36 3 53.1 8.8.1 0 11.7 3.8 22.8 9.8 30.2 15.8 54.4 40.1 70.1 70.3.4.9 4.9 11.4 9.6 22.4 5.8 17 8.8 34.9 8.8 53-.1 90.6-73.8 164.3-164.4 164.3zm0-312c-81.4 0-147.7 66.3-147.7 147.7s66.3 147.7 147.7 147.7 147.7-66.3 147.7-147.7-66.3-147.7-147.7-147.7z" />
    <path d="m367.9 225.3c-25.7 0-49.1-18.3-58.4-45.4l-.4-1.2h-12.4c-4.6 0-8.3-3.7-8.3-8.3s3.7-8.3 8.3-8.3h9l-.1-1.8c-.2-2.1-.2-4-.2-5.8 0-1.2 0-2.5.1-3.8l.1-1.8h-8.8c-4.6 0-8.3-3.7-8.3-8.3s3.7-8.3 8.3-8.3h11.8l.4-1.2c8.8-28.4 32.5-47.4 59-47.4 10.1 0 20.2 2.8 29.1 8.1 1.9 1.1 3.3 2.9 3.8 5.1.5 2.1.2 4.4-.9 6.3-1.5 2.5-4.2 4.1-7.1 4.1-1.5 0-3-.4-4.2-1.2-6.4-3.8-13.4-5.8-20.6-5.8-17.3 0-33 11.4-40.9 29.6l-1 2.4h44.4c4.6 0 8.3 3.7 8.3 8.3s-3.7 8.3-8.3 8.3h-48.2l-.1 1.6c-.1 1.5-.1 2.8-.1 4 0 2 .1 4 .3 6l.1 1.5h37.4c4.6 0 8.3 3.7 8.3 8.3s-3.7 8.3-8.3 8.3h-33.3l1.2 2.4c8.2 17 23.5 27.6 40 27.6 7.2 0 14.1-1.9 20.6-5.8 1.3-.8 2.8-1.2 4.2-1.2 2.9 0 5.7 1.6 7.1 4.1 2.3 3.9 1 9-2.9 11.4-8.9 5.4-18.9 8.2-29 8.2z" />
    <path d="m387.4 486.4c-.9 0-1.8-.1-2.7-.4l-28.6-9.7c-2.1-.7-3.8-2.2-4.8-4.2s-1.1-4.3-.4-6.3l9.7-28.6c1.1-3.4 4.3-5.6 7.9-5.6.9 0 1.8.1 2.7.4 4.3 1.5 6.7 6.2 5.2 10.5l-3 8.8 4.1-2.6c35.7-22.8 64.4-55.2 82.8-93.7 1.4-2.9 4.3-4.7 7.5-4.7 1.2 0 2.4.3 3.6.8 2 1 3.5 2.6 4.2 4.7s.6 4.3-.3 6.3c-20.4 42.7-52.3 78.2-92.4 102.8l-3.1 1.9 10.3 3.5c4.3 1.5 6.7 6.2 5.2 10.5-1.2 3.3-4.3 5.6-7.9 5.6z" />
    <path d="m44.2 154.4c-1.3 0-2.6-.3-3.8-.9-2-1-3.4-2.8-4.1-4.9s-.5-4.4.6-6.3c20.5-39.1 51.1-71.9 88.7-94.9l3.1-1.9-10.7-3.7c-2.1-.7-3.8-2.2-4.8-4.2s-1.1-4.2-.4-6.3c1.1-3.4 4.3-5.6 7.9-5.6.9 0 1.8.1 2.7.4l28.6 9.7c4.3 1.5 6.7 6.2 5.2 10.5l-9.7 28.6c-1.1 3.4-4.3 5.6-7.9 5.6-.9 0-1.8-.1-2.7-.4-4.3-1.5-6.7-6.2-5.2-10.5l2.9-8.4-4.1 2.6c-33.2 21.2-60.5 51-78.9 86.1-1.4 2.8-4.2 4.5-7.4 4.5z" />
    <path d="m166 434c-4.6 0-8.3-3.7-8.3-8.3v-7.3l-1.4-.3c-20.1-4.1-34.6-21-34.6-40 0-4.6 3.7-8.3 8.3-8.3s8.3 3.7 8.3 8.3c0 9.9 6.7 18.7 17.1 22.5l2.3.8v-48.4l-1.4-.3c-20.1-4.1-34.6-21-34.6-40s14.6-35.8 34.6-40l1.4-.3v-6c0-4.6 3.7-8.3 8.3-8.3s8.3 3.7 8.3 8.3v6l1.4.3c20.1 4.1 34.6 21 34.6 40 0 4.6-3.7 8.3-8.3 8.3s-8.3-3.7-8.3-8.3c0-9.9-6.7-18.7-17.1-22.5l-2.3-.8v48.6l1.4.3c20.1 4.1 34.6 21 34.6 40s-14.6 35.8-34.6 40l-1.4.3v7.3c0 4.4-3.7 8.1-8.3 8.1zm8.3-32.4 2.3-.8c10.4-3.8 17.1-12.6 17.1-22.5s-6.7-18.7-17.1-22.5l-2.3-.8zm-18.9-111.3c-10.4 3.8-17.1 12.6-17.1 22.5s6.7 18.7 17.1 22.5l2.3.8v-46.7z" />
  </svg>
);

export const drink = (
  <svg viewBox="0 0 361 450.4" width="35px" height="45px">
    <path d="m354.2 332.8h-104.8l24.4-228.8c.4-4-2.4-7.2-6.4-7.6-.4 0-.4 0-.8 0h-78.8l4.2-28.3c2-12.8 12.8-22 25.6-22h98.4c4 0 7.2-3.2 7.2-7.2s-3.2-7.2-7.2-7.2h-98.4c-19.6 0-36.4 14.8-39.2 34.4l-4.6 29.9h-158.8c-4 0-6.8 3.2-6.8 7.2v.8l7.6 72.4 28.4 267.6c.4 3.6 3.2 6.4 6.8 6.4h179.6c1.2 0 2.8-.4 4-1.2 60.4 8.8 116.4-32.4 125.2-92.8.8-5.2 1.2-10.8 1.2-16.4 0-4-3.2-7.2-6.8-7.2zm-141.2 54.4 30.8-30.8v43.6c-11.2-1.2-22-5.6-30.8-12.8zm-22.8-40.4h43.2l-30.8 30.4c-6.4-8.4-10.8-19.2-12.4-30.4zm67.6 10 30.8 30.8c-8.8 7.2-19.6 11.6-30.8 12.8zm40.4 20.8-30.8-30.4h43.2c-.8 10.8-5.2 21.6-12.4 30.4zm-150.8-44.8c-4 0-7.2 3.2-7.2 7.2 0 18.8 4.8 37.6 14.4 54h-101.6l-22-206.8c16.4 6.8 81.6 15.2 129.2 6l-11.2 79.2c-.4 4 2 7.2 6 8h.8c3.6 0 6.4-2.4 6.8-6l11.6-84c28-6 52.8-2.4 74.4 10l-14 132.4zm111.2-222.4-8 74.8c-22.8-11.6-48.8-14.8-74-9.6l9.2-65.2zm-86.8 0-9.6 68.4c-56.8 12.4-123.6-2.8-132.8-7.6l-6.4-60.8zm-114.4 326-2.8-28.4h109.6c9.2 11.6 20.4 21.2 32.8 28.4zm193.2 0c-5.6 0-11.6-.4-17.2-1.6-.8 0-1.6-.4-2.8-.4-42-9.2-73.2-44.4-76-87.2h21.6c1.6 17.2 9.2 32.8 20.8 45.2l.4.4s.4 0 .4.4c29.2 28.8 76 28.8 105.2 0l.4-.4.4-.4c12-12.4 19.2-28 20.8-45.2h21.6c-3.2 50-45.2 88.8-95.6 89.2z" />
  </svg>
);

export const oversized_double_sinks = (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 400 400"
    width="35px"
    height="35px"
  >
    <path d="M348.49,381.25l-9.81-34.81A81.34,81.34,0,0,0,381.25,275v-6.25a12.52,12.52,0,0,0,12.5-12.5v-12.5a12.52,12.52,0,0,0-12.5-12.5v-62.5a12.52,12.52,0,0,0,12.5-12.5v-12.5a12.52,12.52,0,0,0-12.5-12.5H218.75a12.52,12.52,0,0,0-12.5,12.5v12.5a12.52,12.52,0,0,0,12.5,12.5v62.5a12.52,12.52,0,0,0-12.5,12.5v12.5a12.52,12.52,0,0,0,12.5,12.5V275a81.34,81.34,0,0,0,42.57,71.44l-9.81,34.81H168.12a31.31,31.31,0,0,0-30.62-25h-6.25V300a81.36,81.36,0,0,0,50-75V181.25H68.75v-25h25v12.5h12.5v-12.5a12.52,12.52,0,0,0-12.5-12.5h-50a12.52,12.52,0,0,0-12.5,12.5v25H18.75V225a81.36,81.36,0,0,0,50,75v56.27H62.5a31.31,31.31,0,0,0-30.62,25H0v12.5H400v-12.5ZM218.74,143.75H381.25v12.5H218.75Zm12.51,50h25v-12.5h-25v-12.5h137.5v62.5H231.25Zm-12.51,50H381.25v12.5H218.75ZM231.25,275v-6.25h137.5V275a68.75,68.75,0,0,1-137.5,0Zm41.63,76.5a79.8,79.8,0,0,0,54.24,0l8.37,29.75h-71ZM43.75,156.25h12.5v25H43.75Zm125,37.5v12.5H31.25v-12.5ZM31.25,225v-6.25h137.5V225a68.75,68.75,0,0,1-137.5,0Zm50,79a78.57,78.57,0,0,0,37.5,0v52.27H81.25ZM62.5,368.75h75a18.72,18.72,0,0,1,17.6,12.5H44.9A18.72,18.72,0,0,1,62.5,368.75Z" />
    <path d="M25,131.25H175a18.77,18.77,0,0,0,18.75-18.75V25A18.77,18.77,0,0,0,175,6.25H25A18.77,18.77,0,0,0,6.25,25v87.5A18.77,18.77,0,0,0,25,131.25ZM18.75,25A6.26,6.26,0,0,1,25,18.75H175A6.26,6.26,0,0,1,181.25,25v87.5a6.26,6.26,0,0,1-6.25,6.25H25a6.26,6.26,0,0,1-6.25-6.25Z" />
    <path d="M26.83,35.68l8.83-8.84,75,75-8.83,8.84Z" />
    <path d="M89.32,35.68l8.84-8.84,75,75-8.84,8.83Z" />
  </svg>
);

export const coffee_kitchenette = (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 400 400"
    width="35px"
    height="35px"
  >
    <path d="M53.94,351.09H346.06a5,5,0,0,0,5-5V325.91a5,5,0,0,0-5-5h-5v-5a25.2,25.2,0,0,0-25.18-25.18h-5V139.56H341a5,5,0,0,0,5-5V53.94a5,5,0,0,0-5-5H59a5,5,0,0,0-5,5v80.59a5,5,0,0,0,5,5H89.2v151.1h-5A25.2,25.2,0,0,0,59,315.84v5h-5a5,5,0,0,0-5,5v20.15A5,5,0,0,0,53.94,351.09ZM64,129.49V59H336v70.51Zm181,131h.29a20.15,20.15,0,0,0,0-40.29H159.71a5,5,0,0,0-5,5V255.4a45.28,45.28,0,0,0,16.88,35.26H99.27V139.56h50.37v5a35.3,35.3,0,0,0,30.21,34.89v5.4a5,5,0,0,0,10.08,0v-5h20.14v5a5,5,0,0,0,10.08,0v-5.4a35.3,35.3,0,0,0,30.21-34.89v-5h50.37v151.1H228.45A45.31,45.31,0,0,0,245,260.44Zm-45,30.22a35.32,35.32,0,0,1-35.26-35.26V230.22h70.52V255.4A35.32,35.32,0,0,1,200,290.66Zm45.33-40.3V230.22a10.07,10.07,0,0,1,0,20.14ZM160.21,149.64a25.87,25.87,0,0,1-.5-5v-5h80.58v5a25.87,25.87,0,0,1-.5,5Zm75,10.07a25.15,25.15,0,0,1-20.13,10.07H184.89a25.15,25.15,0,0,1-20.13-10.07ZM69.05,315.84a15.13,15.13,0,0,1,15.11-15.11H315.84A15.13,15.13,0,0,1,331,315.84v5H69.05ZM59,331H341V341H59Z" />
    <path d="M310.8,89.2a15.11,15.11,0,1,0,15.11,15.11A15.11,15.11,0,0,0,310.8,89.2Zm0,20.14a5,5,0,1,1,5-5A5,5,0,0,1,310.8,109.34Z" />
    <path d="M270.51,89.2a15.11,15.11,0,1,0,15.11,15.11A15.11,15.11,0,0,0,270.51,89.2Zm0,20.14a5,5,0,1,1,5-5A5,5,0,0,1,270.51,109.34Z" />
    <path d="M129.49,69.05H79.12a5,5,0,0,0-5,5V94.23a5,5,0,0,0,5,5h50.37a5,5,0,0,0,5-5V74.09A5,5,0,0,0,129.49,69.05Zm-5,20.15H84.16V79.12h40.29Z" />
  </svg>
);

export const spacious_bedroom = (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 400 400"
    width="35px"
    height="35px"
  >
    <g id="Bed-2">
      <path d="M100,183.33H86.67v-20A6.67,6.67,0,0,0,80,156.67H60V123.33H86.67a6.66,6.66,0,0,0,6.66-6.66,6.31,6.31,0,0,0-.2-1.62L79.8,61.71a6.67,6.67,0,0,0-6.47-5h-40a6.66,6.66,0,0,0-6.46,5L13.53,115.05a6.66,6.66,0,0,0,4.85,8.08,6.31,6.31,0,0,0,1.62.2H46.67v33.34h-20A6.66,6.66,0,0,0,20,163.33v20H6.67A6.67,6.67,0,0,0,0,190v26.67a6.66,6.66,0,0,0,6.67,6.66V336.67a6.66,6.66,0,0,0,6.66,6.66H40a6.67,6.67,0,0,0,6.67-6.66v-20H60v20a6.66,6.66,0,0,0,6.67,6.66H93.33a6.66,6.66,0,0,0,6.67-6.66V223.33a6.67,6.67,0,0,0,6.67-6.66V190A6.67,6.67,0,0,0,100,183.33ZM38.54,70H68.13l10,40H28.54ZM33.33,170h40v13.33h-40Zm-20,26.67h80V210h-80ZM20,290H86.67v13.33H20Zm13.33,40H20V316.67H33.33Zm40,0V316.67H86.67V330Zm13.34-53.33H20V223.33H86.67Z" />
      <rect x="60" y="236.67" width="13.33" height="13.33" />
      <path d="M386.67,184.56V83.33a20,20,0,0,0-20-20H153.33a20,20,0,0,0-20,20V184.56A20,20,0,0,0,120,203.33V336.67a6.66,6.66,0,0,0,6.67,6.66h26.66a6.66,6.66,0,0,0,6.67-6.66V303.33H360v33.34a6.66,6.66,0,0,0,6.67,6.66h26.66a6.66,6.66,0,0,0,6.67-6.66V203.33A20,20,0,0,0,386.67,184.56ZM133.33,263.33H386.67V290H133.33Zm20-186.66H366.67a6.66,6.66,0,0,1,6.66,6.66v100H360V150a20,20,0,0,0-20-20H286.67a20,20,0,0,0-20,20v33.33H253.33V150a20,20,0,0,0-20-20H180a20,20,0,0,0-20,20v33.33H146.67v-100A6.66,6.66,0,0,1,153.33,76.67ZM346.67,183.33H280V150a6.67,6.67,0,0,1,6.67-6.67H340a6.67,6.67,0,0,1,6.67,6.67Zm-106.67,0H173.33V150a6.67,6.67,0,0,1,6.67-6.67h53.33A6.67,6.67,0,0,1,240,150ZM140,196.67H380a6.67,6.67,0,0,1,6.67,6.66V250H133.33V203.33A6.67,6.67,0,0,1,140,196.67ZM146.67,330H133.33V303.33h13.34Zm226.66,0V303.33h13.34V330Z" />
    </g>
  </svg>
);

export const outdoor_shower = (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 400 400"
    width="35px"
    height="35px"
  >
    <path d="M238.74,225.38A6.57,6.57,0,0,0,229.6,227l-8.39,12A6.56,6.56,0,1,0,232,246.54l8.39-12A6.56,6.56,0,0,0,238.74,225.38Z" />
    <path d="M188.05,223.89a6.47,6.47,0,0,0,3.74,1.18,6.54,6.54,0,0,0,5.39-2.82l8.37-12a6.57,6.57,0,0,0-10.78-7.5l-8.36,12a6.55,6.55,0,0,0,1.64,9.13Z" />
    <path d="M153.22,199.59a6.56,6.56,0,0,0,9.14-1.63l8.39-12a6.56,6.56,0,0,0-10.77-7.5l-8.39,12a6.57,6.57,0,0,0,1.63,9.14Z" />
    <path d="M204,275.16a6.56,6.56,0,0,0-9.14,1.64l-8.39,12a6.56,6.56,0,1,0,10.77,7.51l8.39-12A6.57,6.57,0,0,0,204,275.16Z" />
    <path d="M169.21,250.87a6.56,6.56,0,0,0-9.14,1.63l-8.38,12a6.56,6.56,0,1,0,10.76,7.5l8.39-12A6.56,6.56,0,0,0,169.21,250.87Z" />
    <path d="M134.4,226.59a6.56,6.56,0,0,0-9.14,1.63l-8.39,12a6.56,6.56,0,1,0,10.77,7.51l8.38-12A6.56,6.56,0,0,0,134.4,226.59Z" />
    <path d="M169.21,327.67a6.57,6.57,0,0,0-9.14,1.64l-8.38,12a6.56,6.56,0,1,0,10.76,7.51l8.39-12A6.56,6.56,0,0,0,169.21,327.67Z" />
    <path d="M134.39,303.38a6.55,6.55,0,0,0-9.13,1.63l-8.39,12a6.56,6.56,0,0,0,10.77,7.5l8.39-12A6.55,6.55,0,0,0,134.39,303.38Z" />
    <path d="M99.58,279.1a6.56,6.56,0,0,0-9.14,1.63l-8.38,12a6.56,6.56,0,1,0,10.76,7.51l8.39-12A6.57,6.57,0,0,0,99.58,279.1Z" />
    <path d="M381.29,44H358a18.73,18.73,0,0,0-18.71,18.71V80.32H303.51a48.93,48.93,0,0,0-30.62,10.84,49.5,49.5,0,0,0-14.33,19,57.86,57.86,0,0,0-72.68,20.37,6.55,6.55,0,0,0,1.84,9.1l85.33,56.55a6.56,6.56,0,0,0,3.63,1.1,7.16,7.16,0,0,0,1.3-.13,6.58,6.58,0,0,0,4.17-2.81,57.86,57.86,0,0,0-12.27-77.15,36.1,36.1,0,0,1,33.63-23.7h35.75V286H310.62v-7.52a6.57,6.57,0,1,0-13.13,0v28.16a6.57,6.57,0,1,0,13.13,0v-7.52h28.64v82.22A18.73,18.73,0,0,0,358,400h23.32A18.73,18.73,0,0,0,400,381.29V241.44a6.57,6.57,0,0,0-13.13,0V381.29a5.58,5.58,0,0,1-5.58,5.58H358a5.58,5.58,0,0,1-5.58-5.58V62.68A5.59,5.59,0,0,1,358,57.09h23.32a5.59,5.59,0,0,1,5.58,5.59V252.51a6.57,6.57,0,0,0,13.13,0V62.68A18.73,18.73,0,0,0,381.29,44ZM274.43,181.31l-73.58-48.77a44.62,44.62,0,0,1,73.58,48.77Z" />
    <path d="M27.45,85.21A26.52,26.52,0,0,1,1,58.72,26,26,0,0,1,8.81,40a25.7,25.7,0,0,1,18.64-7.74h3.91L32,29.66a36.47,36.47,0,0,1,70.62,0l.67,2.58h3.92a26.52,26.52,0,0,1,26.49,26.49,26,26,0,0,1-7.87,18.76,25.64,25.64,0,0,1-18.62,7.73Zm0-39.89A13.52,13.52,0,0,0,14,58.72,13.42,13.42,0,0,0,27.45,72.13h79.79a13.54,13.54,0,0,0,13.4-13.41,13.41,13.41,0,0,0-13.4-13.4h-10a6.55,6.55,0,0,1-6.54-6.55,23.38,23.38,0,1,0-46.76,0,6.55,6.55,0,0,1-6.54,6.55Z" />
  </svg>
);

export const high_ceilings = (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 400 400"
    width="35px"
    height="35px"
  >
    <defs></defs>
    <circle cx="284.14" cy="233.37" r="14.62" />
    <path d="M329.24,312.45c-4.12-46.31-26.19-55.55-26.19-55.55a40.84,40.84,0,0,0-43.79,3.51c-14.55,13.25-17.91,33.47-20.22,53-1.16,9.92,14.37,9.8,15.52,0,1.38-11.66,3.34-23.37,9.12-33.35l0,11.26-.11,54.09v42.91a8.08,8.08,0,0,0,8.13,8.35,8.48,8.48,0,0,0,8.6-8.35V327h7.59v61.53c0,10,15.52,10,15.52,0V345.41l.65-54.19c0-5.18,0-9.8,0-13,6.2,10.16,8.25,22.22,9.66,34.23C314.88,322.25,330.4,322.37,329.24,312.45Z" />
    <line className="cls-1" x1="6.42" y1="392.16" x2="393.38" y2="392.16" />
    <line className="cls-1" x1="6.42" y1="7" x2="393.38" y2="7" />
    <line className="cls-2" x1="129.66" y1="24.85" x2="129.66" y2="373.55" />
    <polygon points="76.49 67.92 86.01 76.79 129.65 29.84 173.29 76.79 182.82 67.92 129.65 10.75 76.49 67.92" />
    <polygon points="76.49 330.47 86.01 321.61 129.65 368.56 173.29 321.61 182.82 330.47 129.65 387.65 76.49 330.47" />
  </svg>
);

export const seating_area = (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 400 400"
    width="35px"
    height="35px"
  >
    <path d="M361.7,218.82a23.15,23.15,0,0,0,.61-18.53l-.08-.21a19.34,19.34,0,0,0-6.51-8.56,15,15,0,0,0,1.13-5.74V155.84a15.15,15.15,0,0,0-15.14-15.13h-16.1a14.38,14.38,0,0,0-2,.13V103.66A18.47,18.47,0,0,0,305.2,85.21H211.88A18.37,18.37,0,0,0,200,89.56a18.37,18.37,0,0,0-11.88-4.35H96.67a18.48,18.48,0,0,0-18.45,18.45v37.18a16.22,16.22,0,0,0-2-.13H60.13A15.15,15.15,0,0,0,45,155.84v29.94a14.85,14.85,0,0,0,.77,4.74,19.16,19.16,0,0,0-8,9.55l-.09.21a23.17,23.17,0,0,0,.61,18.54,6.56,6.56,0,0,0-6.52,6.57V270a6.57,6.57,0,0,0,6.57,6.57H56.44v31.7A6.57,6.57,0,0,0,63,314.79H81.32a6.58,6.58,0,0,0,5.78-3.44L106,276.52H294l18.9,34.83a6.58,6.58,0,0,0,5.78,3.44H337a6.57,6.57,0,0,0,6.57-6.57v-31.7h18.09a6.57,6.57,0,0,0,6.57-6.57V225.39a6.56,6.56,0,0,0-6.52-6.57ZM206.57,206.93a6,6,0,0,1,6-6H344.34a6,6,0,0,1,5.63,3.91l.13.31a9.93,9.93,0,0,1-1,9.34,9.79,9.79,0,0,1-8.2,4.34H206.57Zm119-53.08h16.1a2,2,0,0,1,2,2v29.94a2,2,0,0,1-2,2h-16.1c-2.66,0-2-3.61-2-5.32V155.58A2,2,0,0,1,325.61,153.85ZM211.88,98.35H305.2a5.31,5.31,0,0,1,5.3,5.31l0,79.31a5.31,5.31,0,0,1-5.27,4.79H211.88a5.31,5.31,0,0,1-5.31-5.31V103.66A5.31,5.31,0,0,1,211.88,98.35ZM91.37,103.66a5.31,5.31,0,0,1,5.3-5.31h91.45a5.31,5.31,0,0,1,5.31,5.31v78.81a5.31,5.31,0,0,1-5.31,5.3H103.24c-4.5,0-11-3.57-11.87-5.47ZM58.13,155.84a2,2,0,0,1,2-2h16.1a2,2,0,0,1,2,2v26.63c0,1.69.64,5.3-2,5.3H60.13a2,2,0,0,1-2-2ZM77.41,301.65H69.58V276.52H91.05Zm253,0h-7.83L309,276.52h21.47Zm24.66-38.27H44.92V232h40.9a6.57,6.57,0,0,0,0-13.14H59.1a9.79,9.79,0,0,1-8.2-4.34,9.91,9.91,0,0,1-1-9.33l.13-.32a6,6,0,0,1,5.63-3.91H187.42a6,6,0,0,1,6,6v11.88H72.48a6.58,6.58,0,0,0,0,13.15h282.6Z" />
  </svg>
);

export const kitchenette = (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 400 400"
    width="35px"
    height="35px"
  >
    <path d="M200,210.66H384.8c3.39,0,3.4,0,3.4-3.43,0-3-.11-6.06,0-9.07.1-2-.67-2.55-2.61-2.54-12.18.09-24.37.07-36.55,0-4.06,0-6.51-2.47-6.31-6.17.17-3.23,2.62-5.46,6.32-5.49,7.81-.06,15.63,0,23.44,0,4.88,0,9.75,0,14.62,0,7.53.08,12.75,5.38,12.78,12.94,0,4.37,0,8.74,0,13.11a12.13,12.13,0,0,1-12.09,12.25c-1.43,0-2.87.1-4.29,0-1.79-.14-2.33.63-2.31,2.34.07,5.72,0,11.43,0,17.14q0,69.94,0,139.89c0,8.8-4.5,15.17-12.45,17.37a25,25,0,0,1-6.49.6q-139.65,0-279.3,0c-15.63,0-31.25,0-46.88,0-8.43,0-14.77-4.8-16.88-12.77a23.45,23.45,0,0,1-.5-6q0-77.39,0-154.76c0-3.82,0-3.63-3.81-3.88C12,222,9,221.8,6.41,220.66,2.17,218.76.17,215,.11,210.28S.05,201,.1,196.42A12.14,12.14,0,0,1,12.54,184c10.76-.05,21.52-.08,32.27.05,2.43,0,3.42-.68,3-3.09a3.86,3.86,0,0,1,0-.76c.36-3.57.25-6.17-4.48-7.39-5.2-1.35-7.65-6-8-11.41a77.39,77.39,0,0,1,0-8.06c.13-3.77,2.51-6.19,5.91-6.17s5.64,2.44,5.73,6.28c.05,2.18.05,4.37,0,6.55a2.14,2.14,0,0,0,2.43,2.49l1.76,0H133.6c4.09,0,4.11,0,4.12-4,0-1.85-.08-3.7.06-5.54.27-3.62,2.68-5.85,6-5.75,3.18.1,5.41,2.44,5.51,6,.09,2.86.1,5.72,0,8.57a12.71,12.71,0,0,1-10.33,12c-1.7.34-2.27,1.07-2.17,2.69a32.61,32.61,0,0,1,0,5c-.2,2.08.7,2.53,2.61,2.53q35.3-.08,70.58,0l113.69,0c5.16,0,8.12,3.23,6.89,7.46a5.41,5.41,0,0,1-5.1,4.15c-1.25.11-2.52,0-3.78,0H15.91a7.69,7.69,0,0,0-2.5.07c-.66.25-1.59,1-1.61,1.57-.14,3.94-.13,7.9,0,11.84,0,.52.86,1.26,1.46,1.44a10.13,10.13,0,0,0,2.76.08Zm169.38,11.63H209.14c-3.34,0-3.36,0-3.36,3.32v70.8c0,3.38,0,3.39,3.29,3.39q78.75,0,157.49.06c2.49,0,3.06-.76,3.05-3.13-.08-23.77-.05-47.54-.05-71.31C369.56,224.51,369.47,223.6,369.41,222.29Zm-81.57,89.19v0H209.19c-3.39,0-3.41,0-3.41,3.31,0,23.35,0,46.71-.06,70.07,0,2.63.85,3.2,3.32,3.19q76.75-.11,153.52-.08c5.44,0,7-1.56,7-7.09q0-33,0-66c0-3.32,0-3.34-3.29-3.34Zm-93.7-6.36V225.75c0-3.46,0-3.46-3.46-3.46l-157,0c-3.29,0-3.29,0-3.29,3.3l0,155.21c0,5.66,1.49,7.15,7.16,7.15H190.74c3.4,0,3.4,0,3.4-3.48ZM92.24,184h26.21c6.76,0,6.64,0,6.79-6.65.06-2.55-.68-3.26-3.24-3.25-18.49.11-37,.06-55.45.06-7.15,0-7.07,0-7.08,7.22,0,2.15.76,2.68,2.78,2.66C72.25,184,82.24,184,92.24,184Z" />
    <path d="M303.05.45c26.46,0,52.93.21,79.38-.1A17,17,0,0,1,400,17.81c-.2,33.76-.07,67.53-.08,101.29,0,10.65-6.6,17.35-17.23,17.35q-79.63,0-159.27,0c-10.5,0-17.11-6.72-17.11-17.21,0-33.77.14-67.53-.05-101.3C206.19,7.35,214.12.22,223.92.34,250.3.66,276.68.45,303.05.45ZM309,68.35h0c0,17.81,0,35.61,0,53.42,0,2.15.39,3.1,2.87,3.09,23.52-.09,47,0,70.55-.06,4.52,0,5.86-1.37,5.86-5.86q0-50.4,0-100.79c0-4.67-1.34-6-5.92-6-23.52,0-47,0-70.56-.06-2.33,0-2.76.76-2.75,2.88C309,32.74,309,50.54,309,68.35Zm-11.67.22c0-17.81,0-35.62.05-53.43,0-2.43-.68-3.11-3.11-3.1-23.27.09-46.55.05-69.82.05-5.23,0-6.45,1.24-6.45,6.57q0,49.91,0,99.8c0,5.1,1.22,6.34,6.41,6.34H294c3.33,0,3.34,0,3.34-3.32Z" />
    <path d="M96,74.36q-41.32,0-82.66,0c-6.85,0-11.81-3-12.72-9a55.55,55.55,0,0,1,0-15.77C1.31,44,6.22,40.6,12,40.44c2.27-.06,4.56.15,6.8-.08A3.08,3.08,0,0,0,21,38.63c3.89-13.49,13.72-21,27.78-21H143c14,0,23.82,7.3,27.7,20.72.51,1.78,1.32,2.17,3,2.13a45.85,45.85,0,0,1,8,.22c6,.93,9.7,5.19,10,11.21.18,3.61.19,7.23,0,10.83-.28,7-5.33,11.62-12.6,11.63q-35.41,0-70.82,0H96ZM32.71,40.45c5.4,0,10.42,0,15.43,0A16.65,16.65,0,0,1,52.6,41c2.62.79,4,3.27,3.68,6.14a5.55,5.55,0,0,1-5,4.87,27.62,27.62,0,0,1-3,.1c-11.34,0-22.68,0-34,0-2,0-2.77.56-2.58,2.57.14,1.41,0,2.85,0,4.28,0,3.84,0,3.84,3.77,3.84L137,62.68c13.45,0,26.89,0,40.33,0,2.18,0,3.11-.64,2.89-2.88-.14-1.41,0-2.85,0-4.28,0-3.5,0-3.51-3.44-3.51L76.64,52.1c-.93,0-1.86,0-2.77-.06a5.54,5.54,0,0,1-5.16-4.69c-.4-3,1-5.53,3.69-6.39a14.47,14.47,0,0,1,4.21-.52q39.69,0,79.39,0h3.08a23.87,23.87,0,0,0-1.17-3,15.21,15.21,0,0,0-14.06-8.15q-47.88,0-95.77,0a17.49,17.49,0,0,0-5.44.81A14.69,14.69,0,0,0,32.71,40.45Z" />
    <path d="M287.69,231.49c5.11,0,10.23,0,15.35,0,3.9,0,6.3,2.12,6.39,5.57s-2.35,6.05-6.23,6.08q-15.48.09-30.95,0c-3.88,0-6.46-2.61-6.34-6s2.6-5.57,6.42-5.6c5.12,0,10.24,0,15.36,0Z" />
    <path d="M287.59,335.5c-5,0-10.07,0-15.1,0-4,0-6.52-2.29-6.58-5.71s2.63-5.94,6.66-5.95q15.09,0,30.19,0c4.14,0,6.67,2.3,6.65,5.89s-2.44,5.73-6.73,5.76c-5,0-10.06,0-15.09,0Z" />
    <path d="M113.22,376H56c-8.2,0-12.38-4.14-12.39-12.38q0-36.42,0-72.83c0-7.62,4.19-11.88,11.85-11.88q57.84-.06,115.68,0c7.68,0,11.75,4.24,11.76,11.94q0,36.42,0,72.83c0,8.18-4.21,12.29-12.48,12.29q-28.6,0-57.21,0Zm.19-11.66c18.23,0,36.46-.06,54.69.06,2.64,0,3.2-.78,3.19-3.26q-.15-33.9,0-67.79c0-2.27-.69-2.83-2.86-2.82q-55.2.07-110.39,0c-2.3,0-2.8.77-2.79,2.9q.09,34,0,68c0,2.37.72,2.94,3,2.93C76.61,364.32,95,364.36,113.41,364.36Z" />
    <path d="M43.66,250.34a19,19,0,0,1,19.2-18.83,19.18,19.18,0,0,1,19,19.15,19.45,19.45,0,0,1-19.45,19A19.17,19.17,0,0,1,43.66,250.34Zm11.66.12a7.45,7.45,0,0,0,7.2,7.55,7.69,7.69,0,0,0,7.62-7.48,7.43,7.43,0,0,0-7.42-7.34A7.27,7.27,0,0,0,55.32,250.46Z" />
    <path d="M113.29,231.51a19,19,0,0,1,19,19.07,19.05,19.05,0,1,1-38.1-.06A18.93,18.93,0,0,1,113.29,231.51Zm0,11.68a7.26,7.26,0,0,0-7.41,7.25,7.37,7.37,0,1,0,14.74.11A7.32,7.32,0,0,0,113.32,243.19Z" />
    <path d="M321,68.9c0-4.36,0-8.72,0-13.07,0-3.58,2.35-6.09,5.57-6.19a5.78,5.78,0,0,1,6,6.07q.15,13.2,0,26.4a5.7,5.7,0,0,1-6,6C323.18,88,321,85.64,320.94,82c-.05-4.36,0-8.72,0-13.07Z" />
    <path d="M285.25,68.92c0,4.27.05,8.55,0,12.82-.05,3.92-2.19,6.3-5.59,6.38s-6-2.36-6-6.32q-.15-12.83,0-25.65c0-4,2.43-6.51,5.84-6.54s5.74,2.52,5.79,6.48C285.3,60.37,285.25,64.64,285.25,68.92Z" />
  </svg>
);

export const breakfast = (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 400 400"
    width="35px"
    height="35px"
  >
    <path d="M54.22,337.53a5.86,5.86,0,0,0,4.49-10.83c-29.86-12.38-47-28.42-47-44,0-11.88,9.35-21.91,19.87-29.43C33.44,294.16,106.74,326,200,326s166.56-31.8,168.41-72.68c40.8,29.16,13.34,58.24-33.2,75.83-69.31,26.2-197.56,29.06-276.3-2.21a5.86,5.86,0,0,0-3.24,11.26c86.79,34,212.18,28.93,283.68,1.91C378.46,325.29,400,304.92,400,282.71c0-16.54-11.91-32.13-34.46-45.17a51.35,51.35,0,0,0-11.11-16.12c19.12-19.44,18.26-41.93,0-60.46,20.35-20.68,18.54-45.36-5.29-65.32C326,76.28,285,62.72,235.86,58.17V45.82a7.78,7.78,0,0,0-7.77-7.77H209a5.86,5.86,0,0,0,0,11.72h15.15V68.39H175.86V49.77h37.78a5.86,5.86,0,1,0,0-11.72H171.9a7.78,7.78,0,0,0-7.76,7.76V58.17C115.05,62.72,74,76.27,50.86,95.64c-10.93,9.14-19.3,21-19.3,35.14,0,10.81,5,21,14,30.18-18.25,18.52-19.13,41,0,60.46a51.31,51.31,0,0,0-11.1,16.12C11.91,250.58,0,266.17,0,282.71,0,303.56,19.25,323,54.22,337.53Zm.2-108.39c64.05,48.49,227.12,48.48,291.16,0a39.49,39.49,0,0,1,9.48,13.75c-8.47,11.83-27.15,22.69-53.05,30.76-59,18.4-144.37,18.58-204,0-25.9-8.07-44.58-18.93-53-30.76a39.49,39.49,0,0,1,9.48-13.75Zm258.27,65.52c-62.09,26.13-163.29,26.13-225.38,0-23.15-9.74-38.14-22.14-42.62-34.93C56,269.56,72.88,278.1,94.51,284.84c61,19,148.48,19.47,211,0,21.63-6.74,38.5-15.28,49.82-25.11-4.48,12.79-19.47,25.19-42.62,34.93Zm-258.27-126c64.05,48.49,227.12,48.48,291.16,0a39.49,39.49,0,0,1,9.48,13.75c-8.47,11.84-27.15,22.69-53.05,30.76-59,18.4-144.37,18.58-204,0-25.9-8.07-44.58-18.92-53-30.76a39.49,39.49,0,0,1,9.48-13.75ZM175.86,80.11h48.28V94.69H175.86ZM164.14,98.65a7.78,7.78,0,0,0,7.77,7.76h56.18a7.78,7.78,0,0,0,7.77-7.76V69.94c40.54,3.91,76,14.44,98,29-4.79,2-9.75,3.93-15,6.21-11.88,5.19-21.84,18.56-35.78,21.43-10.84,2.24-26.51-5.7-42.28-4.29-14.48,1.31-27.92,12.08-40.85,12.08s-26.35-10.77-40.85-12.08c-15.79-1.41-31.43,6.53-42.28,4.29-14-2.87-23.89-16.24-35.78-21.43-5.24-2.29-10.27-4.25-15-6.21,22-14.52,57.49-25.05,98-29Zm156.41,53.76A5.86,5.86,0,0,0,313,149c-60.79,22.73-153.39,23-215,3.76-25.9-8.07-44.58-18.92-53-30.76,1.92-5.06,5.49-10,10.64-14.87,6.07,2.79,13.82,5.69,20.82,8.75,9.85,4.29,20.9,18.62,38.11,22.17,14.27,2.95,29.82-5.34,43.59-4.1,12.06,1.09,25.84,12.13,41.9,12.13s29.82-11,41.9-12.13c13.73-1.24,29.33,7,43.59,4.1,17.19-3.54,28.27-17.88,38.11-22.17,6.85-3,14.79-6,20.82-8.75,5.15,4.83,8.72,9.81,10.64,14.87-3.81,5.32-9.7,10.46-17.56,15.32a5.86,5.86,0,0,0,6.17,10,89.4,89.4,0,0,0,11.65-8.48c-4.47,12.8-19.46,25.22-42.63,35-62.09,26.12-163.29,26.12-225.38,0C64.09,164,49.08,151.53,44.65,138.7c27.62,23.87,87.5,39.63,155.35,39.63,43.82,0,85.41-6.53,117.11-18.38a5.86,5.86,0,0,0,3.44-7.54ZM200,238.79c67.85,0,127.73-15.76,155.35-39.63-4.43,12.83-19.44,25.28-42.66,35-62.09,26.13-163.29,26.13-225.38,0-23.22-9.76-38.23-22.21-42.66-35C72.27,223,132.15,238.79,200,238.79Z" />
  </svg>
);

export const spa_bath = (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 400 400"
    width="35px"
    height="35px"
  >
    <path d="M393.55,216.13H335.48V196.77a6.45,6.45,0,0,0-6.45-6.45H251.61a6.45,6.45,0,0,0-6.45,6.45v19.36H64.52V67.74a32.26,32.26,0,1,1,64.51,0V81.19a38.78,38.78,0,0,0-32.26,38.16v6.46a6.46,6.46,0,0,0,6.46,6.45h64.51a6.45,6.45,0,0,0,6.45-6.45v-6.46a38.76,38.76,0,0,0-32.25-38.16V67.74a45.17,45.17,0,0,0-90.33,0V216.13H6.45A6.45,6.45,0,0,0,0,222.58v19.36a6.45,6.45,0,0,0,6.45,6.45H25.81v45.16a71.06,71.06,0,0,0,51.61,68.28V371a6.45,6.45,0,1,0,12.9,0v-6.75c2.13.19,4.28.3,6.45.3H303.23c2.17,0,4.32-.11,6.45-.3V371a6.45,6.45,0,0,0,12.9,0v-9.14a71.06,71.06,0,0,0,51.61-68.28V248.39h19.36a6.45,6.45,0,0,0,6.45-6.45V222.58A6.45,6.45,0,0,0,393.55,216.13ZM161.29,119.35H109.68a25.81,25.81,0,0,1,51.61,0Zm96.77,83.88h64.52V312.9H258.06ZM12.9,235.48V229H245.16v6.45Zm348.39,58.07a58.12,58.12,0,0,1-58.06,58.06H96.77a58.12,58.12,0,0,1-58.06-58.06V248.39H245.16v71a6.46,6.46,0,0,0,6.45,6.46H329a6.45,6.45,0,0,0,6.45-6.46v-71h25.81Zm25.81-58.07H335.48V229H387.1Z" />
    <path d="M129,261.29h-71a6.45,6.45,0,0,0,0,12.9h71a6.45,6.45,0,0,0,0-12.9Z" />
    <path d="M161.29,261.29h-12.9a6.45,6.45,0,0,0,0,12.9h12.9a6.45,6.45,0,1,0,0-12.9Z" />
    <path d="M219.35,164.52A19.36,19.36,0,1,0,200,145.16,19.36,19.36,0,0,0,219.35,164.52Zm0-25.81a6.45,6.45,0,1,1-6.45,6.45A6.46,6.46,0,0,1,219.35,138.71Z" />
    <path d="M264.52,125.81a32.26,32.26,0,1,0-32.26-32.26A32.26,32.26,0,0,0,264.52,125.81Zm0-51.62a19.36,19.36,0,1,1-19.36,19.36A19.35,19.35,0,0,1,264.52,74.19Z" />
    <path d="M283.87,145.16a25.81,25.81,0,1,0,25.81-25.81A25.81,25.81,0,0,0,283.87,145.16Zm25.81-12.9a12.9,12.9,0,1,1-12.91,12.9A12.91,12.91,0,0,1,309.68,132.26Z" />
  </svg>
);

export const king_bed = (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 400 400"
    width="35px"
    height="35px"
  >
    <path d="M393.55,271H387.1V219.35a25.84,25.84,0,0,0-25.81-25.8V83.87a25.85,25.85,0,0,0-25.81-25.81h-271A25.85,25.85,0,0,0,38.71,83.87V193.55a25.84,25.84,0,0,0-25.81,25.8V271H6.45A6.45,6.45,0,0,0,0,277.42v25.81a6.45,6.45,0,0,0,6.45,6.45H12.9v25.8a6.46,6.46,0,0,0,6.45,6.46H38.71A6.45,6.45,0,0,0,45,336.75l5.42-27.07h299.1L355,336.75a6.45,6.45,0,0,0,6.32,5.19h19.36a6.46,6.46,0,0,0,6.45-6.46v-25.8h6.45a6.45,6.45,0,0,0,6.45-6.45V277.42A6.45,6.45,0,0,0,393.55,271ZM51.61,83.87A12.92,12.92,0,0,1,64.52,71h271a12.92,12.92,0,0,1,12.91,12.9V193.55H335.48V167.74a25.82,25.82,0,0,0-25.8-25.8H232.26a25.83,25.83,0,0,0-25.81,25.8v25.81h-12.9V167.74a25.83,25.83,0,0,0-25.81-25.8H90.32a25.82,25.82,0,0,0-25.8,25.8v25.81H51.61Zm271,83.87v25.81H219.35V167.74a12.93,12.93,0,0,1,12.91-12.9h77.42A12.92,12.92,0,0,1,322.58,167.74Zm-141.93,0v25.81H77.42V167.74a12.92,12.92,0,0,1,12.9-12.9h77.42A12.93,12.93,0,0,1,180.65,167.74ZM25.81,219.35a12.92,12.92,0,0,1,12.9-12.9H361.29a12.92,12.92,0,0,1,12.9,12.9V271H25.81ZM33.42,329H25.81V309.68H37.29Zm340.77,0h-7.61l-3.87-19.35h11.48Zm12.91-32.26H12.9v-12.9H387.1Z" />
  </svg>
);

export const ac = (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 400 400"
    width="35px"
    height="35px"
  >
    <path d="M362.39,44H37.61A37.65,37.65,0,0,0,0,81.61v91.45a37.65,37.65,0,0,0,37.61,37.61H362.39A37.65,37.65,0,0,0,400,173.06V81.61A37.65,37.65,0,0,0,362.39,44Zm24.28,129.06a24.3,24.3,0,0,1-24.28,24.27H37.61a24.3,24.3,0,0,1-24.28-24.27V81.61A24.32,24.32,0,0,1,37.61,57.33H362.39a24.32,24.32,0,0,1,24.28,24.28v91.45Z" />
    <path d="M120,242.67a6.67,6.67,0,0,0-6.67,6.66v22.29a83.78,83.78,0,0,1-24.71,59.67,6.67,6.67,0,0,0,9.26,9.59l.17-.17a97.08,97.08,0,0,0,28.62-69.09V249.33A6.67,6.67,0,0,0,120,242.67Z" />
    <path d="M166.67,276a6.67,6.67,0,0,0-6.67,6.67v66.66a6.67,6.67,0,1,0,13.33,0V282.67A6.66,6.66,0,0,0,166.67,276Z" />
    <path d="M166.67,236a6.67,6.67,0,0,0-6.67,6.67v55.49a6.67,6.67,0,0,0,13.33,0V242.67A6.66,6.66,0,0,0,166.67,236Z" />
    <path d="M311.38,331.29a83.78,83.78,0,0,1-24.71-59.67V249.33a6.67,6.67,0,0,0-13.34,0v22.29A97.08,97.08,0,0,0,302,340.71a6.67,6.67,0,0,0,9.43-9.42Z" />
    <path d="M233.33,276a6.66,6.66,0,0,0-6.66,6.67v66.66a6.67,6.67,0,1,0,13.33,0V282.67A6.66,6.66,0,0,0,233.33,276Z" />
    <path d="M233.33,236a6.66,6.66,0,0,0-6.66,6.67v49.21a6.67,6.67,0,0,0,13.33,0V242.67A6.66,6.66,0,0,0,233.33,236Z" />
    <path d="M360,165.67H40A6.67,6.67,0,1,0,40,179H360a6.67,6.67,0,1,0,0-13.33Z" />
    <path d="M360,136H40a6.67,6.67,0,1,0,0,13.33H360A6.67,6.67,0,1,0,360,136Z" />
    <path d="M353.33,70.67H326.67a20,20,0,0,0,0,40h26.66a20,20,0,0,0,0-40Zm0,26.66H326.67a6.67,6.67,0,1,1,0-13.33h26.66a6.67,6.67,0,1,1,0,13.33Z" />
    <path d="M280,84H266.67a6.67,6.67,0,1,0,0,13.33H280A6.67,6.67,0,1,0,280,84Z" />
    <path d="M240,84H226.67a6.67,6.67,0,1,0,0,13.33H240A6.67,6.67,0,1,0,240,84Z" />
  </svg>
);

export const fan = (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 400 400"
    width="35px"
    height="35px"
  >
    <path d="M363.44,144.54a164.68,164.68,0,1,0-183.61,183.6v31.53H132.78a20.17,20.17,0,0,0-20.16,20.16V400H287.38V379.83a20.17,20.17,0,0,0-20.16-20.16H220.17V328.14A164.67,164.67,0,0,0,363.44,144.54ZM267.22,373.11a6.72,6.72,0,0,1,6.72,6.72v6.73H126.06v-6.73a6.72,6.72,0,0,1,6.72-6.72Zm-73.94-13.44V332.78h13.44v26.89ZM200,316A151.24,151.24,0,1,1,351.24,164.74,151.24,151.24,0,0,1,200,316Z" />
    <path d="M341.16,178.18V164.74a6.72,6.72,0,0,0-6.72-6.72h-78.6a73.89,73.89,0,0,0-42.4-134.44H200a6.72,6.72,0,0,0-6.72,6.72v78.59a73.89,73.89,0,0,0-134.44,42.4v13.45a6.72,6.72,0,0,0,6.72,6.72h78.6a73.89,73.89,0,0,0,42.4,134.44H200a6.72,6.72,0,0,0,6.72-6.73V220.58a73.89,73.89,0,0,0,134.44-42.4ZM206.72,37h6.72a60.5,60.5,0,0,1,18.58,118,33.61,33.61,0,0,0-25.3-23.27V37ZM72.29,158v-6.73a60.49,60.49,0,0,1,118-18.57A33.62,33.62,0,0,0,167.06,158Zm121,134.43h-6.72a60.49,60.49,0,0,1-18.58-118,33.6,33.6,0,0,0,25.3,23.26v94.78ZM200,184.9a20.17,20.17,0,1,1,20.17-20.16A20.16,20.16,0,0,1,200,184.9Zm67.11,53.67a60.49,60.49,0,0,1-57.43-41.82,33.6,33.6,0,0,0,23.26-25.29h94.77v6.72A60.5,60.5,0,0,1,267.11,238.57Z" />
  </svg>
);

export const television = (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 400 400"
    width="35px"
    height="35px"
  >
    <path d="M168.35,54.73A5.9,5.9,0,0,0,164.19,53H38.87A14.59,14.59,0,0,0,24.29,67.59V195.93a5.89,5.89,0,1,0,11.77,0V67.59a2.81,2.81,0,0,1,2.81-2.81H164a6,6,0,0,0,6.09-5.47A5.88,5.88,0,0,0,168.35,54.73Z" />
    <path d="M376,121.57H343.71V61.41A33.73,33.73,0,0,0,310,27.71H33.7A33.75,33.75,0,0,0,0,61.41V224.7a33.76,33.76,0,0,0,33.7,33.71h120V272H130.2a13.84,13.84,0,0,0-13.83,13.82v6.39A13.85,13.85,0,0,0,130.2,306h83.32a13.84,13.84,0,0,0,13.82-13.83v-6.39A13.84,13.84,0,0,0,213.52,272H190V258.41H279.5v89.84a24.06,24.06,0,0,0,24,24H376a24.06,24.06,0,0,0,24.05-24V145.61A24.07,24.07,0,0,0,376,121.57ZM213.52,283.77a2.08,2.08,0,0,1,2,2.05v6.39a2.08,2.08,0,0,1-2,2.05H130.2a2.07,2.07,0,0,1-2-2.05v-6.39a2.07,2.07,0,0,1,2-2.05Zm-48-11.77V258.41H178.2V272Zm114-126.39v77.23H38.87A2.81,2.81,0,0,1,36.06,220v-45.1a5.89,5.89,0,1,0-11.77,0V220a14.6,14.6,0,0,0,14.58,14.59H279.5v12H33.71A21.93,21.93,0,0,1,11.77,224.7V61.41A21.93,21.93,0,0,1,33.71,39.48H310a21.93,21.93,0,0,1,21.93,21.93v60.16H319.43v-54A14.62,14.62,0,0,0,304.85,53H153.41a5.89,5.89,0,1,0-.22,11.77H304.85a2.81,2.81,0,0,1,2.81,2.81v54h-4.12A24,24,0,0,0,279.5,145.61ZM376,360.52H303.54a12.28,12.28,0,0,1-12.27-12.27V328.12h97v20.13h0A12.29,12.29,0,0,1,376,360.52Zm12.28-182.85H332a5.89,5.89,0,1,0,0,11.77h56.2V316.35h-97V189.44H305.6a5.89,5.89,0,1,0,0-11.77H291.27V145.61a12.27,12.27,0,0,1,12.27-12.27H376a12.28,12.28,0,0,1,12.28,12.28Z" />
    <path d="M371.41,149.42H351.92a5.89,5.89,0,0,0,0,11.77h19.49a5.89,5.89,0,1,0,0-11.77Z" />
    <path d="M314.9,202h-6.82a5.89,5.89,0,0,0,0,11.78h6.82a5.89,5.89,0,1,0,0-11.78Z" />
    <path d="M343.16,202h-6.82a5.89,5.89,0,1,0,0,11.78h6.82a5.89,5.89,0,0,0,0-11.78Z" />
    <path d="M371.41,202h-6.82a5.89,5.89,0,0,0,0,11.78h6.82a5.89,5.89,0,0,0,0-11.78Z" />
    <path d="M314.9,231.26h-6.82a5.89,5.89,0,0,0,0,11.78h6.82a5.89,5.89,0,1,0,0-11.78Z" />
    <path d="M343.16,231.26h-6.82a5.89,5.89,0,1,0,0,11.78h6.82a5.89,5.89,0,0,0,0-11.78Z" />
    <path d="M371.41,231.26h-6.82a5.89,5.89,0,0,0,0,11.78h6.82a5.89,5.89,0,0,0,0-11.78Z" />
    <path d="M314.9,260.49h-6.82a5.89,5.89,0,0,0,0,11.77h6.82a5.89,5.89,0,1,0,0-11.77Z" />
    <path d="M343.16,260.49h-6.82a5.89,5.89,0,1,0,0,11.77h6.82a5.89,5.89,0,0,0,0-11.77Z" />
    <path d="M371.41,260.49h-6.82a5.89,5.89,0,0,0,0,11.77h6.82a5.89,5.89,0,1,0,0-11.77Z" />
    <path d="M314.9,289.72h-6.82a5.89,5.89,0,0,0,0,11.77h6.82a5.89,5.89,0,1,0,0-11.77Z" />
    <path d="M343.16,289.72h-6.82a5.89,5.89,0,1,0,0,11.77h6.82a5.89,5.89,0,0,0,0-11.77Z" />
    <path d="M371.41,289.72h-6.82a5.89,5.89,0,0,0,0,11.77h6.82a5.89,5.89,0,1,0,0-11.77Z" />
  </svg>
);

export const calendar = (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 400 400"
    width="35px"
    height="35px"
  >
    <path d="M40.49,400A40.54,40.54,0,0,1,0,359.51V73.05a40.55,40.55,0,0,1,40.49-40.5H68.36V0H84.24V32.55H315.76V0h15.88V32.55h27.87A40.55,40.55,0,0,1,400,73.05V359.51A40.54,40.54,0,0,1,359.51,400Zm-24.6-40.49a24.63,24.63,0,0,0,24.6,24.6h319a24.63,24.63,0,0,0,24.6-24.6V136.33H15.89ZM40.49,48.44a24.64,24.64,0,0,0-24.6,24.61v47.39H384.11V73.05a24.64,24.64,0,0,0-24.6-24.61H331.64V81H315.76V48.44H84.24V81H68.36V48.44Z" />
    <rect x="61.85" y="187.17" width="15.89" height="15.89" />
    <rect x="126.95" y="187.17" width="15.89" height="15.89" />
    <rect x="192.06" y="187.17" width="15.89" height="15.89" />
    <rect x="257.16" y="187.17" width="15.89" height="15.89" />
    <rect x="322.27" y="187.17" width="15.89" height="15.89" />
    <rect x="61.85" y="252.28" width="15.89" height="15.89" />
    <rect x="126.95" y="252.28" width="15.89" height="15.89" />
    <rect x="192.06" y="252.28" width="15.89" height="15.89" />
    <rect x="257.16" y="252.28" width="15.89" height="15.89" />
    <rect x="61.85" y="317.38" width="15.89" height="15.89" />
    <rect x="126.95" y="317.38" width="15.89" height="15.89" />
    <rect x="192.06" y="317.38" width="15.89" height="15.89" />
    <rect x="257.16" y="317.38" width="15.89" height="15.89" />
    <rect x="322.27" y="252.28" width="15.89" height="15.89" />
  </svg>
);

export const cellphone = (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 400 400"
    width="35px"
    height="35px"
  >
    <g id="surface1">
      <path d="M299.66,155.09l-9,9.82,40.88,37.48a46.81,46.81,0,0,1,15.12,34.41V400H360V236.8a60.16,60.16,0,0,0-19.45-44.23Z" />
      <path d="M246.67,0H73.33A33.37,33.37,0,0,0,40,33.33V366.67A33.37,33.37,0,0,0,73.33,400H240V388.07a151.56,151.56,0,0,1,25.55-84.37,6.66,6.66,0,0,0-.84-8.41l-46.66-46.67a21.62,21.62,0,0,1,1.58-32,22.46,22.46,0,0,1,29.85,2.3l65.81,65.81,9.42-9.43L280,230.57V33.33A33.37,33.37,0,0,0,246.67,0Zm20,217.24-7.76-7.76a35.88,35.88,0,0,0-47.76-3.16,35,35,0,0,0-2.53,51.73l42.87,42.87a164.85,164.85,0,0,0-24.78,85.75H73.33a20,20,0,0,1-20-20v-20H220V333.33H53.33v-280H266.67Zm0-177.24H53.33V33.33a20,20,0,0,1,20-20H246.67a20,20,0,0,1,20,20Z" />
      <path d="M80,120h26.67A13.33,13.33,0,0,0,120,106.67V80a13.33,13.33,0,0,0-13.33-13.33H80A13.33,13.33,0,0,0,66.67,80v26.67A13.33,13.33,0,0,0,80,120Zm0-40h26.67v26.67H80Z" />
      <path d="M146.67,120h26.66a13.33,13.33,0,0,0,13.34-13.33V80a13.33,13.33,0,0,0-13.34-13.33H146.67A13.33,13.33,0,0,0,133.33,80v26.67A13.33,13.33,0,0,0,146.67,120Zm0-40h26.66v26.67H146.67Z" />
      <path d="M213.33,120H240a13.33,13.33,0,0,0,13.33-13.33V80A13.33,13.33,0,0,0,240,66.67H213.33A13.33,13.33,0,0,0,200,80v26.67A13.33,13.33,0,0,0,213.33,120Zm0-40H240v26.67H213.33Z" />
      <path d="M80,186.67h26.67A13.33,13.33,0,0,0,120,173.33V146.67a13.33,13.33,0,0,0-13.33-13.34H80a13.33,13.33,0,0,0-13.33,13.34v26.66A13.33,13.33,0,0,0,80,186.67Zm0-40h26.67v26.66H80Z" />
      <path d="M80,253.33h26.67A13.33,13.33,0,0,0,120,240V213.33A13.33,13.33,0,0,0,106.67,200H80a13.33,13.33,0,0,0-13.33,13.33V240A13.33,13.33,0,0,0,80,253.33Zm0-40h26.67V240H80Z" />
      <path d="M146.67,186.67h26.66a13.34,13.34,0,0,0,13.34-13.34V146.67a13.34,13.34,0,0,0-13.34-13.34H146.67a13.34,13.34,0,0,0-13.34,13.34v26.66A13.34,13.34,0,0,0,146.67,186.67Zm0-40h26.66v26.66H146.67Z" />
      <path d="M213.33,186.67H240a13.33,13.33,0,0,0,13.33-13.34V146.67A13.33,13.33,0,0,0,240,133.33H213.33A13.33,13.33,0,0,0,200,146.67v26.66A13.33,13.33,0,0,0,213.33,186.67Zm0-40H240v26.66H213.33Z" />
      <path d="M146.67,253.33h26.66A13.33,13.33,0,0,0,186.67,240V213.33A13.33,13.33,0,0,0,173.33,200H146.67a13.33,13.33,0,0,0-13.34,13.33V240A13.33,13.33,0,0,0,146.67,253.33Zm0-40h26.66V240H146.67Z" />
      <path d="M80,320h26.67A13.33,13.33,0,0,0,120,306.67V280a13.33,13.33,0,0,0-13.33-13.33H80A13.33,13.33,0,0,0,66.67,280v26.67A13.33,13.33,0,0,0,80,320Zm0-40h26.67v26.67H80Z" />
      <path d="M146.67,320h26.66a13.33,13.33,0,0,0,13.34-13.33V280a13.33,13.33,0,0,0-13.34-13.33H146.67A13.33,13.33,0,0,0,133.33,280v26.67A13.33,13.33,0,0,0,146.67,320Zm0-40h26.66v26.67H146.67Z" />
      <path d="M153.33,360h13.34v13.33H153.33Z" />
    </g>
  </svg>
);

export const key = (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 400 400"
    width="35px"
    height="35px"
  >
    <path d="M127.41,400a127.4,127.4,0,1,1,39.24-248.59l2.37.77L318.9,2.31A7.81,7.81,0,0,1,324.47,0h67.65A7.9,7.9,0,0,1,400,7.86V109.14a7.89,7.89,0,0,1-7.88,7.88H364.76l-7.2,36.16a7.85,7.85,0,0,1-6.18,6.19l-37.13,7.43-7.43,37.13a7.85,7.85,0,0,1-6.18,6.18l-39.94,8L247.82,231l.77,2.38A127.27,127.27,0,0,1,127.41,400Zm-.09-239a111.71,111.71,0,1,0,104,70.9,7.88,7.88,0,0,1,1.77-8.44l18.14-18.15a7.87,7.87,0,0,1,4-2.15l37.13-7.43,7.43-37.13a7.84,7.84,0,0,1,6.18-6.18L343.14,145l7.43-37.35a7.9,7.9,0,0,1,7.72-6.34h25.95V26.9L228.56,182.58a7.88,7.88,0,0,1-11.15-11.14L373.1,15.76H327.73L176.58,166.9a7.88,7.88,0,0,1-8.44,1.77A111.52,111.52,0,0,0,127.32,161Z" />
    <path d="M93.59,338.19a31.78,31.78,0,1,1,22.48-9.29,31.61,31.61,0,0,1-22.48,9.29Zm0-47.81a16,16,0,1,0,11.34,4.69A15.94,15.94,0,0,0,93.59,290.38Z" />
  </svg>
);

export const plunge_pool_2 = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 400 400"
    width="35px"
    height="35px"
  >
    <g>
      <path
        d="M355.7,279.4c-7.8,0-15.5-2.1-22.2-6.2L318,264c-4.3-2.6-9.1-3.9-14.1-3.9c-4.9,0-9.7,1.3-13.9,3.8l-16.6,9.7
          c-6.6,3.9-14.2,5.9-21.8,5.9c-7.8,0-15.5-2.1-22.2-6.2l-15.5-9.3c-4.3-2.6-9.1-3.9-14.1-3.9c-4.9,0-9.7,1.3-13.9,3.8l-16.6,9.7
          c-6.6,3.9-14.2,5.9-21.8,5.9c-7.8,0-15.5-2.1-22.2-6.2l-15.5-9.3c-4.3-2.6-9.1-3.9-14.1-3.9c-4.9,0-9.7,1.3-13.9,3.8l-16.6,9.7
          c-6.6,3.9-14.2,5.9-21.8,5.9c0,0,0,0,0,0c-7.8,0-15.5-2.1-22.2-6.2l-11.9-7.1l8.1-13.5l11.9,7.1c4.3,2.6,9.1,3.9,14.1,3.9
          c4.9,0,9.6-1.3,13.8-3.8l16.6-9.7c6.6-3.9,14.2-5.9,21.8-5.9c7.8,0,15.5,2.1,22.2,6.2l15.5,9.3c1.2,0.7,2.6,1.4,4,2l5.6,2.2V60.2
          c0-33.2,27-60.2,60.2-60.2h16.2v15.8h-16.2c-24.5,0-44.5,20-44.5,44.5v23.6h108.5V60.2c0-33.2,27-60.2,60.2-60.2h16.2v15.8h-16.2
          c-24.5,0-44.5,20-44.5,44.5v188.9l5.5-2.1c4.9-1.8,10-2.8,15.2-2.8c7.8,0,15.5,2.1,22.2,6.2l15.5,9.3c4.3,2.6,9.1,3.9,14.1,3.9
          c4.9,0,9.6-1.3,13.8-3.8l13.1-7.7l8,13.6l-13,7.7C370.9,277.4,363.3,279.4,355.7,279.4z M199.8,244.3c7.8,0,15.5,2.1,22.2,6.2
          l15.5,9.3c4.3,2.6,9.1,3.9,14.1,3.9c4.8,0,9.5-1.3,13.7-3.7l2-1.2v-73.6H158.9v76.2l19.1-11.2C184.6,246.3,192.2,244.3,199.8,244.3
          z M158.9,169.4h108.5V99.6H158.9V169.4z"
      />
      <path
        d="M251.6,339.7c-7.8,0-15.5-2.1-22.2-6.2l-15.5-9.3c-4.3-2.6-9.1-3.9-14.1-3.9c-4.9,0-9.7,1.3-13.9,3.8l-16.6,9.7
          c-6.6,3.9-14.2,5.9-21.8,5.9c-7.8,0-15.5-2.1-22.2-6.2l-15.5-9.3c-4.3-2.6-9.1-3.9-14.1-3.9c-4.9,0-9.7,1.3-13.9,3.8l-16.6,9.7
          c-6.6,3.9-14.2,5.9-21.8,5.9c0,0,0,0,0,0c-7.8,0-15.5-2.1-22.2-6.2l-11.9-7.1l8.1-13.5l11.9,7.1c4.3,2.6,9.1,3.9,14.1,3.9
          c4.9,0,9.6-1.3,13.8-3.8l16.6-9.7c6.6-3.9,14.2-5.9,21.8-5.9c7.8,0,15.5,2.1,22.2,6.2l15.5,9.3c4.3,2.6,9.1,3.9,14.1,3.9
          c4.9,0,9.6-1.3,13.8-3.8l16.6-9.7c6.6-3.9,14.2-5.9,21.8-5.9c7.8,0,15.5,2.1,22.2,6.2l15.5,9.3c4.3,2.6,9.1,3.9,14.1,3.9
          c4.9,0,9.6-1.3,13.8-3.8l16.6-9.7c6.6-3.9,14.2-5.9,21.8-5.9c7.8,0,15.5,2.1,22.2,6.2l15.5,9.3c4.3,2.6,9.1,3.9,14.1,3.9
          c4.9,0,9.6-1.3,13.8-3.8l13-7.7l8,13.6l-13,7.7c-6.6,3.9-14.2,5.9-21.8,5.9c-7.8,0-15.5-2.1-22.2-6.2l-15.5-9.3
          c-4.3-2.6-9.1-3.9-14.1-3.9c-4.9,0-9.7,1.3-13.9,3.8l-16.6,9.7C266.8,337.7,259.3,339.7,251.6,339.7z"
      />
      <path
        d="M355.7,400c-7.8,0-15.5-2.1-22.2-6.2l-15.5-9.3c-4.3-2.6-9.1-3.9-14.1-3.9c-4.9,0-9.7,1.3-13.9,3.8l-16.6,9.7
          c-6.6,3.9-14.2,5.9-21.8,5.9c-7.8,0-15.5-2.1-22.2-6.2l-15.5-9.3c-4.3-2.6-9.1-3.9-14.1-3.9c-4.9,0-9.7,1.3-13.9,3.8l-16.6,9.7
          c-6.6,3.9-14.2,5.9-21.8,5.9c-7.8,0-15.5-2.1-22.2-6.2l-15.5-9.3c-4.3-2.6-9.1-3.9-14.1-3.9c-4.9,0-9.7,1.3-13.9,3.8l-16.6,9.7
          c-6.6,3.9-14.2,5.9-21.8,5.9c-7.8,0-15.5-2.1-22.2-6.2l-11.9-7.1l8.1-13.5l11.9,7.1c4.3,2.6,9.1,3.9,14.1,3.9
          c4.9,0,9.6-1.3,13.8-3.8l16.6-9.7c6.6-3.9,14.2-5.9,21.8-5.9c7.8,0,15.5,2.1,22.2,6.2l15.5,9.3c4.3,2.6,9.1,3.9,14.1,3.9
          c4.9,0,9.6-1.3,13.8-3.8l16.6-9.7c6.6-3.9,14.2-5.9,21.8-5.9c7.8,0,15.5,2.1,22.2,6.2l15.5,9.3c4.3,2.6,9.1,3.9,14.1,3.9
          c4.9,0,9.6-1.3,13.8-3.8l16.6-9.7c6.6-3.9,14.2-5.9,21.8-5.9c7.8,0,15.5,2.1,22.2,6.2l15.5,9.3c4.3,2.6,9.1,3.9,14.1,3.9
          c4.9,0,9.6-1.3,13.8-3.8l13-7.7l8,13.6l-13.1,7.7C370.9,398,363.3,400,355.7,400z"
      />
    </g>
  </svg>
);

export const hiking = (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 400 400"
    width="35px"
    height="35px"
  >
    <g id="_006---Hiking" data-name="006---Hiking">
      <path
        id="Shape"
        d="M254.5,80a40,40,0,1,0-40-40A40,40,0,0,0,254.5,80Zm0-66.66A26.67,26.67,0,1,1,227.83,40,26.67,26.67,0,0,1,254.5,13.35Z"
      />
      <path
        id="Shape-2"
        data-name="Shape"
        d="M14.52,400h373.3a13.33,13.33,0,0,0,11.92-19.33l-6.66-13.33A13.27,13.27,0,0,0,381.15,360h-60V185.44a19.89,19.89,0,0,0,0-37.54V113.34a6.67,6.67,0,0,0-13.33,0v33.33H288.29a6.67,6.67,0,0,1-5.54-3L251.23,96.43A37.33,37.33,0,0,0,204.78,83.1a19.93,19.93,0,0,0-13.09-15.85l-37.8-13.13a20.08,20.08,0,0,0-25.48,12.39l-6.57,18.87A6.66,6.66,0,0,0,117.48,98l-8.73,25.21a6.67,6.67,0,0,0-4.36,12.58c-6.45,18.63-8.58,22.2-7.33,29.05a20,20,0,0,0-1.19,38.57c45.15,15.71,47.55,17.77,55.86,15.17l-6,42.25c-.67,4.59,2.13,1.08-48.63,69.5A26.66,26.66,0,0,0,95.31,360H21.19a13.27,13.27,0,0,0-11.93,7.34L2.6,380.65A13.33,13.33,0,0,0,14.52,400Zm256-40a28.59,28.59,0,0,0,4-14.45v-66.2a39.92,39.92,0,0,0-10.08-26.56l-39.85-44.84a6.54,6.54,0,0,1-1.28-6.49l12.2-36.58,5.61,7.86a33.41,33.41,0,0,0,27.12,13.95h39.61V360Zm-60-264.91a24.1,24.1,0,0,1,29.58,8.77l31.5,47.26a20,20,0,0,0,16.66,8.9h26.2a6.67,6.67,0,1,1,0,13.34H268.22A20.06,20.06,0,0,1,251.94,165l-25.33-35.49a6.66,6.66,0,1,0-10.84,7.74l10.16,14.23-15.25,45.75a19.84,19.84,0,0,0,4,19.63l39.81,44.81a26.53,26.53,0,0,1,6.67,17.7v66.2A14.18,14.18,0,0,1,248.82,360a13.32,13.32,0,0,1-14.32-13.33v-42a40.32,40.32,0,0,0-8.63-24.77l-51.14-57.27a33.13,33.13,0,0,1-5.56-29.75c25.05-79.07,25.33-74.63,25.44-75.3,3-9,5-17.74,16-22.5ZM171.3,144.83l-50-17.33,8.73-25.18,49.76,17.28ZM141,70.84a6.73,6.73,0,0,1,8.5-4.14L187.3,79.83a6.66,6.66,0,0,1,4.08,8.45L188,98a39.13,39.13,0,0,0-3.66,8.23c-.35,1.1,5.23,2.66-49.92-16.48Zm2.61,134.91-43.33-15a7.25,7.25,0,0,1-5.09-8.1,6.8,6.8,0,0,1,8.7-4.77c6.81,2.37,7.21,2.71,9.25,2.48,20.53,8.44,19.93,8.4,21.75,8.4a6.66,6.66,0,0,0,2.54-12.83c-30.16-12.4-23.7-9.83-25.48-10.3a6.39,6.39,0,0,1-1.5-6.67L117,140.11l50,17.33c-2.49,7.36-12.39,36.87-14.92,44.22a6.66,6.66,0,0,1-8.47,4.11ZM107.85,338.24l46.21-63.58c5.27-7.09,4.73-10.67,9.59-44.75,1.56,2.17-3.54-3.66,25.6,29l-3.41,19.55c-.76,4.54,2,.21-56.29,75.39A13.49,13.49,0,0,1,105,348.29a13.72,13.72,0,0,1,2.82-10.05Zm86-45.86a40.51,40.51,0,0,0,6.72-20.83l15.05,16.85a26.36,26.36,0,0,1,5.56,16.26v42A26.35,26.35,0,0,0,224.86,360H141.67ZM14.52,386.65l6.67-13.33h360l6.67,13.33Z"
      />
    </g>
  </svg>
);

export const family_pool = (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 400 400"
    width="35px"
    height="35px"
  >
    <path d="M151.67,312.66a117.41,117.41,0,0,1,46.87,10.15,124.44,124.44,0,0,0,49.72,10.81,123.05,123.05,0,0,0,49-10.6A116.84,116.84,0,0,1,341,313c1.44,0,2.87-.06,4.3-.06,16.45,0,30.93,2.86,44.27,8.75a9,9,0,0,0,3.64.83,5.38,5.38,0,0,0,5.23-3.38c1.42-3.45-.73-8.61-4.51-10.84a14.89,14.89,0,0,0-1.61-.78,126.81,126.81,0,0,0-48.45-10.09,119.4,119.4,0,0,0-46.12,9.51c-11.15,4.65-24.48,9.55-38.78,10.66-4.55.35-8.73.52-12.78.52-15.9,0-29.48-2.77-41.51-8.46a121,121,0,0,0-52.15-12,127,127,0,0,0-26,2.76c-6.88,1.45-13.74,4.15-20.38,6.76-3.65,1.44-7.43,2.93-11.21,4.21A124.42,124.42,0,0,1,55,318.22a114.74,114.74,0,0,1-43.55-8.73,21.63,21.63,0,0,0-2.68-.84l-.74-.2h-.1c-3.52,0-5.42,1.4-6.35,4.68-1,3.67-.12,6.52,2.82,8.71a13.86,13.86,0,0,0,3.08,1.56l.16.06a124.85,124.85,0,0,0,48.12,10.09,121.39,121.39,0,0,0,48.75-10.6A117.63,117.63,0,0,1,151.67,312.66Z" />
    <path d="M151.67,366.27a117.43,117.43,0,0,1,46.87,10.16c16.52,7.17,33.25,10.81,49.72,10.81a123.05,123.05,0,0,0,49-10.6,116.84,116.84,0,0,1,43.65-10c1.44,0,2.87-.07,4.3-.07,16.45,0,30.93,2.87,44.27,8.76a9,9,0,0,0,3.64.83,5.38,5.38,0,0,0,5.23-3.38c1.42-3.45-.73-8.62-4.51-10.84a11.91,11.91,0,0,0-1.61-.78A126.64,126.64,0,0,0,343.82,351a119.23,119.23,0,0,0-46.12,9.52c-11.15,4.64-24.48,9.55-38.78,10.65-4.55.35-8.73.52-12.78.52-15.9,0-29.48-2.76-41.51-8.46a121.19,121.19,0,0,0-52.15-12,126.34,126.34,0,0,0-26,2.77c-6.88,1.44-13.74,4.15-20.38,6.76-3.65,1.44-7.43,2.92-11.21,4.2A124.17,124.17,0,0,1,55,371.84a114.93,114.93,0,0,1-43.55-8.73,23.57,23.57,0,0,0-2.68-.85l-.74-.2h-.1c-3.52,0-5.42,1.4-6.35,4.68-1,3.66-.12,6.51,2.82,8.71A14.3,14.3,0,0,0,7.48,377l.16.06a125,125,0,0,0,48.12,10.08,121.37,121.37,0,0,0,48.75-10.59A117.47,117.47,0,0,1,151.67,366.27Z" />
    <path d="M368.2,184a58,58,0,0,1-17.05-40.93V122.44a24.52,24.52,0,0,0-2.65-11.1,43.42,43.42,0,0,0-21.67-36.77L284.49,50.12a43.32,43.32,0,0,0-45.4,1.24A40.75,40.75,0,0,0,227.38,27.2L225,24.79A41.07,41.07,0,0,0,166.9,82.87l2.4,2.41a40.85,40.85,0,0,0,29,12,42.6,42.6,0,0,0,5.07-.32,83.1,83.1,0,0,1-25.83,15.12,21.07,21.07,0,0,0-10.42,8.24L138.8,92l-5.9-5.89a53.27,53.27,0,0,0-79.79,70.29,45.19,45.19,0,0,0,31.49,73.3,54.67,54.67,0,0,0-10.25,31.93v53.75a6.49,6.49,0,1,0,13,0V261.61a42.07,42.07,0,0,1,42-42,68,68,0,0,1,24,4.36,169,169,0,0,1-19.58,9.72L128.06,236a27.25,27.25,0,1,0,21,50.31l5.65-2.36a223.65,223.65,0,0,0,38.24-20.54,67.35,67.35,0,0,1,4.4,24.12v27.8a6.49,6.49,0,1,0,13,0v-27.8a80.09,80.09,0,0,0-6.51-31.85,224.45,224.45,0,0,0,26.36-23.36,6.49,6.49,0,0,0-9.35-9A213.18,213.18,0,0,1,149.68,272L144,274.37a14.27,14.27,0,1,1-11-26.35l5.66-2.36A183.87,183.87,0,0,0,245,124l2.26-8.49a14.27,14.27,0,1,1,27.58,7.35l-2.26,8.49c2.44,19.11-35.2,81.47-52,92.13a6.49,6.49,0,1,0,11.4,6.19c10-6,48.29-64.42,49.09-81.43l2.42,1.4a43.08,43.08,0,0,0,19.71,5.77,89.82,89.82,0,0,0,40.08,59.7A20,20,0,0,0,368.2,184ZM178.48,76.1l-2.4-2.4A28.09,28.09,0,1,1,215.8,34l2.41,2.4A28.09,28.09,0,1,1,178.48,76.1ZM182,124.32a96.33,96.33,0,0,0,53.84-48.73,8.32,8.32,0,0,1,11.09-3.93,8.32,8.32,0,0,1,3.93,11.09A112,112,0,0,1,187.7,140a8.32,8.32,0,0,1-11-6.18,8.33,8.33,0,0,1,5.28-9.45ZM163.7,137.15a7.43,7.43,0,0,1-7.36,6.54,6.49,6.49,0,0,0,0,13,20.28,20.28,0,0,0,10.8-3.1,30.47,30.47,0,0,1-52,19.42,34.19,34.19,0,0,1,0-48.3l19-19,24.14,24.15a30.4,30.4,0,0,1,5.4,7.3ZM56.15,184.65A32,32,0,0,1,66.27,161.2a6.47,6.47,0,0,0,.28-9.14l-.29-.3a40.29,40.29,0,0,1,57.47-56.49L125,96.53l-19,19a47.18,47.18,0,0,0,0,66.64,43.38,43.38,0,0,0,13.88,9.32,32.23,32.23,0,0,1-63.73-6.82Zm71.7,22a44.56,44.56,0,0,0,4.61-12c1.42.14,2.85.21,4.28.21a43.62,43.62,0,0,0,14.5-2.47v17.25a81.15,81.15,0,0,0-21.89-3Q128.6,206.62,127.85,206.65Zm38.5,8.91c-.71-.36-1.42-.71-2.14-1.05v-29.4a43.48,43.48,0,0,0,15.95-32.23,20.67,20.67,0,0,0,4.7.54,21.29,21.29,0,0,0,7.25-1.27A125.28,125.28,0,0,0,226.77,133c.89-.7,1.76-1.4,2.62-2.12a171.15,171.15,0,0,1-63,84.68ZM290,138.42l-5.05-2.92c.08-.26.15-.53.22-.8l2.26-8.49a27.26,27.26,0,0,0-19.31-33.35,27.77,27.77,0,0,0-7.32-.92c.62-1.19,1.22-2.4,1.8-3.61A21.29,21.29,0,0,0,252.5,59.94l-1.05-.47A30.35,30.35,0,0,1,278,61.36l42.35,24.45a30.35,30.35,0,0,1,11.9,12.61,24.68,24.68,0,0,0-30.52,24v16.7c0,1.06,0,2.11,0,3.16A30.1,30.1,0,0,1,290,138.42Zm71.18,60.21a7,7,0,0,1-2.67,5.15,7.08,7.08,0,0,1-8.21.41,76.93,76.93,0,0,1-35.57-65V122.44a11.74,11.74,0,1,1,23.47,0v20.64a71.07,71.07,0,0,0,20.9,50.14,7,7,0,0,1,2.08,5.41Z" />
  </svg>
);

export const full_ocean_view = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 400 400"
    width="35px"
    height="35px"
  >
    <path
      d="M252.7,126.2c-8.2,0-14.8-6.7-14.8-14.8c0-4,1.6-7.7,4.4-10.5c2.7-2.8,6.4-4.3,10.4-4.3h2.2l0.4-1.4
	c2.3-9,10.5-15.3,19.8-15.3c9.3,0,17.5,6.3,19.8,15.3l0.4,1.4h2.2c8.2,0,14.8,6.7,14.8,14.8c0,4-1.6,7.7-4.4,10.5
	c-2.7,2.8-6.4,4.3-10.4,4.3H252.7z M252.7,103.9c-2,0-3.9,0.8-5.3,2.2c-1.5,1.4-2.3,3.3-2.3,5.3c0,4.1,3.4,7.5,7.5,7.5h44.7
	c2,0,3.9-0.8,5.3-2.2c1.5-1.4,2.3-3.3,2.3-5.3c0-4.1-3.4-7.5-7.5-7.5h-5.6c-2,0-3.7-1.6-3.7-3.7c0-7.2-5.9-13.1-13.1-13.1
	c-7.2,0-13.1,5.9-13.1,13.1c0,2-1.6,3.7-3.7,3.7H252.7z"
    />
    <g>
      <path
        d="M321.6,206.8c-8.8,0-13.5-2.4-17.5-4.5c-3.6-1.9-6.8-3.5-13.4-3.5c-6.6,0-9.8,1.6-13.4,3.5c-4.1,2.1-8.7,4.5-17.5,4.5
		s-13.5-2.4-17.5-4.5c-3.6-1.9-6.8-3.5-13.4-3.5s-9.8,1.6-13.4,3.5c-4.1,2.1-8.7,4.5-17.5,4.5c-8.8,0-13.5-2.4-17.5-4.5
		c-3.6-1.9-6.8-3.5-13.4-3.5c-6.6,0-9.8,1.6-13.4,3.5c-4.1,2.1-8.7,4.5-17.5,4.5c-8.8,0-13.5-2.4-17.5-4.5
		c-3.6-1.9-6.8-3.5-13.4-3.5c-6.6,0-9.8,1.6-13.4,3.5c-4.1,2.1-8.7,4.5-17.5,4.5s-13.5-2.4-17.5-4.5c-3.6-1.9-6.8-3.5-13.4-3.5
		c-2.5,0-4.5-2-4.5-4.5s2-4.5,4.5-4.5c8.8,0,13.5,2.4,17.5,4.5c3.6,1.9,6.8,3.5,13.4,3.5c6.6,0,9.8-1.6,13.4-3.5
		c4.1-2.1,8.7-4.5,17.5-4.5c8.8,0,13.5,2.4,17.5,4.5c3.6,1.9,6.8,3.5,13.4,3.5s9.8-1.6,13.4-3.5c4.1-2.1,8.7-4.5,17.5-4.5
		c8.8,0,13.5,2.4,17.5,4.5c3.6,1.9,6.8,3.5,13.4,3.5s9.8-1.6,13.4-3.5c4.1-2.1,8.7-4.5,17.5-4.5s13.5,2.4,17.5,4.5
		c3.6,1.9,6.8,3.5,13.4,3.5s9.8-1.6,13.4-3.5c4.1-2.1,8.7-4.5,17.5-4.5c8.8,0,13.5,2.4,17.5,4.5c3.6,1.9,6.8,3.5,13.4,3.5
		s9.8-1.6,13.4-3.5c4.1-2.1,8.7-4.5,17.5-4.5c2.5,0,4.5,2,4.5,4.5s-2,4.5-4.5,4.5c-6.6,0-9.8,1.6-13.4,3.5
		C335.1,204.4,330.5,206.8,321.6,206.8z"
      />
    </g>
    <g>
      <path
        d="M321.6,247.3c-8.8,0-13.5-2.4-17.5-4.5c-3.6-1.9-6.8-3.5-13.4-3.5c-6.6,0-9.8,1.6-13.4,3.5c-4.1,2.1-8.7,4.5-17.5,4.5
		s-13.5-2.4-17.5-4.5c-3.6-1.9-6.8-3.5-13.4-3.5s-9.8,1.6-13.4,3.5c-4.1,2.1-8.7,4.5-17.5,4.5c-8.8,0-13.5-2.4-17.5-4.5
		c-3.6-1.9-6.8-3.5-13.4-3.5c-6.6,0-9.8,1.6-13.4,3.5c-4.1,2.1-8.7,4.5-17.5,4.5c-8.8,0-13.5-2.4-17.5-4.5
		c-3.6-1.9-6.8-3.5-13.4-3.5c-6.6,0-9.8,1.6-13.4,3.5c-4.1,2.1-8.7,4.5-17.5,4.5s-13.5-2.4-17.5-4.5c-3.6-1.9-6.8-3.5-13.4-3.5
		c-2.5,0-4.5-2-4.5-4.5s2-4.5,4.5-4.5c8.8,0,13.5,2.4,17.5,4.5c3.6,1.9,6.8,3.5,13.4,3.5c6.6,0,9.8-1.6,13.4-3.5
		c4.1-2.1,8.7-4.5,17.5-4.5c8.8,0,13.5,2.4,17.5,4.5c3.6,1.9,6.8,3.5,13.4,3.5s9.8-1.6,13.4-3.5c4.1-2.1,8.7-4.5,17.5-4.5
		c8.8,0,13.5,2.4,17.5,4.5c3.6,1.9,6.8,3.5,13.4,3.5s9.8-1.6,13.4-3.5c4.1-2.1,8.7-4.5,17.5-4.5s13.5,2.4,17.5,4.5
		c3.6,1.9,6.8,3.5,13.4,3.5s9.8-1.6,13.4-3.5c4.1-2.1,8.7-4.5,17.5-4.5c8.8,0,13.5,2.4,17.5,4.5c3.6,1.9,6.8,3.5,13.4,3.5
		s9.8-1.6,13.4-3.5c4.1-2.1,8.7-4.5,17.5-4.5c2.5,0,4.5,2,4.5,4.5s-2,4.5-4.5,4.5c-6.6,0-9.8,1.6-13.4,3.5
		C335.1,244.9,330.5,247.3,321.6,247.3z"
      />
    </g>
    <g>
      <path
        d="M321.6,287.8c-8.8,0-13.5-2.4-17.5-4.5c-3.6-1.9-6.8-3.5-13.4-3.5c-6.6,0-9.8,1.6-13.4,3.5c-4.1,2.1-8.7,4.5-17.5,4.5
		s-13.5-2.4-17.5-4.5c-3.6-1.9-6.8-3.5-13.4-3.5s-9.8,1.6-13.4,3.5c-4.1,2.1-8.7,4.5-17.5,4.5c-8.8,0-13.5-2.4-17.5-4.5
		c-3.6-1.9-6.8-3.5-13.4-3.5c-6.6,0-9.8,1.6-13.4,3.5c-4.1,2.1-8.7,4.5-17.5,4.5c-8.8,0-13.5-2.4-17.5-4.5
		c-3.6-1.9-6.8-3.5-13.4-3.5c-6.6,0-9.8,1.6-13.4,3.5c-4.1,2.1-8.7,4.5-17.5,4.5s-13.5-2.4-17.5-4.5c-3.6-1.9-6.8-3.5-13.4-3.5
		c-2.5,0-4.5-2-4.5-4.5s2-4.5,4.5-4.5c8.8,0,13.5,2.4,17.5,4.5c3.6,1.9,6.8,3.5,13.4,3.5c6.6,0,9.8-1.6,13.4-3.5
		c4.1-2.1,8.7-4.5,17.5-4.5c8.8,0,13.5,2.4,17.5,4.5c3.6,1.9,6.8,3.5,13.4,3.5s9.8-1.6,13.4-3.5c4.1-2.1,8.7-4.5,17.5-4.5
		c8.8,0,13.5,2.4,17.5,4.5c3.6,1.9,6.8,3.5,13.4,3.5s9.8-1.6,13.4-3.5c4.1-2.1,8.7-4.5,17.5-4.5s13.5,2.4,17.5,4.5
		c3.6,1.9,6.8,3.5,13.4,3.5s9.8-1.6,13.4-3.5c4.1-2.1,8.7-4.5,17.5-4.5c8.8,0,13.5,2.4,17.5,4.5c3.6,1.9,6.8,3.5,13.4,3.5
		s9.8-1.6,13.4-3.5c4.1-2.1,8.7-4.5,17.5-4.5c2.5,0,4.5,2,4.5,4.5s-2,4.5-4.5,4.5c-6.6,0-9.8,1.6-13.4,3.5
		C335.1,285.4,330.5,287.8,321.6,287.8z"
      />
    </g>
    <g>
      <path
        d="M171.1,196.6c-2.1,0-4.1-1.4-4.6-3.6c-1.5-6.1-3.7-13.6-4.7-15.1c-0.9-1.2-1.5-2.1-2.3-2.6c-2.3-1.4-6.3-0.7-10.4,0.1
		c-3.4,0.7-7,1.4-10.7,1.1c-7.7-0.5-14.8-5.1-20.5-13.3l-0.1-0.1c-1.6-2.2-2.6-3.6-4-3.9c-2.6-0.6-5.3,2.5-6.4,4.4
		c-3.9,6.2-5.8,22.6-6.2,28.4c-0.2,2.6-2.4,4.6-5,4.4c-2.6-0.2-4.6-2.4-4.4-5c0.2-2.4,1.8-23.4,7.6-32.8c3.3-5.2,9.3-10.2,16.4-8.6
		c5.1,1.1,7.8,4.9,9.7,7.7l0.1,0.1c4.1,5.8,8.5,8.9,13.3,9.2c2.5,0.2,5.3-0.4,8.3-1c5.5-1.1,11.7-2.3,17.2,1.1
		c2.3,1.4,3.8,3.3,5.1,5.2c2.3,3.3,5,13.8,6.1,18.2c0.6,2.5-0.9,5.1-3.5,5.7C171.8,196.5,171.5,196.6,171.1,196.6z"
      />
    </g>
    <g>
      <path
        d="M214.1,199.3l-9.1-2.4c1.4-5.4,4.5-16.6,7.5-21.8c1.6-2.7,3.6-5.7,6.9-7.9c3.9-2.7,8.9-3.5,13.1-2.3
    c5.8,1.7,8.5,6.7,10,9.3c0.4,0.8,0.9,1.5,1.4,2.3c1.1,1.8,2.3,3.7,3.1,5.9c2.4,6.5,1.2,11.6,1,12.2c-0.7,2.5-3.2,4-5.8,3.3
    c-2.5-0.7-4-3.2-3.3-5.8c0,0,0.6-2.8-0.7-6.5c-0.5-1.4-1.4-2.8-2.3-4.4c-0.5-0.9-1.1-1.8-1.6-2.7c-1.5-2.7-2.7-4.3-4.3-4.8
    c-1.5-0.4-3.6,0-5.1,1.1c-1.8,1.2-3,3.1-4.1,4.9C218.2,183.9,215.2,195.1,214.1,199.3z M209.6,198.1L209.6,198.1L209.6,198.1z"
      />
    </g>
    <g>
      <path
        d="M393.5,348.4h-6.5V6.5c0-3.6-2.9-6.5-6.5-6.5H19.4c-3.6,0-6.5,2.9-6.5,6.5v341.9H6.5c-3.6,0-6.5,2.9-6.5,6.5v38.7
		c0,3.6,2.9,6.5,6.5,6.5h387.1c3.6,0,6.5-2.9,6.5-6.5v-38.7C400,351.3,397.1,348.4,393.5,348.4z M25.8,12.9h348.4v335.5H25.8V12.9z
		M387.1,387.1H12.9v-25.8h374.2V387.1z"
      />
      <path
        d="M213,337.1h143.4c3.6,0,6.5-2.9,6.5-6.5V30.8c0-3.6-2.9-6.5-6.5-6.5H213H187H43.6c-3.6,0-6.5,2.9-6.5,6.5v299.8
		c0,3.6,2.9,6.5,6.5,6.5H187H213z M180,326.9H47V34.3h133H220h133v292.6H220H180z"
      />
    </g>
  </svg>
);

export const full_town_view = (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 400 400"
    width="35px"
    height="35px"
  >
    <path d="M228.86,150.87H43.17a3.5,3.5,0,0,1,0-7H212.76L105.85,95.07,43.67,123.45a3.5,3.5,0,0,1-2.91-6.37l63.63-29a3.52,3.52,0,0,1,2.91,0l123,56.15a3.5,3.5,0,0,1-1.45,6.68Z" />
    <path d="M189.34,220.05a3.5,3.5,0,0,1-3.5-3.5V150.87H42.72a3.5,3.5,0,0,1,0-7H189.34a3.5,3.5,0,0,1,3.5,3.5v69.18A3.5,3.5,0,0,1,189.34,220.05Z" />
    <path d="M126.51,198.1H85.62a3.5,3.5,0,0,1-3.5-3.5V170.18a3.5,3.5,0,0,1,3.5-3.5h40.89a3.49,3.49,0,0,1,3.5,3.5V194.6A3.5,3.5,0,0,1,126.51,198.1Zm-37.39-7H123V173.68H89.12Z" />
    <path d="M187.63,132.46H44.16a3.5,3.5,0,1,1,0-7H187.63a3.5,3.5,0,0,1,0,7Z" />
    <path d="M151.3,115.6H61.83a3.5,3.5,0,0,1,0-7H151.3a3.5,3.5,0,0,1,0,7Z" />
    <path d="M71.9,131.9a3.5,3.5,0,0,1-3.5-3.5V113.27a3.5,3.5,0,0,1,7,0V128.4A3.49,3.49,0,0,1,71.9,131.9Z" />
    <path d="M109,131.9a3.5,3.5,0,0,1-3.5-3.5V113.27a3.5,3.5,0,0,1,7,0V128.4A3.5,3.5,0,0,1,109,131.9Z" />
    <path d="M145.57,131.9a3.5,3.5,0,0,1-3.5-3.5V113.27a3.5,3.5,0,1,1,7,0V128.4A3.5,3.5,0,0,1,145.57,131.9Z" />
    <path d="M89.17,148.87a3.5,3.5,0,0,1-3.5-3.5V130.24a3.5,3.5,0,1,1,7,0v15.13A3.5,3.5,0,0,1,89.17,148.87Z" />
    <path d="M128.92,148.87a3.5,3.5,0,0,1-3.5-3.5V130.24a3.5,3.5,0,1,1,7,0v15.13A3.5,3.5,0,0,1,128.92,148.87Z" />
    <path d="M170.46,148.87a3.5,3.5,0,0,1-3.5-3.5V130.24a3.5,3.5,0,1,1,7,0v15.13A3.5,3.5,0,0,1,170.46,148.87Z" />
    <path d="M213,195.47a3.5,3.5,0,0,1-1.61-6.61l108.48-56.14a3.56,3.56,0,0,1,1.54-.4l35.7-.7a3.5,3.5,0,1,1,.14,7l-34.89.7L227.53,188.4l129.65-.64a3.54,3.54,0,0,1,3.52,3.48,3.5,3.5,0,0,1-3.48,3.52L213,195.47Z" />
    <path d="M252.54,220.05a3.5,3.5,0,0,1-3.5-3.5V192a3.49,3.49,0,0,1,3.48-3.5l104.65-.71h0a3.5,3.5,0,0,1,0,7L256,195.44v21.11A3.5,3.5,0,0,1,252.54,220.05Z" />
    <path d="M249.46,177.05a3.5,3.5,0,0,1,0-7l107.73-.71h0a3.5,3.5,0,0,1,0,7l-107.74.71Z" />
    <path d="M286.19,158.05a3.5,3.5,0,0,1,0-7l71-.71h0a3.5,3.5,0,0,1,0,7l-71,.71Z" />
    <line className="cls-1" x1="322.82" y1="137.73" x2="322.82" y2="152.08" />
    <path d="M307,174.91a3.5,3.5,0,0,1-3.5-3.5V157.06a3.5,3.5,0,0,1,7,0v14.35A3.5,3.5,0,0,1,307,174.91Z" />
    <line className="cls-1" x1="337.54" y1="157.06" x2="337.54" y2="171.41" />
    <path d="M319.44,191.37a3.5,3.5,0,0,1-3.5-3.5v-14a3.5,3.5,0,0,1,7,0v14A3.5,3.5,0,0,1,319.44,191.37Z" />
    <path d="M290.86,192.44a3.5,3.5,0,0,1-3.5-3.5V174.59a3.5,3.5,0,0,1,7,0v14.35A3.5,3.5,0,0,1,290.86,192.44Z" />
    <path d="M259.26,192.24a3.5,3.5,0,0,1-3.5-3.5v-14a3.5,3.5,0,1,1,7,0v14A3.5,3.5,0,0,1,259.26,192.24Z" />
    <path d="M359,276.69H62.35a3.5,3.5,0,0,1-1.58-6.63l111.55-56.14a3.46,3.46,0,0,1,1.57-.38h94.59a3.61,3.61,0,0,1,1.61.39l90.35,46.77a3.5,3.5,0,0,1-3.21,6.22l-89.6-46.38H174.72L77.09,269.69H359a3.5,3.5,0,0,1,0,7Z" />
    <path d="M101.15,336.34a3.5,3.5,0,0,1-3.5-3.5V273.18a3.5,3.5,0,0,1,3.5-3.5H337.44a3.5,3.5,0,0,1,0,7H104.65v56.16A3.5,3.5,0,0,1,101.15,336.34Z" />
    <path d="M101.89,258.27a3.5,3.5,0,0,1,0-7l233.65-2.08a3.5,3.5,0,1,1,.07,7l-233.66,2.08Z" />
    <path d="M303.79,239.27H138.38a3.5,3.5,0,0,1,0-7H303.79a3.5,3.5,0,0,1,0,7Z" />
    <path d="M255.25,236.8a3.5,3.5,0,0,1-3.5-3.5V219a3.5,3.5,0,0,1,7,0V233.3A3.5,3.5,0,0,1,255.25,236.8Z" />
    <path d="M180.15,236.6a3.49,3.49,0,0,1-3.5-3.5V219.15a3.5,3.5,0,0,1,7,0V233.1A3.5,3.5,0,0,1,180.15,236.6Z" />
    <path d="M218.5,236.8a3.5,3.5,0,0,1-3.5-3.5V219a3.5,3.5,0,0,1,7,0V233.3A3.5,3.5,0,0,1,218.5,236.8Z" />
    <path d="M275.78,255.93a3.5,3.5,0,0,1-3.5-3.5v-14a3.5,3.5,0,0,1,7,0v14A3.5,3.5,0,0,1,275.78,255.93Z" />
    <path d="M234.6,255.93a3.5,3.5,0,0,1-3.5-3.5v-14a3.5,3.5,0,0,1,7,0v14A3.5,3.5,0,0,1,234.6,255.93Z" />
    <path d="M193.41,255.93a3.5,3.5,0,0,1-3.5-3.5v-14a3.5,3.5,0,0,1,7,0v14A3.5,3.5,0,0,1,193.41,255.93Z" />
    <path d="M152.23,255.93a3.5,3.5,0,0,1-3.5-3.5v-14a3.5,3.5,0,0,1,7,0v14A3.5,3.5,0,0,1,152.23,255.93Z" />
    <path d="M286.94,273.46a3.5,3.5,0,0,1-3.5-3.5V256a3.5,3.5,0,0,1,7,0v14A3.5,3.5,0,0,1,286.94,273.46Z" />
    <path d="M246.39,273.46a3.5,3.5,0,0,1-3.5-3.5V256a3.5,3.5,0,0,1,7,0v14A3.5,3.5,0,0,1,246.39,273.46Z" />
    <path d="M205.85,273.46a3.5,3.5,0,0,1-3.5-3.5V256a3.5,3.5,0,0,1,7,0v14A3.5,3.5,0,0,1,205.85,273.46Z" />
    <path d="M165.3,273.46a3.5,3.5,0,0,1-3.5-3.5V256a3.5,3.5,0,0,1,7,0v14A3.5,3.5,0,0,1,165.3,273.46Z" />
    <line className="cls-1" x1="327.49" y1="256" x2="327.49" y2="269.96" />
    <path d="M124.76,273.65a3.49,3.49,0,0,1-3.5-3.5V255.8a3.5,3.5,0,1,1,7,0v14.35A3.5,3.5,0,0,1,124.76,273.65Z" />
    <path d="M159.72,319.47H142.44a3.5,3.5,0,0,1-3.5-3.5V293.56a3.5,3.5,0,0,1,3.5-3.5h17.28a3.5,3.5,0,0,1,3.5,3.5V316A3.5,3.5,0,0,1,159.72,319.47Zm-13.78-7h10.28V297.06H145.94Z" />
    <path d="M253.33,107.45A14.86,14.86,0,0,1,238.49,92.6a14.55,14.55,0,0,1,4.4-10.51,14.38,14.38,0,0,1,10.44-4.33h2.2l.37-1.45a20.44,20.44,0,0,1,39.58,0l.37,1.44h2.2A14.86,14.86,0,0,1,312.89,92.6a14.55,14.55,0,0,1-4.4,10.51,14.4,14.4,0,0,1-10.44,4.34Zm0-22.36a7.58,7.58,0,0,0-7.51,7.51,7.52,7.52,0,0,0,7.51,7.51h44.72a7.58,7.58,0,0,0,7.51-7.51,7.52,7.52,0,0,0-7.51-7.51h-5.59a3.68,3.68,0,0,1-3.67-3.67,13.1,13.1,0,0,0-26.2,0,3.68,3.68,0,0,1-3.67,3.67Z" />
    <path d="M393.55,348.39H387.1V6.45A6.45,6.45,0,0,0,380.65,0H19.35A6.45,6.45,0,0,0,12.9,6.45V348.39H6.45A6.45,6.45,0,0,0,0,354.84v38.71A6.45,6.45,0,0,0,6.45,400h387.1a6.45,6.45,0,0,0,6.45-6.45V354.84A6.45,6.45,0,0,0,393.55,348.39ZM25.81,12.9H374.19V348.39H25.81ZM387.1,387.1H12.9V361.29H387.1Z" />
    <path d="M213,337.06H356.41a6.52,6.52,0,0,0,6.52-6.52V30.75a6.52,6.52,0,0,0-6.52-6.52H43.59a6.52,6.52,0,0,0-6.52,6.52V330.54a6.52,6.52,0,0,0,6.52,6.52H213Zm-33-10.11H47V34.34H353V327H180.05Z" />
  </svg>
);
